{
    "apiErrors": {
        "draft_busy": "Se están redactando demasiadas respuestas en este momento. Inténtalo de nuevo en unos instantes.",
        "special_hours_require_business_hours": "El horario especial necesita un horario comercial. Mantenga el horario con al menos un día abierto, o quite antes las fechas especiales.",
        "special_hours_duplicate_date": "Una fecha especial aparece más de una vez. Deje una sola entrada por fecha.",
        "menu_name_conflict": "Otro menú publicado con el mismo nombre ya existe en una de las localizaciones de este menú. Cambia primero el nombre de uno de los menús.",
        "conversation_assigned_to_agent": "Esta conversación la gestiona Pulse. Únete a la conversación para tomarla.",
        "conversation_already_in_team": "La conversación ya está en este equipo.",
        "team_not_found": "Este equipo ya no existe. Actualiza la página e inténtalo de nuevo.",
        "conversation_assigned_to_another_user": "Esta conversación está asignada a otro agente. Únete a la conversación para tomarla.",
        "billing_surveys_advanced_disabled": "Esta función está disponible en el plan Profesional.",
        "google_authentication_failed": "Imposible integrar",
        "google_access_revoked": "No se pudo integrar",
        "google_auth_code_expired": "El inicio de sesión con Google ha caducado. Inténtalo de nuevo",
        "google_server_error": "Google no está disponible temporalmente. Inténtalo de nuevo más tarde",
        "google_validation_failed": "Google rechazó esta solicitud: {{reasons}}",
        "google_not_found": "La verificación de Google no está disponible para esta localización en este momento",
        "something_wrong": "Algo fue mal",
        "validation": "Algo fue mal",
        "message_too_long": "El texto de la publicación es demasiado largo para una de las plataformas seleccionadas. Acorta el mensaje e inténtalo de nuevo.",
        "duplicate_question_titles": "Los títulos de las preguntas deben ser únicos. Duplicados: {{duplicates}}",
        "forbid": "Acceso no autorizado",
        "unauthorized": "Acceso no autorizado",
        "google_access_revoke_error": "Imposible desconectar la integración",
        "google_publish_reply_error": "No se pudo publicar tu respuesta",
        "google_delete_reply_error": "No se pudo borrar la respuesta a la reseña",
        "review_not_found": "No se pudo responder a la reseña porque ya no existe",
        "google_reply_rejected": "Google no aceptó la solicitud. Inténtalo de nuevo más tarde",
        "review_still_live_on_google": "Esta reseña sigue publicada en Google",
        "google_verification_unavailable": "No se pudo comprobar con Google si la reseña sigue existiendo. Inténtalo de nuevo más tarde",
        "google_reply_unclaimed_location": "Google no acepta respuestas para esta ficha hasta que esté verificada en el Perfil de Empresa de Google",
        "google_my_business_missing_rights": "Faltan permisos - Otorga permisos de 'Gestionar listados' durante el registro con Google para continuar",
        "delete_user_failed_assigned_to_other_companies": "Imborrable. Usuario de varias localizaciones",
        "user_already_exists": "Usuario {{email}} ya existente",
        "user_not_found": "El usuario no existe",
        "invalid_credentials": "Credenciales no válidas",
        "google_email_unverified": "Verifica esta dirección de correo electrónico en tu cuenta de Google y vuelve a intentarlo",
        "invalid_password": "Contraseña no válida",
        "campaign_not_enough_credits": "No tienes suficientes mensajes para hacer esta campaña",
        "cannot_edit_campaign": "Imposible editar campaña",
        "running_campaigns_exists": "No se puede continuar: {{amount}} campaña(s) en progreso",
        "running_coupons_exist": "No se puede continuar: {{amount}} plantilla(s) de cupón activa(s) asignada(s) a esta localización",
        "active_directories_addon_exists": "Cancele primero el complemento Directorios Locales de esta localización",
        "location_country_locked_by_listings": "Cancele el complemento Directorios Locales o desconecte su ficha antes de cambiar el país de esta localización",
        "location_country_required": "Indique el país de la localización",
        "location_country_locked_by_google": "Desconecte la ficha de Google de esta localización antes de cambiar el país",
        "google_listing_country_mismatch": "Esta ficha de Google está en {{listingCountry}}, pero la localización está en {{locationCountry}}. Conecte una ficha del país de la localización",
        "located_in_self_reference": "Una localización no puede estar localizada dentro de sí misma. Elija el negocio dentro del que está",
        "located_in_place_required": "Elija el negocio dentro del que está esta localización o desactive «Localizado dentro de otro negocio»",
        "tracking_tags_medium_invalid": "Use letras minúsculas, dígitos y guiones en utm_medium",
        "tracking_tags_medium_paid": "La analítica contaría este utm_medium como tráfico de pago. Elija otro valor",
        "tracking_tags_campaign_invalid": "Use letras minúsculas, dígitos y guiones en utm_campaign",
        "tracking_tags_campaign_shopping": "La analítica contaría este utm_campaign como tráfico de compras. Elija otro valor",
        "store_code_too_long": "Un código de tienda tiene como máximo 64 caracteres",
        "located_in_place_invalid": "No se ha podido reconocer ese negocio en Google. Búsquelo de nuevo y elíjalo en los resultados",
        "located_in_relation_invalid": "Elija un tipo de relación para el negocio dentro del que está esta localización",
        "pulse_ai_agent_assigned": "No se puede continuar: agente activo en esta localización",
        "campaign_empty": "No hay contactos en el segmento seleccionado",
        "campaign_audience_to_big": "Incapaz de crear campaña superior a 1000 contactos",
        "maximum_daily_messages_reached": "Límite de mensajes diarios alcanzado",
        "over_survey": "Solicitud enviada en los últimos {{delay}} dia(s)",
        "contact_unsubscribed": "Contacto dado de Baja",
        "ticket_managenet_disabled": "Mejore su subscripción para usar esta función",
        "maximum_sms_count_reached": "Mejore su subscripción para enviar más SMS",
        "maximum_emails_count_reached": "Mejore su subscripción para enviar más emails",
        "maximum_companies_count_reached": "Mejore su subscripción para usar esta función",
        "maximum_users_count_reached": "Mejore su subscripción para usar esta función",
        "maximum_templates_count_reached": "Mejore su subscripción para usar esta función",
        "maximum_company_services_count_reached": "Mejore su subscripción para usar esta función",
        "maximum_reply_rules_count_reached": "Mejore su subscripción para usar esta función",
        "review_platforms_disabled": "Mejore su subscripción para usar esta función",
        "IFOOD_AUTHENTICATION_FAILED": "La autenticación de iFood falló",
        "IFOOD_REVIEW_ALREADY_REPLIED": "Reseña ya respondida",
        "IFOOD_MERCHANT_NOT_REGISTERED": "El acceso de iFood para este comercio no está activo",
        "IFOOD_INTEGRATION_NOT_CONNECTED": "La integración con iFood no está conectada",
        "IFOOD_REVIEW_DISCARDED_OR_MODERATION_PENDING": "La reseña ya está descartada o tiene una moderación pendiente",
        "IFOOD_INVALID_REVIEW_REPLY_LENGTH": "La respuesta tiene un límite mínimo de 10 y un máximo de 300 caracteres",
        "IFOOD_EMPTY_REVIEW": "No puedes responder a la reseña con un comentario vacío",
        "IFOOD_REVIEW_RATING_NOT_REPLYABLE": "Las reseñas de cinco estrellas no admiten respuesta",
        "IFOOD_REVIEW_REPLY_WINDOW_EXPIRED": "iFood deja de aceptar respuestas 5 días después de recibida la reseña",
        "channel_not_connected": "No puedes enviar mensajes a este canal porque no está conectado.",
        "channel_unreachable_contact": "Este contacto no puede recibir mensajes por este canal. Revisa el número de teléfono e inténtalo de nuevo.",
        "ringcentral_not_connected": "La cuenta de RingCentral ya no está conectada. Vuelve a conectarla en Integraciones.",
        "ringcentral_number_not_available": "El número seleccionado no puede enviar SMS desde esta cuenta de RingCentral.",
        "ringcentral_unavailable": "RingCentral no responde. Inténtalo de nuevo en unos minutos.",
        "channel_phone_number_in_use": "Este número de teléfono ya lo usa otro canal.",
        "sms_provider_cannot_change": "No se puede cambiar el proveedor de un canal SMS existente. Crea un canal nuevo.",
        "file_size_too_large": "El tamaño del archivo no debe superar los {{size}} {{metric}}",
        "attachment_type_not_supported": "Este tipo de archivo no se puede enviar por este canal",
        "file_size_too_small": "El tamaño del archivo no debe ser menor a {{size}} {{metric}}",
        "image_dimensions_too_small": "La imagen debe tener al menos {{minWidth}}×{{minHeight}} píxeles",
        "video_duration_out_of_range": "El video debe durar entre {{min}} y {{max}} segundos para las plataformas seleccionadas",
        "VTEX_AUTHENTICATION_FAILED": "La autenticación de VTEX falló",
        "COVERMANAGER_NOT_CONNECTED": "Integración CoverManager no conectada",
        "FACEBOOK_NOT_AUTHENTICATED": "Facebook no está autenticado",
        "FACECBOOK_COMMON_ERROR": "Facebook no está disponible en este momento, inténtalo de nuevo más tarde",
        "WHATSAPP_REGISTRATION_FAILED": "Error en el registro del número de teléfono de WhatsApp. Asegúrese de que el número esté verificado e inténtelo de nuevo.",
        "WHATSAPP_CLOUD_API_NOT_ACCEPTED": "Debe aceptar los Términos de Servicio de la API de WhatsApp Business Cloud antes de conectar.",
        "WHATSAPP_WABA_MISSING": "El registro de WhatsApp no devolvió una cuenta de WhatsApp Business. Vuelva a conectar y complete todos los pasos del registro.",
        "WHATSAPP_NUMBER_NOT_VALID": "El formato del número de teléfono de WhatsApp no es válido.",
        "WHATSAPP_NUMBER_IN_USE": "Este número sigue registrado en una aplicación de WhatsApp. Si es la aplicación WhatsApp Business, vuelve a conectarlo y elige seguir usando la aplicación. Si no, haz una copia de seguridad de tus chats, elimina esa cuenta de WhatsApp, espera unos minutos y vuelve a intentarlo.",
        "Internal error": "Algo fue mal",
        "csv_validation": "Formato de archivo incorrecto",
        "csv_import_phone_invalid": "El número de teléfono debe estar en formato internacional si el país no está especificado",
        "csv_import_country_required": "Indique el país de: {{errors}}",
        "invalid_format": "Formato de archivo incorrecto",
        "request_timeout": "La solicitud ha expirado. Por favor, inténtalo de nuevo",
        "channel_configuration_error": "No se puede enviar el mensaje: Configuración del canal no válida",
        "phoneOrEmailRequired": "Se debe requerir un teléfono o un email",
        "phone_number_required": "Se requiere número de teléfono de contacto",
        "email_required": "Se requiere dirección de correo electrónico de contacto",
        "invalid_email": "La dirección de correo electrónico de contacto no es válida: {{errors}}",
        "videos_not_supported_by_google": "Los videos no son compatibles con Google",
        "google_allow_one_image": "Las publicaciones de Google solo pueden tener 1 imagen",
        "stories_allow_one_media": "Las historias permiten exactamente una imagen o un video",
        "facebook_allow_one_video": "Las publicaciones de Facebook solo pueden tener 1 video",
        "facebook_allow_one_type_of_media": "Las publicaciones de video en Facebook no pueden incluir imágene",
        "tiktok_allow_one_video": "Las publicaciones de TikTok solo pueden tener 1 video",
        "tiktok_no_mixed_media": "Las publicaciones de TikTok no pueden mezclar fotos y videos",
        "tiktok_max_photos_exceeded": "Las publicaciones de fotos de TikTok admiten un máximo de 35 imágenes",
        "x_allow_one_video": "Las publicaciones de X solo pueden tener 1 video",
        "x_no_mixed_media": "Las publicaciones de X no pueden mezclar fotos y videos",
        "x_max_photos_exceeded": "Las publicaciones de X admiten un máximo de 4 imágenes",
        "profile_connected_to_another_location": "Este perfil en línea ya está conectado a otra localización. Elija un perfil diferente o desconéctelo de la localización actual antes de continuar",
        "brand_locations_required": "La marca requiere al menos una localización",
        "brand_requires_location": "Esta es la única localización de la marca. Asigna primero otra localización a la marca",
        "delete_brand_failed_assigned_to_channels": "No se puede eliminar. Marca asignada a canales activos",
        "delete_brand_failed_assigned_to_agent": "No se puede eliminar. Esta marca está asignada a agente activo",
        "delete_brand_failed_assigned_to_survey_templates": "Imborrable. Marca vinculada a plantillas de encuestas existentes",
        "conversations_export_in_progress": "Exportación en curso. Espera nuestro correo",
        "export_in_progress": "Exportación en curso. Espera nuestro correo",
        "invalidWhatsAppTemplate": "La plantilla contiene variables no compatibles",
        "an_unexpected_error_occurred": "Ocurrió un error inesperado. Por favor, inténtalo de nuevo",
        "agent_sole_knowledge_owner": "No se puede eliminar el agente. Hay contenido de la base de conocimientos asignado solo a este agente. Reasígnalo o elimínalo primero.",
        "team_owns_channels": "Este equipo tiene canales asignados. Primero reasigna sus canales a otro equipo.",
        "team_owns_channels_requires_messaging": "No se puede quitar el acceso a mensajería a un equipo con canales asignados. Primero reasigna sus canales.",
        "channel_team_required": "Selecciona un equipo para este canal.",
        "live_chat_notification_channel_out_of_scope": "El canal de seguimiento debe pertenecer a la marca del chat en vivo, o a ninguna localización ni marca.",
        "live_chat_brand_required": "Elija la marca a la que pertenece este chat en vivo.",
        "live_chat_phone_or_email_required": "Marque el correo electrónico o el teléfono como campo obligatorio.",
        "live_chat_follow_up_channel_required": "Elija un canal para contactar con los visitantes que se fueron.",
        "live_chat_follow_up_channel_not_collected": "El canal de seguimiento necesita un dato de contacto que el chat no exige. Elija otro canal.",
        "live_chat_locations_out_of_brand": "Todas las localizaciones seleccionadas deben pertenecer a la marca elegida.",
        "live_chat_texts_required": "Escriba el mensaje de bienvenida.",
        "live_chat_welcome_name_fallback_required": "En el mensaje de bienvenida {{errors}}, añada a cada [name] un texto alternativo para los visitantes sin sesión iniciada, como [name|cliente].",
        "live_chat_time_zone_invalid": "La zona horaria del horario no es compatible. Póngase en contacto con el soporte.",
        "live_chat_hours_invalid": "El horario comercial debe indicarse con horas como 09:00.",
        "live_chat_location_out_of_scope": "Este chat en vivo no atiende la localización seleccionada.",
        "channel_team_requires_messaging": "Este equipo no tiene acceso a mensajería. Elige un equipo con permisos de mensajería.",
        "page_already_connected": "Esta página ya está conectada a otro canal.",
        "page_cannot_be_changed": "La página de un canal existente no se puede cambiar. Crea un canal nuevo en su lugar.",
        "subscription_required": "Se requiere una suscripción activa: suscríbase para continuar",
        "minimum_locations_required": "El plan Pluspoint comienza en {{minimumLocations}} localizaciones",
        "plan_not_available_for_new_subscriptions": "Este plan ya no está disponible para nuevas suscripciones",
        "custom_pricing_requires_support": "Su cuenta tiene precios personalizados. Contacte con soporte para cambiar su plan o período de facturación.",
        "billing_catalog_ambiguous": "La facturación no está disponible temporalmente para este plan. Contacte con soporte.",
        "directories_addon_requires_subscription": "Directorios Locales requiere una suscripción activa",
        "directories_addon_included_in_plan": "La publicación en Directorios Locales ya está incluida en su plan",
        "directories_addon_already_enrolled": "Esta localización ya tiene Directorios Locales",
        "directories_addon_not_enrolled": "Esta localización no tiene Directorios Locales",
        "directories_addon_subscription_required": "Elija a qué suscripción facturar Directorios Locales",
        "directories_addon_minimum_term": "Directorios Locales se puede cancelar después de su período mínimo de 3 meses",
        "directories_addon_country_not_supported": "La publicación en Directorios Locales aún no está disponible en el país de esta localización",
        "locations_below_directories_enrollments": "{{enrolledLocationsCount}} localización(es) tienen Directorios Locales: cancele esos complementos antes de reducir localizaciones",
        "billing_surveys_disabled": "Las encuestas no están incluidas en su plan actual",
        "billing_campaigns_disabled": "Las campañas no están incluidas en su plan actual",
        "billing_coupons_disabled": "Los cupones no están incluidos en su plan actual",
        "billing_plan_not_found": "Plan de facturación no encontrado",
        "billing_stripe_subscription_not_found": "Suscripción no encontrada",
        "billing_stripe_subscription_email_is_empty": "La suscripción no tiene correo electrónico registrado",
        "subscription_expired": "Su suscripción ha caducado: renuévela para continuar",
        "maximum_custom_domains_reached": "Ha alcanzado el número máximo de dominios personalizados de su plan",
        "billing_listing_directories_disabled": "Los directorios de listados no están disponibles en su plan actual",
        "email_template_name_taken": "Ya existe una plantilla con este nombre.",
        "email_template_not_found": "Plantilla de email no encontrada. Puede haber sido eliminada.",
        "email_template_required": "Las campañas de email de tipo mensaje requieren una plantilla de la biblioteca.",
        "email_template_archived": "Esta plantilla está archivada y no se puede seleccionar. Desarchívala primero en la biblioteca.",
        "email_template_read_only": "Los diseños iniciales son de solo lectura. Duplica la plantilla para editarla.",
        "email_template_invalid_design": "El diseño de la plantilla no es válido. Revisa el contenido de los bloques, las URL y la longitud de los campos.",
        "email_template_dynamic_link_required": "Las campañas de encuesta y cupón necesitan una plantilla con un botón de enlace dinámico.",
        "email_template_dynamic_link_not_supported": "Las plantillas con botón de enlace dinámico solo pueden usarse en campañas de encuesta o cupón.",
        "email_template_link_type_mismatch": "Los botones de enlace de esta plantilla apuntan a otro tipo de destino, por lo que no puede usarse en esta campaña.",
        "email_template_links_locked_while_in_use": "Los botones de enlace dinámico de esta plantilla se usan en campañas o automatizaciones. Elimina esas referencias o duplica la plantilla.",
        "whatsapp_template_required": "Las campañas de WhatsApp requieren una plantilla de mensaje.",
        "email_template_in_use": "Esta plantilla se usa en campañas o automatizaciones y no se puede eliminar. Elimina esas referencias primero.",
        "whatsapp_template_delete_blocked": "Esta plantilla se usa en campañas o automatizaciones y no se puede eliminar. Elimina esas referencias o archívala en su lugar.",
        "whatsapp_template_in_use": "Esta plantilla se usa en campañas programadas o en curso, o en automatizaciones activas. Duplícala y edita la copia, o elimina esas referencias primero.",
        "whatsapp_template_copy_code_requires_coupon": "El botón de copiar código de esta plantilla necesita una campaña de cupones que proporcione el código.",
        "whatsapp_template_header_media_missing": "El encabezado de imagen de esta plantilla aún no tiene imagen. Completa su configuración en la Biblioteca primero.",
        "whatsapp_template_not_found": "Plantilla de WhatsApp no encontrada. Puede haber sido eliminada.",
        "whatsapp_template_name_taken": "Ya existe una plantilla con este nombre e idioma.",
        "whatsapp_template_invalid_content": "El contenido de la plantilla no es válido. Revisa las variables, los botones y la longitud de los campos.",
        "whatsapp_template_not_editable": "Esta plantilla no se puede editar en su estado actual.",
        "whatsapp_template_unavailable": "Esta plantilla de WhatsApp no está disponible actualmente — puede estar pausada, deshabilitada o le faltan ajustes obligatorios.",
        "whatsapp_template_not_approved": "Solo las plantillas de WhatsApp aprobadas pueden usarse en campañas.",
        "whatsapp_template_not_mapped": "La plantilla tiene variables sin asignar. Termina su configuración en la biblioteca primero.",
        "whatsapp_template_archived": "Esta plantilla está archivada y no se puede seleccionar. Desarchívala primero en la biblioteca.",
        "whatsapp_template_waba_mismatch": "Esta plantilla pertenece a una cuenta de WhatsApp Business distinta a la del canal seleccionado.",
        "whatsapp_template_disconnected": "La cuenta de WhatsApp Business de esta plantilla está desconectada.",
        "whatsapp_template_link_required": "Las campañas de encuesta y cupón necesitan una plantilla con un botón de enlace dinámico.",
        "whatsapp_template_link_not_supported": "Esta plantilla tiene un botón de enlace dinámico, por lo que solo puede usarse en campañas de encuestas o cupones.",
        "whatsapp_template_link_type_mismatch": "El botón de enlace de esta plantilla apunta a un tipo de destino distinto del que necesita este envío.",
        "whatsapp_template_links_locked_while_in_use": "No se puede añadir ni quitar el botón de enlace mientras haya campañas o automatizaciones usando esta plantilla. Elimina esas referencias o duplica la plantilla.",
        "automation_invalid_trigger": "Una automatización necesita exactamente un disparador.",
        "automation_trigger_no_events": "Elige al menos un evento disparador.",
        "automation_no_action": "Añade al menos un mensaje o encuesta a la que lleve el disparador.",
        "automation_wait_invalid": "Un paso de espera necesita una duración mayor que cero.",
        "automation_survey_missing": "Elige una plantilla de encuesta para el paso de encuesta.",
        "automation_message_empty": "Añade contenido al paso de mensaje.",
        "automation_condition_incomplete": "A un filtro le falta un campo o un valor.",
        "automation_too_large": "Una automatización no puede tener más de 100 pasos.",
        "automation_unreachable_node": "Cada paso debe estar conectado al disparador.",
        "automation_has_cycle": "Una automatización no puede contener bucles.",
        "automation_invalid_edge": "Una conexión apunta a un paso inexistente.",
        "automation_branch_edge_invalid": "Las rutas de una bifurcación deben etiquetarse como sí o no.",
        "automation_branch_duplicate": "Una bifurcación puede tener como máximo una ruta de sí y una de no.",
        "automation_multiple_next": "Un paso puede tener como máximo un paso siguiente.",
        "automation_unexpected_branch_key": "Solo las bifurcaciones pueden tener rutas etiquetadas.",
        "automation_invalid_node_id": "A un paso de la automatización le falta un id.",
        "automation_duplicate_node_id": "Los pasos de la automatización deben tener ids únicos.",
        "automation_node_channel_required": "Elige un canal para cada paso de mensaje y encuesta.",
        "automation_node_channel_invalid": "Un paso usa un canal no válido o no disponible.",
        "automation_node_survey_invalid": "Un paso usa una plantilla de encuesta no válida.",
        "automation_node_coupon_invalid": "Un paso usa una plantilla de cupón no válida.",
        "automation_channel_type_unsupported": "Este tipo de canal no es compatible con las automatizaciones.",
        "automation_segment_in_use": "Este segmento se usa en una automatización. Quítalo de la automatización antes de eliminarlo.",
        "facebook_profile_id_missing": "Este enlace de Facebook no incluye el id del perfil. Copia la dirección completa de la página, incluida la parte ?id=",
        "google_place_id_missing": "Este enlace de Google no contiene un id de lugar",
        "profile_url_invalid": "Introduce una dirección web completa que empiece por http:// o https://",
        "social_platform_managed_as_link": "Esta red social se gestiona desde los enlaces sociales de la localización, no como perfil de reseñas",
        "ubereats_store_url_invalid": "Introduce la dirección de una página de local de Uber Eats, por ejemplo https://www.ubereats.com/store/nombre/id",
        "bbb_profile_url_invalid": "Introduce la dirección del perfil de empresa en BBB, por ejemplo https://www.bbb.org/us/tx/san-antonio/profile/categoria/nombre-0825-1000132336",
        "thefork_restaurant_url_invalid": "Introduce la dirección de la página de un restaurante en TheFork, por ejemplo https://www.thefork.com/restaurant/nombre-r123",
        "booking_profile_url_invalid": "Introduzca la dirección de una página de hotel de Booking.com, por ejemplo https://www.booking.com/hotel/es/nombre.html",
        "expedia_group_profile_already_connected": "Esta localización ya tiene Expedia / Hotels.com. Para cambiar al otro sitio, elimínelo y añada la nueva dirección.",
        "expedia_group_profile_url_invalid": "Introduzca la dirección de la página del alojamiento en Expedia o Hotels.com, por ejemplo https://www.hotels.com/ho123456",
        "booking_extranet_url_invalid": "Introduzca un enlace de la Extranet de Booking.com de esta propiedad o su ID numérico.",
        "media_dimensions_too_large": "El archivo no debe superar {{maxWidth}}×{{maxHeight}} píxeles para las plataformas seleccionadas",
        "video_invalid": "Este archivo no es un video válido",
        "video_too_long": "El video supera la duración máxima para las plataformas seleccionadas",
        "video_too_short": "El video es más corto que el mínimo de 3 segundos",
        "video_too_large": "El video supera el tamaño máximo de subida",
        "video_too_small": "El archivo de video está vacío o es demasiado pequeño para ser un video válido",
        "video_format_unsupported": "Solo se admiten archivos de video MP4",
        "video_processing_failed": "No se pudo procesar el video. Intenta exportarlo de nuevo como MP4.",
        "video_codec_unsupported": "El video debe estar codificado en H.264 o HEVC — expórtalo de nuevo como MP4 estándar",
        "video_audio_unsupported": "El audio del video debe ser AAC — expórtalo de nuevo como MP4 estándar",
        "video_too_large_for_platform": "Este video es demasiado grande para una de las plataformas seleccionadas — consulta los avisos de arriba",
        "video_too_small_for_platform": "Este video no alcanza el tamaño mínimo de una de las plataformas seleccionadas",
        "video_too_long_for_platform": "Este video es demasiado largo para una de las plataformas seleccionadas — consulta los avisos de arriba",
        "video_too_short_for_platform": "Este video dura menos del mínimo de 3 segundos",
        "video_too_wide_for_platform": "La resolución de este video es demasiado alta para una de las plataformas seleccionadas — consulta los avisos de arriba",
        "video_not_supported_by_platform": "Una de las plataformas seleccionadas no admite publicaciones de video",
        "video_link_untrusted": "Este video debe subirse a través de Pluspoint antes de poder usarse",
        "video_external_not_supported_by_tiktok": "TikTok solo puede publicar videos subidos a través de Pluspoint — sube el archivo o quita TikTok",
        "tiktok_settings_required": "Faltan los ajustes de TikTok. Abre la publicación y elígelos.",
        "tiktok_disclosure_incomplete": "Debes indicar si tu contenido te promociona a ti, a un tercero o a ambos.",
        "video_too_long_for_creator": "El video es más largo de lo que permite la cuenta de TikTok conectada.",
        "tiktok_privacy_unavailable": "La opción de privacidad que elegiste ya no está disponible en la cuenta de TikTok conectada. Reintenta cuando la cuenta vuelva a ofrecerla, o programa una publicación nueva con otra audiencia.",
        "tiktok_branded_private": "El contenido de marca no se puede publicar como Solo yo.",
        "tiktok_cannot_post_now": "TikTok no acepta publicaciones de esta cuenta en este momento. Inténtalo de nuevo más tarde.",
        "tiktok_unaudited": "La aplicación de TikTok de Pluspoint aún no está aprobada para publicaciones públicas.",
        "tiktok_account_not_resolved": "Esta localización no indica qué cuenta de TikTok publica para ella. Elige una en el perfil de la localización.",
        "tiktok_auth_removed": "La cuenta de TikTok se desconectó. Vuelve a conectarla y después inténtalo de nuevo.",
        "tiktok_media_pull_failed": "TikTok no pudo descargar el contenido. Inténtalo de nuevo.",
        "tiktok_media_rejected": "TikTok rechazó el contenido. Revisa el formato, la resolución y la duración, y después programa una publicación nueva.",
        "tiktok_publish_cancelled": "La publicación se canceló en TikTok.",
        "video_too_wide": "La resolución de este video supera la de cualquier plataforma admitida (máx. 4096 px en el lado más largo)",
        "review_reply_draft_unusable": "Pulse AI devolvió un borrador con marcadores sin rellenar. Vuelva a intentar Escribir respuesta.",
        "recovery_form_unresolved": "El formulario de recuperación no está disponible para esta reseña. Quite su marcador de la respuesta.",
        "description_contains_url": "No se permiten enlaces en las descripciones del negocio.",
        "special_hours_times_required": "Una fecha especial abierta necesita su horario.",
        "special_hours_times_not_allowed": "Una fecha especial cerrada no puede tener horario.",
        "special_hours_invalid_time_range": "Un rango horario debe terminar después de empezar.",
        "location_not_found": "Esta localización ya no existe.",
        "concurrency_conflict": "Otra persona modificó o eliminó esta localización al mismo tiempo. Vuelva a abrirla e inténtelo de nuevo.",
        "bulk_update_conflict": "Otra persona modificó una de estas localizaciones mientras se aplicaba la edición. No se guardó nada. Vuelva a aplicar la edición.",
        "email_domain_taken": "Este dominio ya está registrado. Contacta con soporte si es tuyo.",
        "email_domain_suspended": "El envío desde este dominio está suspendido. Contacta con soporte.",
        "email_domain_public": "Es un proveedor de correo público. Usa un dominio propio de tu negocio.",
        "email_domain_reserved": "Los dominios de Pluspoint no se pueden conectar.",
        "email_domain_invalid": "Introduce un dominio válido, por ejemplo acme.com.",
        "email_domain_return_path_invalid": "El subdominio Return-Path solo puede contener letras, dígitos y guiones.",
        "hosted_email_capacity": "Ahora mismo no se puede conectar el correo en tu propio dominio. Contacta con soporte.",
        "email_domain_return_path_fixed": "Este dominio ya tiene un subdominio Return-Path. Desactiva el subdominio personalizado para reutilizarlo.",
        "email_address_invalid": "Introduce una dirección de correo válida de tu propio dominio.",
        "email_channel_address_locked": "La dirección de este canal de correo no se puede cambiar.",
        "email_channel_hosted_create": "Los canales de correo con dominio propio se crean desde la configuración del dominio.",
        "email_domain_in_use": "Elimina primero los canales de este dominio.",
        "hosted_email_unavailable": "El correo con dominio propio no está disponible en este entorno.",
        "channel_not_ready": "Este canal todavía espera a que se verifique su dominio.",
        "channel_throttled": "El servicio de envío está saturado. Inténtalo de nuevo en un minuto.",
        "email_domain_check_failed": "No se pudieron comprobar los registros en este momento. Inténtalo de nuevo en un minuto.",
        "invalid_website": "Introduce un dominio, con o sin ruta, como ayuda.ejemplo.com o ejemplo.com/ayuda",
        "document_too_many_pages": "El archivo no debe superar las {{pages}} páginas",
        "document_too_many_rows": "Cada hoja no debe superar las {{rows}} filas",
        "knowledge_base_document_limit": "Estos agentes ya tienen el número máximo de documentos: {{errors}}",
        "knowledge_base_website_limit": "Estos agentes ya tienen el número máximo de sitios web: {{errors}}",
        "knowledge_base_conflict": "Otra persona modificó este contenido al mismo tiempo. No se guardó nada. Vuelva a intentarlo.",
        "file_required": "Selecciona un archivo",
        "no_active_account": "Ya no tiene acceso a ninguna cuenta de Pluspoint. Pida al propietario de la cuenta que vuelva a invitarle.",
        "invalid_sex": "El sexo debe ser Femenino o Masculino: {{errors}}",
        "invalid_date_of_birth": "La fecha de nacimiento debe ser AAAA-MM-DD, o MM-DD sin el año, desde 1900 y no futura: {{errors}}",
        "invalid_language": "El idioma debe ser un código de idioma como en o pt: {{errors}}",
        "birth_year_required": "Una fecha de nacimiento introducida a mano necesita el año",
        "automation_trigger_date_invalid": "Elige una fecha y hora válidas para el disparador.",
        "automation_condition_invalid": "Un filtro tiene un valor que no puede usar.",
        "automation_trigger_date_passed": "Esta fecha única ya pasó.",
        "automation_condition_event_on_date": "Los filtros de evento no se aplican a una automatización que empieza en una fecha."
    },
    "AnalyticsConversion": {
        "conversion": "Conversión",
        "sentSurveys": "Enviar encuesta",
        "responsesReceived": "Respuestas recibidas",
        "reviewsReceived": "Reseñas recibidas",
        "openedSurveys": "Encuestas abiertas",
        "responses": "Respuestas",
        "proceededToReviewSite": "Continuaron a sitios de reseñas",
        "responseRate": "Tasa de respuesta",
        "reviewRate": "Tasa de reseña",
        "reviewRateTooltip": "La tasa de reseñas incluye todas las reseñas de las ubicaciones seleccionadas, no solo las que provienen de encuestas. La tasa real de reseñas generadas por encuestas puede diferir.",
        "fromPreviousPeriod": "Periodos previos",
        "reviewsLifecycle": "Embudo de conversión",
        "overall": "General",
        "surveyInvitations": "Invitaciones a encuestas",
        "qrCodes": "Códigos QR",
        "conversionTrend": "Tendencia de conversión"
    },
    "AnalyticsKeywords": {
        "tableTitle": "Analíticas palabras clave",
        "keyword": "Palabra clave",
        "avgRating": "Rating",
        "numberOfReviews": "Número de reseñas",
        "sentiment": "Sentimiento",
        "positiveKeywords": "Palabras clave positivas",
        "negativeKeywords": "Palabras clave negativas"
    },
    "AnalyticsOperationalInsights": {
        "topStrengths": "Principales fortalezas",
        "topStrengthsSubtitle": "Las categorías en las que los clientes más frecuentemente dejan reseñas de 5 estrellas.",
        "topIssues": "Principales problemas",
        "topIssuesSubtitle": "Las categorías mencionadas con más frecuencia en reseñas con valoraciones bajas.",
        "incidents": "Incidencias",
        "incidentsSubtitle": "El porcentaje de reseñas negativas en cada categoría. Los valores más altos indican una mayor concentración de insatisfacción del cliente.",
        "sentimentScore": "Puntuación de sentimiento",
        "sentimentScoreSubtitle": "El equilibrio general entre el feedback positivo y negativo por categoría. Las puntuaciones positivas indican fortalezas; las negativas indican áreas problemáticas."
    },
    "AnalyticsReviews": {
        "averageRating": "Rating medio",
        "reviews": "Reseña",
        "totalReviews": "Reseñas totales",
        "totalRepliesPercentage": "Tasa de respuesta",
        "totalResponses": "Total respuestas",
        "reviewsRatingDistribution": "Distribución rating medio",
        "responsesRatingDistribution": "Distribución rating de respuestas",
        "stars1": "1 star",
        "stars2": "2 stars",
        "stars3": "3 stars",
        "stars4": "4 stars",
        "stars5": "5 stars",
        "ratingsTimeline": "Historial de valoraciones",
        "ratingsTimelineTooltip": "El historial de valoraciones muestra valores históricos estimados. Las valoraciones reales en las plataformas pueden diferir.",
        "reviewIndex": "Índice de reseñas",
        "reviewIndexTooltip": "Una puntuación sobre 100 de cómo valoran los clientes sus localizaciones en las plataformas de reseñas, en la que las reseñas recientes pesan más. Aparece cuando hay suficientes reseñas valoradas recientes.",
        "sentimentTrend": "Tendencia",
        "positiveReviews": "Reseña positiva",
        "positiveResponses": "Respuesta positiva",
        "negativeReviews": "Reseña negativa",
        "negativeResponses": "Respuesta negativa",
        "reviewSitesTrend": "Tendencia plataforma",
        "fromPreviousPeriod": "Periodos previos",
        "others": "Otros",
        "nps": "Net Promoter Score",
        "reviewsByDay": "Reseñas por día",
        "reviewsByDaypart": "Reseñas por franja horaria",
        "sunday": "Dom",
        "monday": "Lun",
        "tuesday": "Mar",
        "wednesday": "Mié",
        "thursday": "Jue",
        "friday": "Vie",
        "saturday": "Sáb",
        "morning": "Mañana",
        "afternoon": "Tarde",
        "evening": "Noche"
    },
    "AnalyticsConversations": {
        "responseRate": "Tasa de respuesta",
        "responseTime": "Tiempo de respuesta (horas)",
        "resolutionTime": "Tiempo de Resolución (horas)",
        "resolutionRate": "Tasa de resolución",
        "newConversations": "Nuevas conversaciones",
        "resolvedConversations": "Conversaciones resueltas",
        "openConversations": "Conversaciones abiertas",
        "unassignedConversations": "Conversaciones no asignadas",
        "conversationsTrend": "Tendencia",
        "channelsBreakdown": "Distribución canales",
        "totalConversations": "Total de conversaciones",
        "messagesPerConversation": "Mensajes por conversación",
        "conversationsHandled": "Conversaciones atendidas",
        "averageHandleTime": "Tiempo medio de atención (horas)"
    },
    "AnalyticsSocialPosts": {
        "posts": "Publicaciones",
        "followers": "Seguidores",
        "reach28": "Alcance a 28 días",
        "rateByReach": "Tasa de interacción por alcance",
        "rateByFollowers": "Tasa de interacción por seguidores",
        "reach": "Alcance",
        "likes": "Me gusta",
        "comments": "Comentarios",
        "shares": "Compartidos",
        "engagements": "Interacciones",
        "clicks": "Clics",
        "saves": "Guardados",
        "percentagePoints": "{{value}} p. p."
    },
    "AnalyticsPresence": {
        "searchAppearances": "Apariciones en búsqueda",
        "views": "Vistas",
        "calls": "Llamadas",
        "directions": "Direcciones",
        "websiteClicks": "Clics en el sitio web",
        "devicesBreakdown": "Desglose de dispositivos",
        "googleSearchMobile": "Google Search - Móvil",
        "googleMapsMobile": "Google Maps - Móvil",
        "googleSearchDesktop": "Google Search - Escritorio",
        "googleMapsDesktop": "Google Maps - Escritorio",
        "searchKeywords": "Palabras clave de búsqueda",
        "totalViews": "Vistas totales"
    },
    "AnalyticsVisibility": {
        "pageTitle": "Controla tu visibilidad en las búsquedas locales",
        "pageSubtitle": "Descubre cómo se posiciona cada localización en los resultados de Google Maps en una cuadrícula de puntos a su alrededor. Compara localizaciones, sigue los cambios de posición a lo largo del tiempo, ejecuta escaneos cuando quieras y abre una localización para ver su mapa punto por punto y sus competidores.",
        "reportTitle": "Informe de visibilidad",
        "vs90DaysAgo": "frente a hace 90 días",
        "loadError": "No se pudieron cargar los datos de visibilidad. Inténtalo de nuevo.",
        "averageVisibility": "Visibilidad media",
        "locationsInTop3": "Localizaciones en el top 3 local",
        "averageMapRank": "Posición media en el mapa",
        "location": "Localización",
        "visibility": "Visibilidad",
        "avgRank": "Posición media",
        "rankTrend": "Tendencia de posición",
        "rankTrendHint": "Posición media en el mapa por mes durante los últimos 12 meses, del más antiguo al más reciente. Los meses sin escaneos aparecen como huecos.",
        "delta90d": "Cambio de posición (90 d)",
        "delta90dHint": "Variación de la posición media en el mapa respecto al escaneo más cercano a hace 90 días. Verde — subió hacia el n.º 1, rojo — bajó.",
        "inTop3": "En el top 3",
        "inTop3Hint": "Porcentaje de puntos escaneados donde este negocio apareció en el top 3 local en el último escaneo.",
        "avgMapRank": "Posición media en el mapa",
        "top3Points": "Puntos en el top 3",
        "trackedKeywords": "Palabras clave monitorizadas",
        "whoWinsHere": "Quién gana aquí",
        "business": "Negocio",
        "rating": "Valoración",
        "you": "tú",
        "runNewScan": "Ejecutar nuevo escaneo",
        "printReport": "Imprimir informe",
        "scanInProgress": "Escaneo en curso",
        "scanDate": "Fecha del escaneo",
        "googleProfile": "Perfil de Google",
        "address": "Dirección",
        "phone": "Teléfono",
        "website": "Sitio web",
        "mapRankTitle": "Posición en el mapa — {{keyword}}",
        "gridSpacing": "separación de {{km}} km",
        "top3": "Top 3",
        "fourToTen": "4–10",
        "elevenToTwenty": "11–20",
        "notInTop20": "Fuera del top 20",
        "noDataYet": "Aún no hay resultados: configura el rastreo de una localización para ejecutar su primer escaneo",
        "noCoordinates": "Completa la dirección para habilitar el escaneo",
        "rescanConflict": "Ya hay un escaneo en curso para esta localización",
        "gridSettings": "Configuración de la cuadrícula",
        "gridSizeLabel": "Tamaño de la cuadrícula",
        "gridSpacingLabel": "Distancia entre puntos",
        "spacingKm": "{{km}} km",
        "addKeywordLabel": "Añadir palabra clave",
        "keywordsRequired": "Añade al menos una palabra clave",
        "excludePinsHint": "Haz clic en un punto para dejar de rastrearlo; haz clic en un punto excluido para restaurarlo.",
        "keepOnePin": "Al menos un punto debe seguir rastreándose",
        "settingsApplyNote": "Los cambios se aplican a partir del próximo escaneo.",
        "settingsSaved": "Configuración de visibilidad guardada",
        "settingsSavedScanStarted": "Configuración guardada: primer escaneo iniciado",
        "autoScan": "Escaneo mensual",
        "autoScanHint": "Al activarlo, esta localización se vuelve a escanear automáticamente cada mes.",
        "autoScanConfigureFirst": "Configura primero el rastreo de esta localización",
        "viewReports": "Ver informes",
        "runScan": "Ejecutar escaneo",
        "scanStarted": "Escaneo iniciado",
        "configure": "Configurar",
        "reviews": "Reseñas",
        "reviewsHint": "Total de reseñas de Google; el valor entre paréntesis es el cambio mensual, estimado a partir de la variación entre los dos últimos escaneos.",
        "categories": "Categorías",
        "googleMapsLink": "Perfil",
        "openOnGoogleMaps": "Abrir en Google Maps",
        "competitorPinHint": "★ — ubicación de este competidor"
    },
    "alertMessages": {
        "popupBlocked": "Permite las ventanas emergentes para abrir el formulario de denuncia de Google",
        "createSuccess": "Creado exitosamente",
        "createFail": "No se pudo crear",
        "editSuccess": "Editado exitosamente",
        "editFail": "No se pudo editar",
        "deleteSuccess": "Eliminado exitosamente",
        "deleteFail": "No se pudo borrar",
        "updateSuccess": "Actualizado exitosamente",
        "updateFail": "No se pudo actualizar",
        "retrySuccess": "Reintento programado",
        "retryFail": "No se pudo programar el reintento",
        "downloadFail": "No se pudo descargar",
        "printFail": "No se pudo imprimir",
        "sendSuccess": "Enviado exitosamente",
        "conversationCreated": "Conversación creada",
        "sendFail": "No se pudo enviar",
        "importSuccess": "Importado correctamente",
        "importFail": "No se pudo importar",
        "importPartial": "Importadas {{imported}} localizaciones, omitidas {{skipped}}",
        "cancelSuccess": "Cancelado exitosamente",
        "cancelFail": "No se ha podido cancelar",
        "uploadSuccess": "Subida exitosa",
        "uploadFail": "No se pudo subir",
        "connectIntegrationSuccess": "La integración se ha conectado correctamente",
        "connectIntegrationFail": "No se pudo conectar la integración",
        "ifoodConnectRequestSent": "Se ha enviado la solicitud de conexión con iFood. La integración se activará cuando iFood conceda el acceso",
        "disconnectIntegrationSuccess": "La integración ha sido cancelada",
        "disconnectIntegrationFail": "No se pudo cancelar la integración",
        "tooManyFiles": " Puedes subir un máximo de {{limit}} archivos",
        "loadFail": "No se pudo cargar"
    },
    "buttons": {
        "moveConversation": "Mover conversación",
        "cancel": "Cancelar",
        "close": "Cerrar",
        "discard": "Descartar",
        "clearFilters": "Borrar filtros",
        "copy": "Copiar",
        "open": "Abrir",
        "delete": "Borrar",
        "edit": "Editar",
        "create": "Crear",
        "revoke": "Revocar",
        "save": "Guardar",
        "merge": "Fusionar",
        "mergeContacts": "Fusionar contactos",
        "saveChanges": "Guardar Cambios",
        "filters": "Filtro",
        "applyFilters": "Filtrar",
        "addLocation": "Agregar Localización",
        "addLocationManually": "Agregar Localización manualmente",
        "sendMessage": "Enviar Mensaje",
        "reopen": "Reabrir",
        "resolve": "Resolver",
        "enable": "Activar",
        "pause": "Pausar",
        "continue": "Continuar",
        "back": "Atrás",
        "done": "Hecho",
        "cheduleCampaign": "Programar Campaña",
        "getCode": "Obtener Código",
        "reply": "Responder",
        "publish": "Publicar",
        "connect": "Conectar",
        "disable": "Desactivar",
        "disconnect": "Desconectar",
        "reconnect": "Reconectar",
        "sendSurveys": "Enviar Encuesta",
        "replaceCSV": "Reemplazar Archivo CSV",
        "uploadCSVFile": "Subir Archivo CSV",
        "addChannel": "Añadir Nuevo Canal",
        "importFromGoogle": "Importar de Google",
        "upgradePlan": "Mejorar Plan",
        "managePlan": "Gestionar Plan",
        "changePlan": "Cambiar plan",
        "talkToSales": "Solicita una demo",
        "addUser": "Añadir Usuario",
        "addRule": "Añadir Nueva Auto-respuesta",
        "createCampaign": "Crear Campaña",
        "import": "Importar",
        "contact": "ASISTENCIA",
        "setUpSurveys": "Configurar Encuestas",
        "viewResponses": "Ver Respuestas de Encuestas",
        "newTicket": "Nuevo ticket",
        "viewTicket": "Ver Ticket",
        "sendLink": "Enviar Link",
        "manageMicrosites": "Gestionar Micro-sites",
        "seeSurveyResponse": "Ver Respuestas de Encuesta",
        "resolveComplaints": "Resolver Quejas",
        "replyToReviews": "Respuesta a Reseñas",
        "download": "Descargar",
        "print": "Imprimir",
        "viewReviews": "Ver Reseñas",
        "logIn": "Acceso",
        "createNewMicrosite": "Crear Nuevo Micrositio",
        "replace": "Remplazar",
        "upload": "Subir",
        "add": "Añadir",
        "localization": "Localización",
        "addLanguage": "Añadir Idioma",
        "addCategory": "Añadir categoría",
        "addManually": "Añadir Manualmente",
        "connectAnotherAccount": "Conectar Otra Cuenta",
        "complete": "Completo",
        "addTemplate": "Añadir Plantilla de Respuesta",
        "changePassword": "Cambiar Contraseña",
        "signupButton": "Crear Cuenta",
        "addSurvey": "Crear Nueva Encuesta",
        "createQrCode": "Crear código QR",
        "copyCode": "Copiar Código",
        "replaceSecret": "Reemplazar secreto",
        "generateSecret": "Generar secreto",
        "copyLink": "Copiar enlace",
        "preview": "Previa",
        "exportAsCSV": "Exportar como CSV",
        "exportAsExcel": "Exportar como Excel",
        "logout": "Cerrar Sesión",
        "deleteSite": "Borrar Micrositio",
        "configure": "Configurar",
        "documentation": "Documentación",
        "viewMore": "Ver más",
        "confirm": "Confirmar",
        "createNewPost": "Crear nueva publicación",
        "manage": "Administrar",
        "connectProfile": "Conectar Perfil",
        "viewStatus": "Ver Estado",
        "createNewProfile": "Crear Nuevo Perfil",
        "manageProfile": "Administrar Perfil",
        "publishProfile": "Publicar Perfil",
        "schedulePost": "Programar publicación",
        "updateLocations": "Actualizar localizaciones",
        "validate": "Validar",
        "bulkUpdateCSV": "Importar (CSV)",
        "bulkEdit": "Edición masiva",
        "selectAll": "Seleccionar todo",
        "deselectAll": "Deseleccionar todo",
        "send": "Enviar",
        "addNewTemplate": "Añadir nueva plantilla",
        "export": "Exportar",
        "startSync": "Iniciar sincronización",
        "syncing": "Sincronizando..",
        "importing": "Importando..",
        "addNewDate": "Añadir nueva fecha",
        "report": "Denunciar",
        "undoReport": "Deshacer denuncia",
        "viewOnGoogle": "Ver en Google",
        "connectWithMeta": "Conectar Meta Business",
        "saveDraft": "Guardar borrador",
        "hideAllNotifications": "Ocultar todas las notificaciones",
        "hide": "Ocultar",
        "markAsReplied": "Marcar como respondido",
        "copyAndOpen": "Copiar y abrir",
        "addContent": "Añadir contenido",
        "createBrand": "Crear nueva marca",
        "addAgent": "Añadir agente",
        "reset": "Restablecer",
        "joinConversation": "Unirse a la conversación",
        "join": "Unirse",
        "tryForFree": "Probar gratis",
        "resend": "Reenviar código",
        "cropImage": "Confirmar imagen",
        "assignAgents": "Asignar agentes",
        "upgrade": "Mejorar"
    },
    "AutomationsPage": {
        "create": "Crear automatización",
        "editor": {
            "channel": "Canal",
            "oncePerContact": "Una vez por contacto",
            "save": "Guardar",
            "nameRequired": "Ponle un nombre a la automatización",
            "saved": "Automatización guardada",
            "addStep": "Añadir paso",
            "branchYes": "Sí",
            "branchNo": "No",
            "namePlaceholder": "Automatización sin título",
            "fixIssues": "Algunos pasos tienen problemas. Corrige los pasos resaltados antes de guardar."
        },
        "palette": {
            "send": "Enviar",
            "flow": "Flujo"
        },
        "paletteHint": {
            "sendMessage": "Envía un SMS, WhatsApp o email",
            "sendCoupon": "Envía un cupón al contacto",
            "sendSurvey": "Envía una encuesta al contacto",
            "wait": "Pausa antes del siguiente paso",
            "branch": "Divide la ruta según una condición"
        },
        "trigger": {
            "whoCanEnter": "Quién puede entrar",
            "byEvent": "Evento",
            "byDate": "Fecha",
            "date": "Fecha",
            "contactBirthday": "Cumpleaños del contacto",
            "fixedDate": "Una fecha fija",
            "month": "Mes",
            "day": "Día",
            "year": "Año",
            "everyYear": "Todos los años",
            "timing": "Cuándo",
            "onTheDay": "El mismo día",
            "before": "Antes",
            "offsetDaysBefore": "Días antes",
            "after": "Después",
            "offsetDaysAfter": "Días después",
            "sendAt": "Hora",
            "birthday": "Cumpleaños",
            "whichSegments": "Segmentos (déjalo vacío para cualquiera)",
            "daysBefore_one": "{{count}} día antes",
            "daysBefore_other": "{{count}} días antes",
            "daysAfter_one": "{{count}} día después",
            "daysAfter_other": "{{count}} días después"
        },
        "nodes": {
            "trigger": "Disparador",
            "branch": "Si / entonces",
            "sendMessage": "Enviar mensaje",
            "sendCoupon": "Enviar cupón",
            "sendSurvey": "Enviar encuesta",
            "wait": "Esperar",
            "exit": "Salida",
            "setDuration": "Definir duración",
            "noMessage": "Aún sin mensaje",
            "pickSurvey": "Elige una encuesta",
            "surveySelected": "Encuesta seleccionada",
            "pickCoupon": "Elige un cupón",
            "couponSelected": "Cupón seleccionado",
            "setCondition": "Definir condición",
            "pickEvents": "Elige eventos",
            "eventCount": "{{count}} evento(s)",
            "conditionCount": "{{count}} condición(es)",
            "exitSubtitle": "Los contactos salen de la automatización aquí"
        },
        "drawer": {
            "customEventType": "Tipo de evento personalizado (opcional)",
            "branchHint": "Se toma la ruta «sí» cuando se cumplen estas condiciones",
            "wait": "Espera"
        },
        "table": {
            "steps": "Pasos",
            "enrolled": "Contactos inscritos",
            "enrolledHint": "Contactos que entraron en esta automatización",
            "failedFixHint": "Esta automatización falló. Ábrela y corrige el problema para volver a activarla."
        },
        "conditions": {
            "everyoneEnters": "Todos los que activen esta automatización entrarán.",
            "matchAllHint": "Solo contactos que cumplan todo lo siguiente:",
            "matchAnyHint": "Contactos que cumplan cualquiera de estos escenarios:",
            "addFilter": "Añadir filtro",
            "addAlternative": "Añadir alternativa “O”",
            "scenario": "Escenario {{number}}",
            "and": "y",
            "or": "o",
            "segment": "Segmento",
            "segments": "Segmentos",
            "eventField": "Campo del evento",
            "jsonPathPlaceholder": "Ruta JSON, p. ej. order.total",
            "value": "Valor",
            "valuePlaceholder": "valor",
            "operators": {
                "isAnyOf": "es cualquiera de",
                "isNoneOf": "no es ninguno de",
                "is": "es",
                "isNot": "no es",
                "isOneOf": "es uno de",
                "contains": "contiene",
                "notContains": "no contiene",
                "isKnown": "es conocido",
                "isUnknown": "es desconocido",
                "greaterThan": "es mayor que",
                "lessThan": "es menor que"
            },
            "listPlaceholder": "valores, separados por comas",
            "tooComplex": "Estos filtros se crearon con un editor anterior y son demasiado complejos para mostrarse. Bórralos para reconstruirlos.",
            "clearFilters": "Borrar filtros",
            "deletedSegment": "(segmento eliminado)",
            "incompleteFilter": "Completa este filtro o elimínalo",
            "eventFields": {
                "provider": "Proveedor de pagos",
                "account": "Cuenta de pagos",
                "location": "Localización",
                "amount": "Importe pagado",
                "currency": "Moneda",
                "firstPurchase": "Primera compra",
                "paymentCount": "Número de compras",
                "brand": "Marca"
            },
            "unavailableOption": "(ya no está disponible)",
            "age": "Edad",
            "contactLocation": "Localización del contacto"
        },
        "triggers": {
            "contactCreated": "Contacto creado",
            "surveyResponded": "Encuesta respondida",
            "surveySent": "Encuesta enviada",
            "conversationResolved": "Conversación resuelta",
            "reviewLeft": "Reseña recibida",
            "integrationEvent": "Evento de integración",
            "customEvent": "Evento personalizado",
            "couponRedeemed": "Cupón canjeado",
            "formSubmitted": "Formulario enviado",
            "integrationCoverManager": "Reserva de CoverManager",
            "integrationVtex": "Pedido de VTEX",
            "paymentCompleted": "Pago completado",
            "bookingStarted": "Reserva iniciada",
            "bookingEnded": "Reserva finalizada",
            "addedToSegment": "Añadido a un segmento"
        },
        "units": {
            "minutes": "minutos",
            "hours": "horas",
            "days": "días"
        },
        "issues": {
            "triggerEvents": "Elige al menos un evento de disparador",
            "channelRequired": "Elige un canal",
            "channelUnavailable": "El canal seleccionado está desconectado o no disponible",
            "messageRequired": "Añade un mensaje",
            "emailTemplateRequired": "Elige una plantilla de email",
            "whatsAppTemplateRequired": "Elige una plantilla de WhatsApp",
            "surveyRequired": "Elige una encuesta",
            "couponRequired": "Elige un cupón",
            "waitInvalid": "Establece una duración de espera",
            "conditionIncomplete": "Completa o elimina los filtros incompletos",
            "segmentMissing": "Un filtro usa un segmento que ya no existe",
            "noAction": "Añade un paso de mensaje o encuesta al que lleve el disparador",
            "triggerDate": "Elige la fecha en que empieza esta automatización",
            "eventFieldOnDate": "Quita los filtros de evento: una automatización que empieza en una fecha no tiene evento que filtrar",
            "triggerSegmentMissing": "El disparador usa un segmento que ya no existe"
        }
    },
    "CampaignsPage": {
        "title": "Gestión de campañas",
        "subtitle": "Notifica promociones o noticias importantes a través de campañas",
        "audience": "Segmento",
        "audienceHint": "Déjalo vacío para llegar a todos los contactos.",
        "name": "Título",
        "createTitle": "Crear campaña",
        "editTitle": "Editar campaña",
        "viewTitle": "Detalles de campaña",
        "duplicateCampaign": "Duplicar campaña",
        "contactsNumber": "Contactos seleccionados: {{count}}",
        "triggerEvent": "Eventos desencadenantes",
        "triggerExplanation": "Elija los eventos que iniciarán su campaña de mensajería. En los casos en que se produzcan varios eventos, el retraso se contará a partir del último evento.",
        "surveySent": "Encuesta enviada",
        "status0": "Programada",
        "status1": "Continua",
        "status2": "Completado",
        "status3": "Cancelada",
        "status5": "Pausada",
        "warningMessage": "Para reducir el riesgo de ser bloqueado por WhatsApp, se recomienda mantener el tamaño de tu campaña de marketing por debajo de 50 contactos.",
        "addCoverPhoto": "Añadir foto de portada",
        "coverPhotoFormat": "Formato: JPG o PNG. Anchura mínima: 600 px",
        "imageFormat": "Formato: JPG o PNG.",
        "addCTAButton": "Añadir botón de llamada a la acción",
        "buttonTitle": "Título del botón",
        "addImage": "Añadir imagen"
    },
    "common": {
        "unsavedChangesTitle": "¿Descartar los cambios sin guardar?",
        "unsavedChangesDescription": "Tienes cambios sin guardar que se perderán si cierras esta ventana.",
        "enabled": "Activado",
        "unknown": "Usuario desconocido",
        "noOptions": "Sin opciones",
        "noData": "Sin datos",
        "noNotifications": "No hay nuevas notificaciones",
        "timeframe": "Periodo de tiempo",
        "allTime": "Histórico",
        "today": "Hoy",
        "previous": "Anterior",
        "next": "Siguiente",
        "last7Days": "Últimos 7 días",
        "lastWeek": "Semana pasada",
        "last30Days": "Últimos 30 días",
        "last90Days": "Últimos 90 días",
        "thisMonth": "Este mes",
        "lastMonth": "Mes pasado",
        "thisYear": "Este año",
        "exportError": "Imposible exportar los datos como CSV",
        "zapierIntegration": "Integración Zapier",
        "clipboardCopied": "Copiado al portapapeles",
        "clipboardFailed": "Portapapeles no soportado",
        "image": "Imagen",
        "imageUploadFormat": "Formatos de archivo: JPG, PNG. Tamaño máximo: {{size}}",
        "images": "Imágenes",
        "users": "Usuarios",
        "location": "Localización",
        "locations": "Localizaciones",
        "allLocations": "Todas las localizaciones",
        "channel": "Canal",
        "survey": "Encuesta",
        "surveys": "Encuestas",
        "reviewSites": "Plataforma",
        "rating": "Rating",
        "status": "Estatus",
        "update": "Actualización",
        "keywords": "Palabras clave",
        "replyTemplates": "Plantilla vinculadas",
        "all": "Todos",
        "url": "URL",
        "or": "o",
        "name": "Nombre",
        "firstName": "Nombre",
        "lastName": "Apellidos",
        "lastNameOpt": "Apellidos (opcional)",
        "fullName": "Nombre",
        "phoneNumber": "Móvil",
        "email": "Email",
        "emailAddress": "Dirección email",
        "login": "Login",
        "password": "Contraseña",
        "outOf": "{{total}} de {{max}}",
        "saving": "Guardando...",
        "edit": "Editar",
        "delete": "Borrar",
        "view": "Vista",
        "duplicate": "Duplicar",
        "deleteTitle": "Confirmar eliminación",
        "deleteDescription": "¿Estás seguro de que deseas borrar esto? Esta acción no se puede deshacer.",
        "delay": "Demora",
        "refresh": "Refrescar",
        "contactCreated": "Contacto creado",
        "liveChat": "Сhat en vivo",
        "left": "Izquierda",
        "right": "Derecha",
        "file": "Archivo",
        "audio": "Audio",
        "video": "Video",
        "monday": "Lunes",
        "tuesday": "Martes",
        "wednesday": "Miércoles",
        "thursday": "Jueves",
        "friday": "Viernes",
        "saturday": "Sábado",
        "sunday": "Domingo",
        "open": "Abierto",
        "closed": "Cerrado",
        "24hours": "24 horas",
        "story": "Historia",
        "user": "Usuario",
        "new_other": "Nuevas",
        "new_one": "Nuevo",
        "unassigned": "No asignadas",
        "title": "Título",
        "scheduledTime": "Hora programada",
        "scheduled": "Programada",
        "published": "Publicado",
        "unpublished": "No publicado",
        "publishing": "Publicando",
        "cancelled": "Cancelado",
        "deleted": "Eliminado",
        "description": "Descripción",
        "completed": "Completada",
        "cancel": "Cancelar",
        "subscriptionExpiredMsg": "Problema con su suscripción. Comprueba tus datos de facturación o ponte en contacto con el servicio de asistencia.",
        "upgradeToAdd": "Mejorar para agregar más",
        "planCancelledUntilPeriodEnd": "Su suscripción está cancelada y permanece activa hasta el final del período pagado. Contacte con soporte para reactivarla.",
        "upgradeAskAdmin": "Pide al administrador de la cuenta que actualice el plan.",
        "upgradeToUnlock": "Mejorar para desbloquear capacidad",
        "sms": "SMS",
        "whatsApp": "WhatsApp",
        "liveChatLowercase": "live-chat",
        "facebookMessenger": "Facebook Messenger",
        "instagram": "Instagram",
        "templates": "Plantillas",
        "industry": "Industria",
        "impressions": "Impresiones",
        "reach": "Alcance",
        "engagement": "Interacciones",
        "learnMore": "Más información",
        "number": "Número",
        "text": "Texto",
        "date": "Fecha",
        "required": "Requerido",
        "type": "Tipo",
        "templateName": "Nombre de plantilla",
        "author": "Autor",
        "yes": "Sí",
        "no": "No",
        "labels": "Segmento",
        "locationLabels": "Etiquetas de localización",
        "logo": "Logo",
        "low": "Bajo",
        "medium": "Medio",
        "high": "Alto",
        "critical": "Crítico",
        "average": "Promedio",
        "good": "Bueno",
        "excellent": "Excelente",
        "conversations": "Conversaciones",
        "platform": "Plataforma",
        "actionRequired": "Acción requerida",
        "conflict": "Conflicto",
        "conflicts": "Conflictos",
        "conflict_one": "Conflicto",
        "conflict_other": "Conflictos",
        "notFound": "No encontrado",
        "notVerified": "No verificado",
        "disconnected": "Desconectado",
        "notPublished": "No publicado",
        "inProgress": "En proceso",
        "synced": "Sincronizado",
        "syncedWithConflicts": "Sincronizado con conflictos",
        "na": "N/A",
        "latitude": "Latitud",
        "longitude": "Longitud",
        "none": "Ninguna",
        "reported": "Denunciado",
        "report": "Denunciar",
        "format": "Formato",
        "photo": "Foto",
        "customer": "Cliente",
        "business": "Empresa",
        "category_other": "Categorías",
        "category_one": "Categoría",
        "action": "Acción",
        "day": "Día",
        "week": "Semana",
        "month": "Mes",
        "year": "Año",
        "draft": "Borrador",
        "top": "Top",
        "bottom": "Últimas",
        "notifications": "Notificaciones",
        "complaint_other": "Reclamaciones",
        "complaint_one": "Reclamación",
        "review_other": "Reseña",
        "review_one": "Reseña",
        "location_other": "Localizaciones",
        "location_one": "Localización",
        "profile_other": "Perfiles",
        "profile_one": "Perfil",
        "message_other": "Mensajes",
        "message_one": "Mensaje",
        "subject": "Asunto",
        "cc": "CC",
        "bcc": "CCO",
        "link": "Enlace",
        "microsite": "Micrositio",
        "color_one": "Color",
        "color_other": "Colores",
        "archived": "Archivado",
        "assignedTo": "Asignar a",
        "question": "Pregunta",
        "answer": "Respuesta",
        "copy": "Copia",
        "brands": "Marcas",
        "brand": "Marca",
        "failed": "Fallido",
        "actions": "Acciones",
        "questions": "Preguntas",
        "language": "Idioma",
        "localization": "Localización",
        "disabled": "Desactivado",
        "active": "Activar",
        "day(s)": "día(s)",
        "hour(s)": "hora(s)",
        "minute(s)": "minuto(s)",
        "appearance": "Apariencia",
        "settings": "Ajustes",
        "style": "Estilo",
        "font": "Fuente",
        "button_one": "Botón",
        "button_other": "Botones",
        "background": "Fondo",
        "customEvent": "Evento externo",
        "unverified": "No verificado",
        "verify": "Verificar",
        "noFileSelected": "No se ha seleccionado ningún archivo",
        "chat": "Chat",
        "customInstructionsOpt": "Instrucciones personalizadas (opcional)",
        "activity": "Actividad",
        "information": "Información",
        "newMessage": "Nuevo mensaje",
        "frequency": "Frecuencia",
        "currency": "Moneda",
        "coupon": "Cupón",
        "service": "Servicio",
        "paymentMethods": "Métodos de pago",
        "externalId": "ID externo",
        "public": "Público",
        "publicLink": "Enlace público",
        "private": "Privado",
        "sharedTemplate": "Plantilla compartida",
        "template": "Plantilla",
        "teams": "Equipos",
        "createdOn": "Creado en",
        "platforms": "Plataformas",
        "emoji": "Emoji",
        "attachFile": "Adjuntar archivo",
        "menu": "Menú",
        "form": "Formulario",
        "team": "Equipo",
        "recoveryForm": "Formulario de recuperación",
        "removedPersonName": "{{name}} (eliminado)",
        "notSpecified": "Sin especificar"
    },
    "ContactsPage": {
        "createdOn": "Creado en",
        "deleteContactsDescription": "Seguro que quieres borrar a {{selectedContacts}} contactos? No habrá marcha atrás.",
        "facebookProfile": "Perfil de Facebook",
        "instagramProfile": "Perfil de Instagram",
        "createTitle": "Crear contacto",
        "createSubtitle": "Anadir detalles del contacto",
        "editTitle": "Editar contacto",
        "editContactsTitle": "Editar contactos",
        "editBulkContactsSubtitle": "Seleccione las propiedades que desea editar. Los cambios se aplicarán a todos los contactos seleccionados.",
        "editSubtitle": "Cambiar detalles de la información del cliente",
        "mergeContactsTitle": "Fusionar contactos",
        "mergeContactsSubtitle": "Fusionar contactos para combinar dos perfiles en uno, incluyendo todos los atributos y la actividad. En caso de conflicto, los atributos del contacto principal tendrán prioridad.",
        "mergeContactPrimary": "Contacto principal (Se conservará)",
        "mergeContactSecondary": "Contacto a fusionar (A eliminar)",
        "unsubscribe": "Darse de baja",
        "unsubscribed": "Dado de baja",
        "lastActiveOn": "Última actividad",
        "importTitle": "Importar contactos",
        "importSubtitle": "Importar contactos con archivo CSV.",
        "importConsent": "Confirmo que estos contactos aceptaron recibir mensajes de mi negocio y que la lista no se ha comprado, alquilado ni obtenido de terceros.",
        "bulkFileLink": "Descargar CSV de muestra.",
        "csvFile": "Archivo CSV",
        "importFile": "Importar",
        "id": "ID",
        "dataVerificationDescription": "Revise los datos analizados del archivo csv. Para que se procese, no debe contener ningún error.\n Si encuentra un error, cierre esta ventana emergente, edite y vuelva a cargar el archivo.",
        "validate": "Validar",
        "numberToImport": "Contacts to add {{diff}}. Contacts to update {{duplicates}}",
        "contactsToAdd": "Contactos a añadir",
        "contactsToUpdate": "Contactos a actualizar",
        "noContacts": "Sin contactos",
        "search": "Buscar",
        "searchLabel": "Buscar por nombre, teléfono o correo",
        "activitySurveySent": "Encuesta enviada: {{template}}",
        "activityFormSubmitted": "Envió el formulario {{name}}",
        "activitySurveyReminder": "Recordatorio de encuesta enviado: {{template}}",
        "activitySurveyResponded": "Respondió a {{template}} con {{rating}} estrellas",
        "activityMessageSent": "Mensaje enviado a través de {{channel}}",
        "activityConversationStarted": "Conversación iniciada",
        "activityConversationClosed": "Conversación resuelta por {{name}}",
        "activityConversationReopened": "Conversación reabierta por {{name}}",
        "activityReviewLeft": "Dejó reseña en {{reviewType}}",
        "activityIntegrationEvent": "Evento de {{integration}}",
        "contacts": "contactos",
        "contactsSelected": "{{selectedContacts}} contactos seleccionados",
        "mergeSuccess": "Los contactos se han fusionado con éxito",
        "mergeFail": "No se pudieron fusionar contactos",
        "activityPaymentCompleted": "Pago completado",
        "paymentDetails": {
            "amount": "Importe",
            "location": "Localización",
            "paidAt": "Pagado",
            "method": "Método de pago",
            "account": "Cuenta de pagos",
            "purchase": "Compra",
            "firstPurchase": "Primera",
            "purchaseNumber": "N.º {{count}}",
            "viewReceipt": "Ver recibo",
            "sources": {
                "CARD": "Tarjeta",
                "BANK_ACCOUNT": "Cuenta bancaria",
                "WALLET": "Monedero digital",
                "BUY_NOW_PAY_LATER": "Compra ahora, paga después",
                "SQUARE_ACCOUNT": "Saldo de Square",
                "CASH": "Efectivo",
                "EXTERNAL": "Otro"
            }
        },
        "sex": "Sexo",
        "sexFemale": "Femenino",
        "sexMale": "Masculino",
        "dateOfBirth": "Fecha de nacimiento",
        "language": "Idioma",
        "dateOfBirthWithoutYear": "Guardado como {{date}}, sin año",
        "leaveUnchanged": "Dejar sin cambios",
        "activityAddedToSegment": "Añadido al segmento {{name}}"
    },
    "ErrorsPages": {
        "titleSomethingWrong": "Imposible abrir esta página",
        "textSomethingWrong": "Sentimos el inconveniente. Somos conscientes del problema y ya analizamos la causa del mismo. Si el problema continua, envíenos un correo a help@pluspoint.io para obtener asistencia inmediata",
        "notFoundPage": "No podemos encontrar la página que buscas"
    },
    "FeedbackResponses": {
        "newReviews": "Nuevas reseñas disponibles. <0>{{update}}</0>",
        "update": "Actualizar",
        "noDataMessage": "NA",
        "onlyRating": "El cliente no dejó comentario, solo puntuó.",
        "aiReviewTags": "Lo que más le gustó",
        "contactDetailsOnly": "El cliente dejó sus datos de contacto sin mensaje.",
        "copyNumber": "Copiar número móvil",
        "callNumber": "Llamar movil",
        "chatViber": "Contacte através de Viber",
        "chatWhatsApp": "Contacte através de WhatsApp",
        "copyEmail": "Copiar email",
        "chatEmail": "Contacte através de email",
        "ticketStatus": "Estatus ticket",
        "completed": "Completado",
        "viaCoverManager": "Via CoverManager",
        "hideAnonimous": "Ocultar respuestas anónimas",
        "linkedReview": "Reseña vinculada"
    },
    "FeedbackSurveys": {
        "created": "Encuestas creadas:",
        "createdQrOnly": "Códigos QR creados:",
        "title": "Gestionar su encuesta",
        "subtitle": "Configure encuestas para recopilar impresiones de sus clientes, comprender mejor sus necesidades y asegurarse de que se mantienen leales y recomiendan su negocio.",
        "titleQrOnly": "Consigue reseñas de forma más inteligente",
        "subtitleQrOnly": "Pásate a Pluspoint Professional para sacar más partido a la recogida de reseñas. Envía encuestas por email, SMS o WhatsApp, anima a los clientes satisfechos a dejar una reseña pública, recoge feedback privado y sigue la evolución del NPS.",
        "responses": "Respuestas:",
        "views": "Vistas:",
        "modalTitle": "Editar encuesta — {{surveyName}}",
        "surveyName": "Nombre encuesta",
        "contactDetails": "Detalles del contacto",
        "contactEmail": "Email de contacto",
        "contactPhone": "Teléfono de contacto",
        "contactName": "Nombre de contacto",
        "contactFormPlacement": "Mostrar el formulario de contacto en",
        "contactFormMainScreen": "Pantalla principal",
        "contactFormMainScreenDescription": "Todos los que califican ven el formulario de contacto.",
        "contactFormNegativeScreen": "Pantalla negativa",
        "contactFormNegativeScreenDescription": "Solo ven el formulario de contacto quienes califican por debajo del umbral.",
        "contactFormNoFields": "Active al menos un campo abajo para mostrar el formulario de contacto.",
        "addField": "Añadir campo",
        "deleteField": "Borrar campo",
        "reviewSites": "Plataforma",
        "fillColor": "Llenar",
        "topText": "Texto superior",
        "bottomText": "Texto inferior",
        "messageTemplate": "Plantilla mensaje",
        "emailSubject": "Asunto del correo electrónico",
        "protectionLabel": "Protección sobre encuestar",
        "protectionTooltip": "Establezca esta opción para evitar que el sistema envíe varias invitaciones al mismo número de teléfono durante un período de tiempo específico.",
        "day": "1 dia",
        "days3": "3 dias",
        "week": "1 semana",
        "weeks2": "2 semanas",
        "month": "1 mes",
        "months3": "3 meses",
        "months6": "6 meses",
        "year": "1 año",
        "followUpLabel": "Enviar seguimiento automático",
        "followUpDescription": "Configure una solicitud de seguimiento que se enviará automáticamente si no se da una respuesta dentro de un número de días concreto",
        "wait": "Esperar",
        "days": "Dias",
        "followUpMessage": "Mensaje de seguimiento",
        "main": "Principal",
        "positive": "Positiva",
        "negative": "Negativa",
        "neutral": "Neutral",
        "tabSettings": "Ajustes",
        "tabSharing": "Compartir",
        "qrCode": "Código QR",
        "enableSendSurveys": "Habilitar envío de encuestas",
        "enableSendSurveysDescription": "Permitir que esta encuesta se envíe a clientes a través de campañas, bandeja de entrada y la función Enviar encuesta",
        "customizeQrCodeDesign": "Diseñar QR",
        "surveyQuestions": "Preguntas de encuesta",
        "addQuestion": "Añadir pregunta",
        "questionsDescription": "Crea preguntas de encuesta personalizadas para comprender mejor las necesidades de los clients.",
        "brandSettings": "Configuración de la marca",
        "changeAppearance": "Puedes cambiar la apariencia en la <0>{{brandSettings}}</0>.",
        "addFirstQuestion": "Añade una pregunta para activar la vista previa.",
        "page": "Página",
        "addPage": "Añadir página",
        "emptyPageHint": "Arrastra una pregunta aquí",
        "nps": "Activar puntuación de satisfacción (NPS)",
        "customerSatisfaction": "Pedir una calificación",
        "ratingScale": "Escala de calificación:",
        "fiveStar": "1–5 Estrellas",
        "npsScale": "0–10 Puntuación",
        "enableNpsToAddQuestions": "Active la puntuación de satisfacción en Configuración para agregar preguntas",
        "sendableSurveyRequired": "Requiere una encuesta con el envío de encuestas habilitado",
        "satisfactionSurveyThreshold": "Interceptar comentarios negativos si la calificación es menor de:",
        "labelsTitle": "Segmentos",
        "labelsSubtitle": "Asignar segmentos a los contactos recopilados a través de esta encuesta",
        "typeRating": "Calificación",
        "typeSingleChoice": "Opción única",
        "typeYesNo": "Sí / No",
        "typeMultiSelect": "Selección múltiple",
        "typeShortAnswer": "Respuesta corta",
        "typeParagraph": "Texto largo",
        "typeDate": "Fecha",
        "questionType": "Question type",
        "addOption": "Add option",
        "optionLabel": "Option",
        "gateQuestion": "Pregunta filtro",
        "gateQuestionTooltip": "Omitir las preguntas restantes si se selecciona 'No'.",
        "gateRequiresTooltip": "No disponible cuando la pregunta filtro está habilitada.",
        "showConditionally": "Mostrar según respuesta anterior",
        "showConditionallyTooltip": "Mostrar esta pregunta solo cuando se den respuestas específicas a preguntas anteriores. Varias reglas usan lógica Y (todas deben coincidir).",
        "conditionShowIf": "Mostrar esta pregunta solo si",
        "conditionAndIf": "Y si",
        "conditionMatches": "coincide con",
        "addCondition": "Agregar condición",
        "star": "estrella",
        "stars": "estrellas",
        "yes": "Sí",
        "no": "No",
        "other": "Otro",
        "includeOtherOption": "Incluir opción \"Otro\"",
        "customWording": "Texto personalizado de la encuesta",
        "aiReviewSuggestions": "Sugerencias de reseñas con IA",
        "aiReviewSuggestionsTooltip": "Los visitantes que te valoran bien eligen lo que más les gustó y Pulse AI redacta una reseña breve que pueden copiar en Google y en los demás sitios de reseñas.",
        "aiReviewTags": "Etiquetas que pueden elegir los visitantes",
        "addReviewTag": "Añadir etiqueta",
        "reviewTagNamePlaceholder": "Nombre de la etiqueta",
        "createReviewTag": "Crear",
        "editReviewTagTitle": "Editar etiqueta",
        "deleteReviewTagTitle": "¿Eliminar etiqueta?",
        "deleteReviewTagDescription": "\"{{name}}\" se eliminará para toda la cuenta y se quitará de todas las encuestas.",
        "useCustomWording": "Usar texto personalizado",
        "customWordingTooltip": "Añada texto personalizado para cada idioma que quiera que la encuesta admita. Un idioma solo aparecerá en la encuesta si tiene texto.",
        "positiveMessage": "Mensaje positivo",
        "negativeMessage": "Mensaje negativo",
        "localizationSingleLanguage": "Añada idiomas en Texto personalizado de la encuesta, en Ajustes, para traducir las preguntas"
    },
    "filters": {
        "labels": "Etiquetas de localización",
        "companies": "Localizaciones",
        "locations": "Localizaciones",
        "surveys": "Encuestas",
        "integrations": "Plataforma",
        "channels": "Canal",
        "platforms": "Plataformas",
        "timeframe": "Periodo de tiempo",
        "rating": "Rating",
        "statuses": "Estatus",
        "views": "Estatus",
        "hideAnonimous": "Activar para ver solo respuestas con información de contacto",
        "keywords": "Palabras clave",
        "withoutReplies": "Reseñas sin respuesta",
        "onlyFeatured": "Reseñas destacadas",
        "formats": "Formato",
        "categories": "Categorías",
        "authors": "Autor",
        "contactLabels": "Segmento",
        "grouping": "Agrupar por",
        "brands": "Marcas",
        "showUnreadOnly": "Mostrar solo conversaciones no leídas",
        "sorting": "Ordenar por",
        "teams": "Equipos",
        "sexes": "Sexo",
        "languages": "Idioma",
        "birthMonths": "Mes de cumpleaños",
        "ageBracket": "Edad",
        "anyAge": "Cualquier edad"
    },
    "ForgotPasswordPage": {
        "title": "¿Olvidó la contraseña?",
        "description": "Introduce tu correo. Le enviaremos un enlace para restablecer su contraseña..",
        "backToLogin": "Retroceder inicio de sesión",
        "confirmationSuccess": "Si existe una cuenta Pluspoint, se enviará un correo electrónico con más instrucciones"
    },
    "Header": {
        "home": "Home",
        "reviewsOverview": "Visión general",
        "templates": "Plantillas",
        "responses": "Todas las respuestas",
        "surveys": "Encuestas",
        "reviewsManage": "Todas las reseñas",
        "reviewsTemplates": "Plantillas de respuesta",
        "reviewsAutoreplies": "Auto respuestas",
        "reviewsAutomation": "Automatización",
        "messagingInbox": "Bandeja de entrada",
        "messagingTemplates": "Plantillas de mensajes",
        "microsites": "Micrositios",
        "menus": "Menús",
        "forms": "Formularios",
        "analytics": "Analítica",
        "analyticsConversion": "Analiticas de conversión",
        "analyticsReviews": "Analiticas de reseñas",
        "analyticsSurveys": "Analiticas de respuestas",
        "analyticsConversations": "Conversaciones",
        "analyticsPresence": "Presencia",
        "settings": "Ajustes",
        "onboarding": "A bordo",
        "reviewsWidgets": "Widgets de página web",
        "socialPosts": "Publicaciones",
        "keywords": "Palabras clave y sentimiento",
        "ordersIfood": "Pedidos",
        "campaigns": "Campañas",
        "campaignsAutomated": "Automatizadas",
        "campaignsOneTime": "Únicas",
        "contacts": "Contactos",
        "presence": "Presencia",
        "presenceProfiles": "Perfiles",
        "presenceMedia": "Fotos y vídeos",
        "locationsManage": "Gestionar localizaciones",
        "locationsProfiles": "Perfiles",
        "locationsMedia": "Fotos y Videos",
        "visibilityScanner": "Escáner de visibilidad",
        "locationsAnalytics": "Análisis de Localizaciones",
        "login": "Acceso",
        "signup": "Inscripción",
        "resetPassword": "Resetear contraseña",
        "forgotPassword": "¿Olvidó la contraseña?",
        "verifyEmail": "",
        "acceptInvitation": "Aceptar invitación",
        "error": "Error",
        "pulseAI": "Pulse AI",
        "coupons": "Cupones",
        "campaignsLibrary": "Biblioteca"
    },
    "HomePage": {
        "leaderboard": "Clasificación",
        "5LocationsBy": "5 localizaciones por",
        "rating": "puntuación",
        "reviews": "reseñas",
        "nps": "NPS",
        "inbox": "Bandeja de entrada",
        "surveys": "Respuestas a encuestas",
        "recommendations": "Recomendaciones",
        "presence": "Presencia en línea",
        "locations": "Presencia online",
        "synchronization": "Sincronización de perfiles",
        "optimizationScoreSubtitle": "Identifica localizaciones con perfiles incompletos para mejorar la visibilidad y la confianza",
        "locationsSubtitle": "Descubre cómo los clientes encuentran tus localizaciones e interactúan con ellas",
        "synchronizationSubtitle": "Mantén la información de tu negocio consistente en todas partes donde los clientes te buscan",
        "leaderboardSubtitle": "Identifica las localizaciones que lideran y las que necesitan apoyo para mejorar el rendimiento",
        "inboxSubtitle": "Responde a los mensajes de los clientes desde todos los canales en un solo lugar",
        "reviewsSubtitle": "Mantente al tanto de las nuevas reseñas y mejora tu reputación respondiendo rápido",
        "surveysSubtitle": "Recoge opiniones para detectar quejas a tiempo y mejorar la experiencia del cliente",
        "socialSubtitle": "Atrae a tu audiencia con publicaciones constantes y mide qué llega a los clientes",
        "surveysTitle": "Gestionar quejas y feedback del cliente",
        "unreplied": "Sin responder",
        "vsPrevMonth": "<0>{{percentage}}</0> vs Mes Anterior",
        "getStarted": "Iniciación en {{steps}} pasos fáciles",
        "continueOnboarding": "Continuar la incorporación",
        "googleTitle": "Integrar con Google My Business (5 min)",
        "googleDescription": "Gestionar y responder a reseñas de clientes y actualizar información pública.",
        "brandTitle": "Crear una marca (5 min)",
        "brandDescription": "Agrupa localizaciones para una gestión más sencilla y personaliza su apariencia en la plataforma.",
        "channelsTitle": "Configurar canales de comunicación (20 min)",
        "channelsDescription": "Consolidar chat en vivo y plataformas de mensajería para una comunicación con el cliente más fluida.",
        "templatesTitle": "Crear plantillas de encuestas (10 min)",
        "templatesDescription": "Habilitar encuestas para capturar retroalimentación esencial de clientes y aumentar reseñas en línea.",
        "qrCodesTitle": "Crea códigos QR para reseñas (5 min)",
        "qrCodesDescription": "Genera códigos QR para colocar en tickets, mesas o escaparates y que los clientes dejen una reseña al instante.",
        "autoRepliesTitle": "Configurar auto-respuestas a reseñas (10 min)",
        "autoRepliesDescription": "Automatizar respuestas personalizadas a reseñas para mayor compromiso y cuidado al cliente.",
        "usersTitle": "Invitar a otros usuarios (5 min)",
        "usersDescription": "Expandir las capacidades de su equipo invitando a colegas a la plataforma.",
        "recommendation1Title": "Responder a las últimas reseñas",
        "recommendation1Subtitle": "Hay reseñas que no han sido respondidas.",
        "recommendation1Text": "Al responder a las reseñas, ayudas a mejorar la calificación de estrellas de tus localizaciones.",
        "recommendation1UrlText": "Ir a reseñas",
        "recommendation2Title": "Actualizar las fotos de tus perfiles",
        "recommendation2Subtitle": "Las fotos no se han actualizado hace más de un mes.",
        "recommendation2Text": "Las fotos actuales ayudarán a mejorar tu presencia en línea.",
        "recommendation2UrlText": "Ir a fotos",
        "recommendation3Title": "Añade descripciones a tus localizaciones",
        "recommendation3Subtitle": "Algunos de tus perfiles no tienen descripciones.",
        "recommendation3Text": "Una descripción completa mejora la clasificación de tu perfil en los resultados de búsqueda.",
        "recommendation3UrlText": "Ir a configuración",
        "recommendationLocationsUrlText": "Ir a localizaciones",
        "recommendation4Title": "Resuelve los conflictos de perfiles y publica las localizaciones pendientes",
        "recommendation4Subtitle": "Algunos perfiles requieren tu atención.",
        "recommendation4Text": "Resuelve los conflictos para que tus datos sean coherentes y publica los perfiles que aún no están activos para que los clientes puedan encontrarte.",
        "recommendation4UrlText": "Ir a perfiles",
        "recommendation5Title": "Responder a los mensajes no leídos",
        "recommendation5Subtitle": "Tienes mensajes no leídos, que requieren tu atención.",
        "recommendation5Text": "Responder rápidamente mejora la satisfacción del cliente.",
        "recommendation5UrlText": "Ir a bandeja de entrada",
        "recommendation6Title": "Publicar una post en redes sociales",
        "recommendation6Subtitle": "Algunos perfiles no han tenido una nueva publicación en un tiempo.",
        "recommendation6Text": "Las publicaciones regulares en redes sociales mantienen a tu audiencia comprometida y mejoran tu presencia online.",
        "recommendation6UrlText": "Ir a publicaciones",
        "recommendation7Title": "Revisar quejas recientes",
        "recommendation7Subtitle": "Hay quejas de tus clientes.",
        "recommendation7Text": "Atender las quejas de manera rápida, ayuda a mejorar la satisfacción del cliente y la confianza en tu empresa.",
        "recommendation7UrlText": "Ir a quejas",
        "recommendation8Title": "Integración desconectada",
        "recommendation8Text": "La integración entre una plataforma de reseñas y Pluspoint está actualmente desconectada. Por favor, reconéctala para seguir usando la integración correctamente.",
        "recommendation9Title": "Canal desconectado",
        "recommendation9Text": "Un canal de comunicación está actualmente desconectado. Reconéctalo para asegurar que todos los mensajes y respuestas a clientes se entreguen sin interrupciones.",
        "recommendation10Title": "Campaña automatizada fallida",
        "recommendation10Text": "Una campaña automatizada no se ejecutó correctamente. Verifica la configuración de la automatización para identificar y solucionar el problema.",
        "recommendation10UrlText": "Ir a campañas",
        "recommendation11Title": "Campaña única fallida",
        "recommendation11Text": "Tu campaña única no se envió correctamente. Revisa los detalles de la campaña e inténtalo de nuevo.",
        "showAllRecommendation": "Mostrar todas las recomendaciones",
        "showLessRecommendation": "No mostrar recomendaciones ocultas"
    },
    "Listings": {
        "modalTitleGoogle": "Gestionar el perfil de Google My Business",
        "modalTitleFacebook": "Gestionar el perfil de Facebook",
        "about": "General",
        "name": "Nombre",
        "openingDate": "Fecha de apertura",
        "contact": "Contacto",
        "primaryPhone": "Teléfono principal",
        "additionalPhone": "Teléfono adicional",
        "website": "Sitio web",
        "businessHours": "Horario",
        "categories": "Categorías",
        "primaryCategory": "Categoría principal",
        "secondaryCategory_one": "Categoría secundaria",
        "secondaryCategory_other": "Categorías secundarias",
        "enableProfileSync": "Activar la sincronización del perfil",
        "disableProfileSync": "Desactivar sincronización del perfil",
        "connectMainPage": "Conectar página principal",
        "storeLocation": "Tienda",
        "connectStoreLocation": "Conectar tienda",
        "ignoredFields": "Campos ignorados",
        "ignoredFieldsHint": "Pluspoint no envía estos campos a esta ficha ni los reporta como conflictos.",
        "currentlyDifferent": "actualmente distinto"
    },
    "LoginPage": {
        "title": "Bienvenido de nuevo",
        "description": "Accede a tus localizaciones, reseñas y mensajes desde un único panel.",
        "forgotPassword": "¿Olvidó su contraseña?",
        "notRegistered": "¿No tienes una cuenta? <0>{{link}}</0>",
        "signUp": "Inscripción",
        "terms": "Términos",
        "privacy": "Política de Privacidad",
        "dpa": "Acuerdo de procesamiento de datos",
        "termsConditions": "Usando Pluspoint aceptas <0>{{terms}}</0> <1>{{privacy}}</1> Y <2>{{dpa}}</2>",
        "signinWithGoogle": "Inicia sesión con Google",
        "googleUserNotFound": "No se encontró una cuenta con este correo. <0>{{link}}</0> para comenzar."
    },
    "LogoutModal": {
        "logOutConfirmation": "¿Cerrar sesión en Pluspoint?",
        "logOutConfirmationDescription": "Volverá a la pantalla de inicio de sesión"
    },
    "DnsRecordCard": {
        "type": "Tipo:",
        "name": "Nombre:",
        "value": "Valor:",
        "status": "Estado:",
        "notChecked": "Sin comprobar"
    },
    "MicrositesPage": {
        "createCustomLending": "Crea una landing page específica para cada localización",
        "createCustomLendingSubTitle": "Cree una landing page para móviles por localización y proporcione a los clientes la información que necesitan, como lista de servicios, reservas y enlaces de redes sociales.",
        "created": "Micro-sites creados:",
        "content": "Contenido",
        "modalTitle": "Editar micrositio",
        "codeName": "Nombre del micrositio",
        "displaySocialMediaLinks": "Mostrar enlaces de redes sociales",
        "showReviews": "Mostrar ratings y reseñas",
        "links": "Links, Encuestas y Formularios",
        "linksSubtitle": "Crea un micrositio añadiendo enlaces externos, encuestas y formularios",
        "visits": "Visitas:",
        "additionalSettings": "Configuración adicional",
        "showLiveChat": "Mostrar chat en vivo",
        "surveyNotAvailableForBrand": "Las encuestas no son compatibles con marcas. Elimine este enlace.",
        "micrositeNotAvailableForLocation": "Los enlaces de micrositios no son compatibles con localizaciones. Elimine este enlace.",
        "surveyNotAvailableForLocation": "Encuesta no disponible para esta localización. Seleccione otra o elimine.",
        "micrositeNotAvailableForBrand": "Micrositio no disponible para esta marca. Seleccione otro o elimine.",
        "customDomain": "Dominio personalizado",
        "customDomainCaption": "Publica este micrositio desde tu propio dominio en lugar de plsp.io",
        "useCustomDomain": "Usar dominio personalizado",
        "domain": "Dominio",
        "statusPending": "Pendiente",
        "statusActive": "Activo",
        "statusFailed": "Fallido",
        "noDomainsInAccount": "No hay dominios en su cuenta",
        "noDomainsAvailable": "No hay dominios disponibles. Contacte a su administrador para añadir un dominio personalizado.",
        "addNewDomain": "Añadir nuevo dominio",
        "addCustomDomain": "Añadir dominio personalizado",
        "enterDomainDescription": "Introduzca el dominio que desea utilizar para sus micrositios.",
        "domainOwnershipNote": "El dominio debe ser de su propiedad. Deberá añadir un registro CNAME para verificar la propiedad. Para usar un dominio raíz, su proveedor DNS debe soportar CNAME flattening.",
        "dnsInstructions": "Añada este registro CNAME en su proveedor de dominio para apuntar su dominio a Pluspoint.",
        "domainRequired": "El dominio es obligatorio",
        "domainLengthError": "El dominio debe tener entre 4 y 253 caracteres",
        "domainInvalidFormat": "Introduzca un dominio válido",
        "domainPluspoint": "Los dominios de Pluspoint no se pueden usar como dominios personalizados",
        "addDomain": "Añadir dominio",
        "editDomain": "Editar dominio — {{hostname}}",
        "status": "Estado:",
        "lastChecked": "Última comprobación:",
        "micrositesUsingDomain": "Micrositios que usan este dominio:",
        "checkStatus": "Comprobar estado",
        "checking": "Comprobando...",
        "checkStatusError": "No se pudo comprobar el estado del dominio. Inténtelo de nuevo.",
        "deleteCustomDomain": "Eliminar dominio personalizado",
        "deleteConfirm": "¿Eliminar permanentemente {{hostname}}?",
        "deleteImpact": "Este dominio es utilizado por {{count}} micrositio(s). Perderán su URL personalizada y solo serán accesibles a través de plsp.io.",
        "deleteWarning": "Esta acción no se puede deshacer. Deberá volver a añadir y verificar el dominio para usarlo de nuevo.",
        "domainDeleted": "Dominio personalizado eliminado",
        "deleteError": "Error al eliminar el dominio",
        "addDomainError": "No se pudo registrar el dominio. Inténtelo de nuevo más tarde.",
        "loadError": "Error al cargar los dominios personalizados",
        "menuNotAvailable": "Menú no disponible para este micrositio. Seleccione otro o elimine.",
        "formNotAvailable": "Formulario no disponible para este micrositio. Seleccione otro o elimine.",
        "menuNotAvailableForBrand": "Los menús no están disponibles en micrositios de marca. Elimine este enlace."
    },
    "ContactFieldsSettings": {
        "identifyingFieldRequired": "Un teléfono o un email debe seguir siendo obligatorio"
    },
    "FormsPage": {
        "title": "Convierte visitas en relaciones duraderas",
        "subtitle": "Recoge los datos de tus clientes con formularios personalizables y úsalos para crear tus listas de contactos, segmentar audiencias y lanzar campañas dirigidas.",
        "created": "Formularios creados:",
        "createForm": "Crear formulario",
        "modalTitle": "Formulario",
        "internalName": "Nombre del formulario",
        "downloadSubmissions": "Descargar envíos",
        "confirmationMessage": "Mensaje de confirmación",
        "defaultConfirmationMessage": "Gracias por enviar el formulario",
        "views": "Vistas:",
        "submissions": "Envíos:",
        "contactFields": "Campos de contacto",
        "contactFieldsSubtitle": "Elige qué datos pide el formulario y cuáles son obligatorios.",
        "deleteForm": "Eliminar formulario"
    },
    "LocalizeItemModal": {
        "defaultLanguages": "Idioma predeterminado",
        "additionalLanguages": "Idiomas adicionales"
    },
    "multiSelectLabels": {
        "done": "Hecho",
        "manage": "Administrar",
        "createNewLabel": "Crear nuevo segmento",
        "searchLabel": "Buscar o crear nuevos segmentos"
    },
    "GoogleLocationsList": {
        "searchLabel": "Buscar",
        "hideConnected": "Ocultar las ya conectadas",
        "hideUnverified": "Ocultar las no verificadas",
        "noMatches": "No hay localizaciones que coincidan",
        "allConnected": "Todas las localizaciones ya están conectadas"
    },
    "OnboardingPage": {
        "titleFirst": "Bienvenido a Pluspoint!",
        "subtitleFirst": "Empecemos con tu información básica para configurar tu espacio de trabajo y adaptar la experiencia a tus necesidades.",
        "titleSecond": "Conecta tu cuenta de Google",
        "subtitleSecond": "Vincula tu Perfil de Empresa de Google para importar y gestionar tus localizaciones en Pluspoint. Asegúrate de conceder todos los permisos. Así podremos sincronizar tus localizaciones correctamente y gestionar tus reseñas.",
        "buttonConnectWithGoogle": "Conectar con Google",
        "titleGoogleEmpty": "No encontramos ubicaciones",
        "subtitleGoogleEmpty": "No encontramos ninguna localización de Google Business asociada a esta cuenta. Intenta conectar otra cuenta de Google o comprueba que seleccionaste todos los permisos durante la autorización.",
        "titleManual": "Añade tu primera localización",
        "subtitleManual": "Introduzca el nombre y dirección de su ubicación. Más adelante podrás añadir otras en Menú de listados.",
        "titleGoogle": "Seleccionar ubicaciones para importar",
        "subtitleGoogle": "Elige las localizaciones que quieres importar a Pluspoint. Puedes añadir una o varias para empezar a gestionar reseñas, mensajes y perfiles.",
        "canTryNextFull": "¿No es la lista que buscas? Prueba lo siguiente:",
        "canTryNext": "¿No aparece la lista que buscas? Conecta otra cuenta de Google.",
        "success": "¡Éxito!"
    },
    "AcceptInvitationPage": {
        "title": "Configura tu cuenta",
        "description": "Has sido invitado a unirte a Pluspoint",
        "continueWithGoogle": "Continuar con Google",
        "emailMismatch": "El correo de la cuenta de Google no coincide con el correo de la invitación. Inténtalo de nuevo con la cuenta correcta.",
        "tokenExpired": "Este enlace de invitación ha expirado. Contacta a tu administrador para una nueva invitación.",
        "alreadyAccepted": "Esta invitación ya ha sido aceptada. Inicia sesión."
    },
    "ResetPasswordPage": {
        "titleReset": "Resetear contraseña",
        "titleChanged": "Contraseña cambiada",
        "descriptionReset": "Introduce una nueva contraseña para tu cuenta",
        "descriptionChanged": "Su contraseña se cambió con éxito. Ahora puede iniciar sesión en su cuenta con una nueva contraseña.",
        "confirmPassword": "Confirmar contraseña"
    },
    "ReviewsAutoreplies": {
        "instantlyRespond": "Responder de manera instantánea a las reseñas",
        "googleConnected": "Configurar respuestas automáticas a reseñas de Google que se activarán cuando se cumplan ciertas condiciones",
        "subtitleWithManualSupport": "Configura respuestas con IA para las reseñas de clientes. Personaliza las sugerencias en todas las plataformas y publica respuestas automáticamente en reseñas de Google.",
        "created": "Auto-respuestas creadas:",
        "ruleName": "Nombre",
        "containsMessage": "No contiene mensaje",
        "addRule": "Añadir nueva auto-respuesta",
        "editRule": "Editar auto-respuesta",
        "viewRule": "Detalles de la auto-respuesta",
        "reviewType": "Tipo de reseña",
        "withComment": "Con comentario",
        "withoutComment": "Sin comentario",
        "applyToPastReviews": "Aplicar a reseñas anteriores no respondidas",
        "enableAI": "Activar auto-respuestas de Pulse AI para nuevas reseñas",
        "enableAIDescription": "Las auto-respuestas de Pulse AI pueden generar respuestas inexactas o inapropiadas. Al habilitar esta opción, reconoces los riesgos y aceptas la responsabilidad de supervisar y gestionar las respuestas.",
        "pulseAiDescription": "Añade instrucciones personalizadas para guiar las respuestas generadas por IA. Se aplican cuando haces clic en Escribir respuesta en cualquier reseña, y a las auto-respuestas de reseñas de Google cuando el interruptor de abajo está activado.",
        "createNewTemplate": "Crear nueva plantilla",
        "sendRecoveryForm": "Enviar formulario de recuperación",
        "sendRecoveryFormDescription": "Las respuestas a las reseñas de 1 a 4 estrellas terminan con un enlace a un formulario privado donde el cliente puede dejar sus datos de contacto."
    },
    "ReviewsEmptyFeed": {
        "reviewsNotSelectedTitle": "No seleccionó ninguna fuente",
        "integrationDescription": "Plataforma",
        "surveyDescription": "encuesta",
        "reviewsAreLoadingTitle": "Tus reseñas se están cargando en Pluspoint",
        "reviewsAreLoadingDescription": "Normalmente lleva unos minutos",
        "reviewsNotSelectedDescription": "Selecciona una localización válida, {{feedback}} y un rating",
        "reviewsNotExistTitle": "Aún no has recibido ninguna reseña",
        "reviewsNotExistDescriptionEx": "<0>{{sendSurveys}}</0> o <1>{{setupSurvey}}</1> para empezar a conseguir más reseñas",
        "sendSurveys": "Enviar encuesta",
        "setupSurvey": "Configurar encuestas"
    },
    "ReviewsManage": {
        "newReviews": "Nuevas reseñas disponibles. <0>{{update}}</0>",
        "update": "ACTUALIZAR",
        "withoutReplies": "Mostrar sólo reseñas sin respuesta",
        "noTextMsg": "Texto no proporcionado",
        "onlyRating": "El cliente no escribió reseña, solo dejo calificación",
        "repliedOn": "Respondido el {{date}}",
        "replied": "Respondido",
        "repliedOnByUser": "{{name}} respondió el {{date}}",
        "repliedByUser": "{{name}} respondió",
        "viewOn": "Ver en {{integration}}",
        "editReply": "Editar respuesta",
        "unverifiedListingNotice": "Esta ficha no está verificada en el Perfil de Empresa de Google, por lo que Google no acepta respuestas.",
        "verifyListingAction": "Verificar la ficha",
        "replyingAsOwner": "Responder como dueño",
        "publishReply": "Publicar respuesta",
        "yourReply": "Su respuesta",
        "unresolvedPlaceholders": "Su respuesta contiene un marcador que no se puede rellenar: {{placeholders}}. Quítelo antes de publicar.",
        "viaOn": "via {{integration}} en {{date}}",
        "locationsCount": "{{count}} localizaciones",
        "assignContact": "Asignar contacto",
        "markAsReplied": "Marcar como respondido",
        "replyingOnExternal": "Responder en en el sitio externo",
        "manuallyRepliedOn": "Respondido manualmente el {{date}}",
        "manuallyReplied": "Respondido manualmente",
        "manuallyRepliedOnByUser": "{{name}} respondió manualmente el {{date}}",
        "manuallyRepliedByUser": "{{name}} respondió manualmente",
        "translate": "Traducir",
        "showOriginal": "Mostrar original",
        "translatedByGoogle": "Traducido por Google",
        "markAsFeatured": "Marcar como destacada",
        "removeFromFeatured": "Quitar de destacadas",
        "markAsDeleted": "Marcar como eliminada",
        "unmarkAsDeleted": "Desmarcar como eliminada",
        "markedAsDeleted": "Reseña marcada como eliminada",
        "unmarkedAsDeleted": "Reseña desmarcada como eliminada",
        "reviewStatus": {
            "updated": "Actualizada",
            "deleted": "Eliminada",
            "featured": "Destacada"
        }
    },
    "RespondTemplate": {
        "insertTemplate": "Meter plantilla",
        "noSavedTemplates": "Sin plantillas guardadas",
        "saveReplyAsTemplate": "Guardar respuesta como plantilla",
        "deleteTemplate": "Borrar plantilla",
        "overwriteTemplate": "Reescribir plantilla",
        "saveAsNewTemplate": "Guarda como nueva plantilla",
        "saveNewTemplate": "Guardar nueva plantilla",
        "editTemplate": "¿Editar plantilla?",
        "editTemplateDescription": "Esto anulará tu plantilla"
    },
    "ReviewsReplyTemplates": {
        "tenfoldProductivity": "Multiplique la productividad de su equipo con respuestas programadas",
        "googleConnected": "Gestiona y actualiza las respuestas programadas",
        "created": "Plantillas creadas:",
        "templateMessage": "Mensaje de plantilla",
        "linkedAutoreplies": "Auto-respuestas vinculadas",
        "addTemplate": "Añadir plantilla de respuesta",
        "editTemplate": "Editar plantilla de respuesta",
        "viewTemplate": "Detalles de la plantilla de respuesta",
        "messageInputText": "Ingrese su plantilla de mensaje a continuación. Puede usar marcadores de posición [name] y [location] que se reemplazarán automáticamente con el nombre del cliente y su ubicación donde se realizó la revisión. Inserte el enlace del formulario de recuperación desde el mismo menú para invitar al cliente a dejar sus datos de contacto."
    },
    "SendInvites": {
        "sendSurvey": "Enviar encuesta",
        "sendSurveys": "Enviar encuestas",
        "personal": "Personal",
        "bulk": "Bulk",
        "phoneEmail": "Móvil o email",
        "from": "De",
        "messageSent": "Invitación enviada satisfactoriamente",
        "messagesSent": "las invitaciones han sido enviadas exitosamente",
        "bulkDescription1": "Puede importar hasta 1000 clientes a los que le gustaría enviar sus invitaciones para opinar.",
        "bulkDescription2": "Para ver la estructura correcta del archivo CSV, puede",
        "bulkFileLink": "descargar archivo piloto",
        "dataVerification": "Verificación de datos",
        "dataVerificationDescription": "Revise los datos analizados del archivo csv. Para que pueda ser procesado, no debe contener ningún error. Si encuentra un error, cierre esta ventana emergente, edite y vuelva a cargar el archivo. Si un contacto tiene correo electrónico y número de teléfono, recibirá un mensaje de texto.",
        "id": "ID",
        "import": "Importar {{amount}} contactos",
        "contactsAdded": "Contactos añadidos",
        "viewContacts": "Ver contactos",
        "addedContacts": "Contactos añadidos"
    },
    "SettingsTabs": {
        "profile": "Perfil",
        "general": "Cuenta",
        "companies": "Localización",
        "channels": "Canales",
        "integrations": "Integraciones"
    },
    "mcpConnections": {
        "title": "Conexiones MCP",
        "subtitle": "Aplicaciones que pueden conectarse a tu cuenta de Pluspoint mediante el Model Context Protocol. Revoca cualquiera que ya no uses.",
        "row": {
            "authorizedBy": "Autorizado por {{name}} · {{when}}",
            "authorizedByNoDate": "Autorizado por {{name}}",
            "lastUsed": "Último uso: {{when}}",
            "lastUsedNever": "Último uso: nunca",
            "verified": "Proveedor verificado"
        },
        "empty": {
            "title": "Aún no hay conexiones MCP.",
            "body": "Pega {{url}} en Claude.ai, ChatGPT u otro cliente MCP para conectar. Te pediremos autorización primero."
        },
        "howTo": {
            "title": "Cómo conectar",
            "body": "Pega esta URL en tu cliente MCP:",
            "guide": "Guía paso a paso para Claude, ChatGPT y otros asistentes"
        },
        "revoke": {
            "confirmTitle": "¿Revocar esta conexión?",
            "confirmBody": "{{name}} dejará de tener acceso a tu cuenta de Pluspoint. Las sesiones activas pueden continuar hasta 1 hora mientras los tokens de acceso existentes caducan. La conexión deberá volver a autorizarse para restablecer el acceso.",
            "success": "{{name}} ha sido revocado."
        },
        "errors": {
            "fetchFailed": "No se pudieron cargar las conexiones MCP.",
            "revokeFailed": "No se pudo revocar esta conexión."
        }
    },
    "SettingsIntegrations": {
        "manageIntegration": {
            "title": "Gestionar integración",
            "subtitle": "Conecta cada perfil de esta cuenta con una localización de Pluspoint.",
            "connectToLocation": "Conectar a localización",
            "dontConnect": "No conectar",
            "createNew": "Crear nueva localización",
            "emptyProfiles": "No se encontraron perfiles para esta cuenta.",
            "loadError": "No pudimos cargar los perfiles de esta cuenta. Inténtalo de nuevo.",
            "retry": "Reintentar",
            "singleProfilePrompt": "Elige una localización para asociar esta cuenta",
            "inactiveLocation": "Inactiva en Square"
        },
        "connected": "Conectado",
        "notConnected": "Desconectados",
        "integrations": "Integraciones",
        "googleNoLocations": "No se encontraron ubicaciones. Seleccione otra cuenta de Google",
        "iFoodSubtitle": "Administre las reseñas de iFood y envíe encuestas a los consumidores",
        "iFoodTitle": "Conectar cuenta iFood ",
        "iFoodInstructions": "Ingresa el CNPJ de cada localización en iFood.",
        "vtexTitle": "Conectar cuenta VTEX",
        "vtexSubtitle": "Para integrar su cuenta VTEX con nuestra plataforma y habilitar las encuestas automatizadas posteriores a la compra, necesitamos que nos proporcione las credenciales de acceso necesarias. Esto incluye una App Key y un App Token. <0>{{link}}</0> sobre cómo obtenerlas.",
        "instructionsLink": "Lea nuestras instrucciones",
        "accountName": "Nombre de cuenta",
        "appToken": "Application Token",
        "appKey": "Application Key",
        "coverManagerTitle": "Conecte su cuenta CoverManager",
        "coverManagerSubtitle": "Introduzca su ApiKey para conectar su cuenta CoverManager a Pluspoint.",
        "apiKey": "apiKey",
        "deleteIntegration": "¿Borrar integración?",
        "deleteIntegrationMessage": "Esta integración se borrará de su cuenta. ¿Desea continuar?",
        "addIntegration": "Añadir integración",
        "columnPlatform": "Plataforma",
        "columnAccount": "Cuenta",
        "columnStatus": "Estado",
        "columnActions": "Acciones",
        "noIntegrationsTitle": "Aún no hay integraciones",
        "noIntegrationsDescription": "Conecta tu primera integración para empezar a sincronizar datos.",
        "searchPlaceholder": "Buscar integraciones",
        "requestIntegrationTitle": "¿No encuentras tu integración?",
        "requestIntegrationDescription": "Solicítala y la estudiaremos, o conéctate mediante Zapier o nuestra API.",
        "requestIntegrationSuccess": "¡Gracias! Tu solicitud de integración ha sido enviada.",
        "requestIntegrationError": "No se pudo enviar tu solicitud",
        "connectViaApi": "Conectar vía API",
        "connectViaZapier": "Conectar vía Zapier",
        "headerTitle": "Conectar tus plataformas",
        "headerSubtitle": "Conecta las plataformas que ya utilizas —Google, redes sociales, mensajería y CRM— para sincronizar reseñas, publicar contenido, gestionar conversaciones y centralizar los datos de tus clientes.",
        "requestNamed": "Solicitar añadir «{{name}}»"
    },
    "SettingsProfile": {
        "alertsAndReports": "Alertas e informes",
        "settingsTitle": "Perfil y configuración personal",
        "profilePhoto": "Foto de perfil",
        "generalInfo": "Información general",
        "systemLanguage": "Idioma del sistema",
        "currentPassword": "Contraseña actual",
        "newPassword": "Nueva contraseña",
        "confirmPassword": "Confirmar nueva contraseña",
        "passwordResetText": "¿Olvidó su contraseña?",
        "passwordResetUrl": "Establece nueva contraseña",
        "everyHour": "Cada hora",
        "everyDay": "Diarias",
        "everyWeek": "Semanal",
        "everyMonth": "Mensual",
        "emptyNumberTooltip": "Introduce tu número de teléfono para recibir alertas por SMS",
        "emailNotifications": "Correos de notificación",
        "emailNotificationsDescription": "Recibe novedades y avisos en tu correo.",
        "profileSyncConflicts": "Conflicto de sincronización de perfiles",
        "newReviews": "Nuevas reseñas",
        "newMessages": "Mensajes sin asignar",
        "newSurveyResponses": "Nuevas respuestas de encuestas",
        "performanceReports": "Informes de rendimiento",
        "performanceReportsDescription": "Accede a reportes periódicos sobre tu cuenta.",
        "smsNotifications": "Alertas SMS de quejas",
        "smsNotificationsDescription": "Recibe un SMS cuando un cliente deje una respuesta negativa.",
        "browserNotifications": "Notificaciones en el navegador",
        "browserNotificationsDescription": "Entérate de nuevos mensajes directamente en tu dispositivo.",
        "pushMessagesSnackbar": "Activa las notificaciones del navegador para recibir alertas de mensajes nuevos directamente en tu dispositivo. <0>{{enable}}</0>",
        "serviceWorkerUpdate": "Ya está disponible una nueva versión de Pluspoint. <0>{{refresh}}</0>",
        "bumpVersion": "Nueva versión disponible. Por favor, actualiza la página. <0>{{refresh}}</0>",
        "installApp": "Instalar aplicación",
        "installAppDescription": "Instala Pluspoint en tu dispositivo para un acceso rápido.",
        "installIosInstructions": "Abre esta página en Safari, toca el ícono de Compartir y luego \"Añadir a la pantalla de inicio\".",
        "installed": "Instalada"
    },
    "SettingsGeneral": {
        "apiDocumentation": "Documentación de la API",
        "accountNameOwnership": "Nombre de cuenta y propiedad",
        "linkTracking": "Seguimiento de enlaces",
        "linkTrackingDescription": "Vea en su analítica cuántos visitantes llegan a su sitio web desde sus fichas de Google, Facebook y los directorios. Pluspoint añade por usted las etiquetas de seguimiento al enlace del sitio web de cada ficha.",
        "trackingTagsEnabled": "Etiquetar los enlaces de las fichas",
        "trackingTagsSource": "utm_source",
        "trackingTagsMedium": "utm_medium",
        "trackingTagsCampaign": "utm_campaign",
        "trackingTagsContent": "utm_content",
        "trackingTagsPreview": "Ejemplo para una ficha de Google",
        "accountName": "Nombre de cuenta",
        "accountOwner": "Dueño de cuenta",
        "accountLocale": "Lugar",
        "billing": "Facturación",
        "upgradePluspointSubscription": "Mejorar mi suscripción de Pluspoint",
        "currentPlan": "Plan actual",
        "endsOn": "Termina en",
        "endedOn": "terminón en",
        "daysLeft_one": "día pendiente",
        "daysLeft_other": "días restantes",
        "upgradeDescription": "Seleccione el plan, el período de facturación y la cantidad de ubicaciones para proceder:",
        "numberOfCompanies": "Número de localizaciones",
        "annual": "Anual",
        "monthly": "Mensual",
        "proceedToPayment": "Proceder al pago",
        "pricePerCompany": "Precio por localización",
        "totalPrice": "Precio total",
        "month": "mes",
        "year": "año",
        "nextPaymentOn": "Próximo pago",
        "cancelsOn": "Cancela el",
        "upgradePlan": "Mejorar Plan",
        "changePlan": "Cambiar plan",
        "changeDescription": "Seleccione el plan de precios, el ciclo de facturación y el número de localizaciones y usuarios.",
        "numberOfUsers": "Número de usuarios",
        "onlineListings": "Listados",
        "reviewManagement": "Gestión de reseñas",
        "inboxAndLiveChat": "Bandeja de entrada y Live-chat",
        "socialPosting": "Publicaciones sociales",
        "microsites": "Micrositios",
        "analytics": "Analítica",
        "surveysAndTickets": "Encuestas y Tickets",
        "campaigns": "Campañas de mensajería",
        "additionalUsers": "Usuarios adicionales",
        "currentPrice": "Precio actual",
        "newPrice": "Nuevo precio",
        "dueToday": "A pagar hoy",
        "proratedOnNextInvoice": "Cargos prorrateados en la próxima factura",
        "pulseAICredits": "Pulse AI Créditos",
        "recurrentCredits": "Créditos recurrentes",
        "recurrentCreditsDescription": "Uso de los créditos recurrentes asignados. Se reinician al comienzo de cada ciclo de facturación.",
        "additionalCredits": "Créditos adicionales",
        "additionalCreditsDescription": "Créditos adicionales disponibles. No caducan y pueden usarse en cualquier momento.",
        "buyCredits": "Comprar créditos",
        "enableAutoPay": "Activar pago automático",
        "autoPayDescription": "Compra créditos automáticamente cuando tu saldo baje del límite establecido.",
        "creditsLeft": "{{amount}} créditos disponibles",
        "creditLimit": "Límite de crédito",
        "creditsToPurchase": "Créditos a comprar",
        "selectAccount": "Seleccionar cuenta",
        "twoMonthsFree": "2 meses gratis",
        "perLocationPer": "localización / {{period}}",
        "pluspointFeatureEverything": "Todas las funciones incluidas — sin niveles ni restricciones",
        "pluspointFeatureReviews": "Reseñas: supervise, responda y consiga más con IA",
        "pluspointFeatureInbox": "Bandeja de entrada omnicanal con chatbot de IA 24/7",
        "pluspointFeatureEngage": "Publicaciones sociales, campañas, encuestas y cupones",
        "pluspointFeatureAllowances": "{{users}} usuarios y {{credits}} créditos de IA / mes incluidos",
        "minimumLocations": "Mínimo {{count}} localizaciones",
        "usersIncluded": "{{count}} incluidos",
        "summaryPlan_one": "{{count}} localización",
        "summaryPlan_other": "{{count}} localizaciones",
        "summaryAdditionalUsers_one": "{{count}} usuario adicional",
        "summaryAdditionalUsers_other": "{{count}} usuarios adicionales",
        "billToSubscription": "Facturar a la suscripción",
        "directoriesNoneEnrolled": "Aún no hay localizaciones inscritas.",
        "directoriesManagedPerLocation": "Añada o cancele Directorios Locales para cada localización desde su página de gestión.",
        "openLocations": "Abrir localizaciones",
        "locationsEnrolled_one": "{{count}} localización activada",
        "locationsEnrolled_other": "{{count}} localizaciones activadas"
    },
    "SettingsCompanies": {
        "movedTitle": "Las localizaciones se han movido",
        "movedDescription": "Ahora puedes gestionar tus localizaciones desde el menú principal.",
        "goToLocations": "Ir a Localizaciones",
        "degree": "Título",
        "office": "Oficina",
        "menus": "Menús",
        "menuAssignmentFailed": "Localización guardada, pero no se pudo asignar el menú. Inténtalo de nuevo.",
        "headshotUrl": "Foto de perfil",
        "locationName": "Nombre de localización",
        "internalName": "Nombre interno",
        "primaryPhone": "Teléfono principal",
        "phoneExtension": "Ext.",
        "addChat": "Añadir chat",
        "email": "Correo electrónico de servicio",
        "website": "Sitio web",
        "contact": "Contacto",
        "additionalInformation": "Información adicional",
        "descriptionShort": "Descripción corta",
        "descriptionMedium": "Descripción media",
        "descriptionLong": "Descripción larga",
        "openingDate": "Fecha de apertura",
        "businessHours": "Horario",
        "specialHours": "Horario especial",
        "specialHoursNeedBusinessHours": "El horario especial necesita un horario comercial. Active el horario y abra al menos un día para añadir fechas.",
        "coverPhoto": "Foto de portada",
        "nationalHealthProviderId": "National Health Provider ID",
        "storeCode": "Código de tienda",
        "certifications": "Certificaciones",
        "categoriesAndServices": "Categorías y servicios",
        "address": "Dirección",
        "city": "Ciudad",
        "channels": "Canal",
        "pending": "Pendiente",
        "createChannel": "Añadir nuevo canal",
        "showAddress": "Mostrar la dirección de la empresa a los clientes",
        "locatedInToggle": "Localizado dentro de otro negocio",
        "locatedInNeedsPin": "Coloque el marcador en el mapa para buscar negocios cercanos",
        "locatedIn": "Localizado en",
        "relationIndependent": "Negocio independiente",
        "locatedInRelationLabel": "Relación",
        "relationDepartment": "Departamento",
        "viewOnGoogleMaps": "Ver en Google Maps",
        "addressLine1": "Dirección línea 1",
        "addressLine2": "Dirección línea 2",
        "postalCode": "Código postal",
        "state": "Región",
        "country": "País",
        "countryLockedByListings": "Bloqueado mientras los directorios estén conectados",
        "countryLockedByGoogle": "Bloqueado mientras haya una ficha de Google conectada",
        "pinFollowsGoogle": "El marcador del mapa sigue a su ficha de Google. Muévalo desde su Perfil de Empresa en Google",
        "publishedDirectories_one": "Publicado ({{count}} directorio)",
        "publishedDirectories_other": "Publicado ({{count}} directorios)",
        "optimizationScore": "Puntuación de optimización",
        "optimizationScoreTooltip": "Mide qué tan bien optimizada está tu localización para la búsqueda en línea, según la completitud de los campos del perfil. Las puntuaciones más altas mejoran la visibilidad.",
        "integrationName": "Nombre de integración",
        "disconnectIntegration": "¿Desconectar la integración activa?",
        "disconnectIntegrationMessage": "No podrá recopilar reseñas a través de Pluspoint en esta plataforma y ver análisis. ¿Desea continuar?",
        "integrations": "Integraciones",
        "onlineProfiles": "Perfiles en línea",
        "socialLinks": "Enlaces sociales",
        "managedByConnection": "Gestionado por la conexión",
        "connected": "Conectado",
        "notConnected": "No conectado",
        "published": "Publicado",
        "notPublished": "No publicado",
        "generalInfo": "Información general",
        "profileURL": "URL de perfil",
        "uberEatsReviewsHint": "Uber Eats publica solo una selección de las reseñas de 5 estrellas de cada local. Los recuentos y promedios en Pluspoint reflejan esa selección.",
        "bookingExtranetLink": "Enlace de la Extranet de Booking.com",
        "bookingExtranetHint": "Opcional. Pegue cualquier enlace de la Extranet de esta propiedad (admin.booking.com) o el ID de la propiedad. Las respuestas abrirán directamente la página de reseñas de la Extranet.",
        "connectIntegration": "Conectar integración",
        "editProfile": "Editar perfil",
        "reviewPlatforms": "Plataformas de reseñas",
        "addReviewPlatform": "Añadir plataforma de reseñas",
        "connectIntegrationMsg": "Perfil conectado",
        "locationPublishedMsg": "Localización publicada. Los cambios pueden tardar varios días en aparecer en los sitios externos.",
        "profileDisconnected": "Perfil desconectado",
        "atLeastOneProfile": "Al menos una integración debe estar habilitada",
        "selectLocation": "Seleccione localización",
        "connectLocation": "Conectar localización",
        "goToIntegrations": "Ir a integraciones",
        "importCompanies": "Importar localización",
        "importCompaniesCount": "Importar {{count}} localización(es)",
        "selectCompanies": "Seleccione las ubicaciones que desea importar desde su cuenta de Google:",
        "linkedTo": "Enlazado a",
        "googleAutocomplete": "Buscar negocio en Google",
        "addLocationTitle": "Agregar nueva ubicación",
        "addLocationDescription": "Busque la localización de Google que le gustaría agregar a Pluspoint y haga clic en Agregar ubicación.",
        "connectDrawerDescription": "Seleccione un elemento apropiado de la lista para vincularlo a la localización.",
        "connectDrawerNotConnected": "Integración no conectada",
        "connectDrawerNotConnectedDescription": "Conecte su cuenta en los ajustes de integración para continuar (se requieren permisos del 'Global Admin').",
        "iFoodPendingTitle": "Conexión con iFood en proceso",
        "iFoodPendingDescription": "La solicitud de conexión se ha enviado a iFood. Podrá vincular las localizaciones cuando iFood conceda el acceso.",
        "title": "Gestione todas sus localizaciones en un solo lugar",
        "subtitle": "Mantenga los datos del negocio, horarios, direcciones e información de contacto precisos y consistentes en todas sus localizaciones. Añada nuevas localizaciones, edite en lote o importe desde Google — todo lo que necesita para mantenerse organizado.",
        "additionalPhone": "Teléfono adicional",
        "additionalPhones": "Teléfonos adicionales",
        "addPhone": "Añadir teléfono",
        "geoModifier": "Geomodificador",
        "addFeatureMessage": "Agregar mensaje destacado",
        "healthcareFacility": "Centro de salud",
        "healthcareProfessional": "Profesional sanitario",
        "hotel": "Hotel",
        "restaurant": "Restaurante",
        "listingDirectories": "Directorio de Listados",
        "listingDirectoriesDescription": "Publique y sincronice su localización en más de 200 directorios.",
        "findOnGoogle": "Buscar en Google",
        "enterManually": "Ingresar manualmente",
        "googleAccountRequired": "Conecta tu cuenta de Google en los ajustes de integración para continuar",
        "facebookAccountRequired": "Conecta tu cuenta de Facebook en los ajustes de integración para continuar",
        "tiktokAccountRequired": "Conecta tu cuenta de TikTok en los ajustes de integración para continuar",
        "xAccountRequired": "Conecta tu cuenta de X en los ajustes de integración para continuar",
        "whatsappAccountRequired": "Conecta tu cuenta de WhatsApp en los ajustes de integración para continuar",
        "createGoogleProfileTitle": "Crear perfil en Google",
        "createGoogleProfileDescription": "Elige en qué cuenta de Google y grupo de localizaciones se debe crear esta ficha.",
        "googleAccount": "Cuenta de Google",
        "googleLocationGroup": "Grupo de localizaciones",
        "selectAccountToLink": "Elige en qué cuenta conectada publicará esta localización.",
        "account": "Cuenta",
        "localDirectories": "Directorios Locales",
        "addLocalDirectories": "Añadir Directorios Locales",
        "cancelLocalDirectories": "Cancelar Directorios Locales",
        "cancelLocalDirectoriesDescription": "La publicación continúa hasta el final del periodo que ha pagado; después se retiran los listados de esta localización. No se emiten reembolsos.",
        "directoriesValueCopy": "Publique esta localización en más de 200 directorios — de Apple Maps y Bing a TripAdvisor y Yelp — y mantenga horarios, fotos y datos sincronizados automáticamente. Los datos consistentes en todas partes son la base de la búsqueda local y de las respuestas de IA como ChatGPT: así le encuentran primero y gana más clientes.",
        "directoriesPromoTitle": "Aparezca en más de 200 directorios locales",
        "directoriesPromoDescription": "Publique {{location}} en más de 200 directorios — Apple Maps, Bing, TripAdvisor, Yelp y más — con los datos siempre sincronizados. Aparezca primero en la búsqueda local y en respuestas de IA como ChatGPT.",
        "seeAllDirectories": "Ver todos los directorios",
        "perLocation": "por localización",
        "directoriesMinimumTermNotice": "Se puede cancelar después de 3 meses.",
        "chargedTodayProrated": "Cargo de hoy (prorrateado)",
        "thenFrom": "Después desde {{date}}",
        "addForToday": "Añadir por {{amount}} hoy",
        "subscribeAndAddLocation": "Suscribirse y añadir esta localización",
        "directoriesRequiresSubscription": "Directorios Locales requiere una suscripción activa. Suscríbase a su plan y añada esta localización en un solo paso.",
        "directoriesSinceCancellableAfter": "Publicando desde {{since}} · cancelable después del {{cancellableAfter}}",
        "directoriesCancellableAfter": "Cancelable después del {{date}}",
        "directoriesEndsOn": "Publicando hasta el {{date}}",
        "directoriesIncludedInPlan": "Incluido en su plan",
        "viewListings": "Ver directorios",
        "directoriesAddedMsg": "Directorios Locales añadido. La publicación ha comenzado.",
        "directoriesCancelledMsg": "Directorios Locales cancelado. La publicación continúa hasta el final de su periodo pagado."
    },
    "ScorePanel": {
        "recommendations": "Recomendaciones",
        "allDone": "Todo lo que cuenta para la puntuación está completo",
        "suggest": "Sugerir",
        "write": "Redactar",
        "dismiss": "Descartar",
        "replace": "Reemplazar",
        "undo": "Deshacer",
        "waitForAi": "Espera a que Pulse AI termine",
        "thinking": "Pulse AI está trabajando en ello…",
        "failed": "No se pudieron generar sugerencias. Inténtalo de nuevo.",
        "noSuggestions": "Pulse AI no tiene sugerencias para esta localización.",
        "reviewBeforeSave": "Revísala en el formulario. No se guarda nada hasta que selecciones Guardar.",
        "aiServices": "Pulse AI · según tus categorías y descripción",
        "aiCategories": "Pulse AI · según los datos de tu negocio",
        "aiSpecialHours": "Pulse AI · festivos en {{country}}",
        "aiDescription": "Pulse AI · descripción sugerida",
        "specialHoursNote": "Las fechas se añaden como Cerrado. Cambia una fecha a Abierto e indica su horario si abres ese día.",
        "addServices_zero": "Añadir servicios",
        "addServices_one": "Añadir {{count}} servicio",
        "addServices_other": "Añadir {{count}} servicios",
        "addCategories_zero": "Añadir categorías",
        "addCategories_one": "Añadir {{count}} categoría",
        "addCategories_other": "Añadir {{count}} categorías",
        "addDates_zero": "Añadir fechas",
        "addDates_one": "Añadir {{count}} fecha",
        "addDates_other": "Añadir {{count}} fechas",
        "drafted": {
            "shortDescription": "Descripción corta redactada",
            "mediumDescription": "Descripción media redactada",
            "longDescription": "Descripción larga redactada"
        },
        "rec": {
            "locationName": "Añade el nombre de la localización",
            "practitioner": "Completa los datos del profesional",
            "certifications": "Añade una certificación",
            "phone": "Añade un número de teléfono",
            "email": "Añade un email",
            "website": "Añade un sitio web",
            "address": "Completa la dirección",
            "workingHours": "Configura el horario",
            "specialHours": "Añade un horario especial",
            "shortDescription": "Añade una descripción corta",
            "mediumDescription": "Añade una descripción media",
            "longDescriptionAdd": "Añade una descripción larga",
            "longDescriptionExtend": "Amplía la descripción larga",
            "openingDate": "Añade la fecha de apertura",
            "engagement": "Añade un mensaje destacado",
            "categoriesAdd": "Añade una categoría",
            "categoriesMore": "Añade otra categoría",
            "servicesAdd": "Añade servicios",
            "servicesMore": "Añade más servicios",
            "paymentMethods": "Selecciona métodos de pago",
            "logo": "Sube un logo",
            "cover": "Sube una foto de portada",
            "socialAdd": "Añade un enlace social",
            "socialMore": "Añade otro enlace social"
        }
    },
    "SettingsChannels": {
        "historyImportRunning": "Importando chats anteriores…",
        "historyImportCompleted": "Chats anteriores importados",
        "historyImportDeclined": "Chats anteriores no compartidos",
        "historyImportFailed": "No se pudieron importar los chats anteriores o los contactos",
        "headerTitle": "Gestionar tus canales",
        "headerSubtitle": "Conecte todos sus canales de comunicación para ofrecer una experiencia de cliente coherente desde un único panel",
        "firstStepTitle": "Añadir nuevo canal",
        "firstStepSubtitle": "Selecciona que tipo de canal te gustaría añadir",
        "createChannelTitle": "Añada un nuevo canal de {{channelType}}",
        "editChannelTitle": "Editar canal de {{channelType}}",
        "editChannelSubtitle": "Ofrezca asistencia instantánea a sus clientes con la integración del {{channelType}}",
        "linkChannelToLocation": "Vincular este canal a una localización o marca",
        "channelName": "Nombre de canal",
        "senderId": "ID remitente",
        "provider": "Proveedor",
        "accountSid": "Account SID",
        "authToken": "Auth token",
        "apiToken": "HTTP API Token",
        "customGateway": "Pasarela personalizada",
        "whatsAppNumber": "Número WhatsApp",
        "senderIdNotice": "El ID del remitente identifica al remitente de un mensaje SMS. Puede tener hasta 11 caracteres, incluidas letras mayúsculas y minúsculas, los dígitos del 0 al 9 y espacios.",
        "isNewWhatsAppAcc": "¿Nueva cuenta de WhatsApp?",
        "whatsAppSuccess": "WhatsApp conectado!",
        "whatsAppFail": "Número ya existente en esta cuenta",
        "whatsAppTooltip": "Habilite esta opción si su número de WhatsApp se registró hace menos de 30 días para reducir la probabilidad de que lo bloqueen al enviar mensajes masivos automáticos. Si está habilitado, Pluspoint establece un límite para los mensajes enviados a través de este canal a 2 solicitudes por día. Este límite se incrementa gradualmente en 1,5 veces cada día (por ejemplo, 2, 3, 5, 7, 10, etc.)",
        "whatsAppInstruction1": "1. Abra WhatsApp en el teléfono con el número proporcionado",
        "whatsAppInstruction2": "2. Toca <strong>{{settings}}</strong> y luego <strong>{{qrIcon}}</strong>",
        "qrIcon": "QR icono",
        "whatsAppInstruction3": "3. toca en <strong>{{scan}}</strong> y dirige tu movila ese punto",
        "scan": "Escanea",
        "pending": "Pendiente",
        "welcomeTagline": "Mensaje de bienvenida",
        "businessHoursSwitch": "Activar el horario comercial",
        "offlineMessage": "Mensaje offline",
        "widgetPosition": "Posición del widget de chat en vivo",
        "widgetOffsetX": "Desplazamiento horizontal (px)",
        "widgetOffsetY": "Desplazamiento vertical (px)",
        "addCodeBelow": "Agregue el código a la sección principal del HTML de tu sitio web.",
        "messagesTab": "Mensajes",
        "contactDetailsHint": "Se piden en el chat después del primer mensaje del visitante. Al menos uno de los campos, correo electrónico o teléfono, debe ser obligatorio.",
        "assignLocationSwitch": "Asignar las conversaciones a una localización",
        "assignLocationHint": "Cada conversación se asigna a una localización. Cuando hay más de una localización en la lista, se pide a los visitantes que elijan la localización con la que contactan.",
        "allLocationsCount": "Todas las localizaciones ({{number}})",
        "selectedLocations": "Localizaciones seleccionadas",
        "reachVisitorsTitle": "Contactar con los visitantes que se fueron",
        "missedRepliesSwitch": "Avisar de las respuestas no vistas",
        "missedRepliesHint": "Cuando un agente responde después de que el visitante cerró la página, este recibe una breve nota con un enlace para volver al chat.",
        "followUpRequiresContact": "Requiere que el correo electrónico o el teléfono sea obligatorio",
        "followUpChannelCleared": "El canal seleccionado ya no coincide con los campos de contacto; elija otro",
        "followUpChannelUnavailable": "El canal de seguimiento está desconectado o eliminado; elija otro",
        "followUpChannelOtherTeam": "Un canal de otro equipo",
        "welcomeButtons": "Botones",
        "welcomeButton": "Botón {{number}}",
        "addButton": "Añadir botón",
        "welcomePopupSwitch": "Mostrar el mensaje de bienvenida junto al botón del chat automáticamente",
        "welcomePopupHint": "Aparece unos segundos después de cargar la página, una vez por visitante. En el móvil, o si está desactivado, los visitantes lo ven al abrir el chat.",
        "showOfflineMessage": "Mostrar el mensaje offline",
        "offlineHoursHint": "Se publica en el chat fuera del horario indicado abajo. Las horas están en su zona horaria, {{timeZone}}.",
        "websiteWidget": "Widget del sitio web",
        "chatLink": "Enlace del chat",
        "chatLinkHint": "Abre este chat en una página alojada. Compártalo como enlace o código QR donde no se pueda instalar el widget: menús, recibos, firmas de correo, perfiles sociales.",
        "chatLinkParams": "Añada ?locationId= con el ID de una localización para omitir la pregunta de la localización, ?language= con un código de idioma para abrir el chat en ese idioma, o ?start= con un mensaje para rellenar el primer mensaje del visitante.",
        "allowedSites": "Sitios permitidos",
        "allowedSitesHint": "Dominios en los que puede aparecer el widget, subdominios incluidos. Deje la lista vacía para permitir cualquier sitio. Sus micrositios y el enlace del chat siempre están permitidos.",
        "allowedSiteInvalid": "Introduzca un dominio como example.com",
        "signedInCustomers": "Clientes con sesión iniciada",
        "signingSecretHint": "Firme los datos del cliente en su servidor con este secreto para que los clientes que hayan iniciado sesión en su sitio omitan el formulario.",
        "signingSecret": "Secreto de firma",
        "replaceSecretTitle": "¿Reemplazar el secreto de firma?",
        "replaceSecretBody": "Los datos firmados con el secreto actual dejan de aceptarse de inmediato. Actualice su sitio web con el nuevo secreto.",
        "followUpWarning": "Aviso",
        "logoUrl": "URL del logotipo",
        "smtpHost": "SMTP Host",
        "smtpPort": "SMTP Port",
        "username": "Nombre de usuario",
        "encryption": "Método de cifrado",
        "saveInstagramReplies": "Recibir menciones en la historia",
        "createNewChannel": "Crear nuevo canal",
        "enableIncomingEmail": "Recibir correos en la bandeja de entrada (IMAP)",
        "enableIncomingEmailHint": "Recibir y responder correos de clientes directamente desde la bandeja de entrada",
        "imapHost": "IMAP Host",
        "imapPort": "IMAP Port",
        "imapUsername": "Usuario IMAP",
        "imapUsernamePlaceholder": "Dejar vacío para usar el usuario SMTP",
        "imapPassword": "Contraseña IMAP",
        "imapPasswordPlaceholder": "Dejar vacío para usar la contraseña SMTP",
        "signature": "Firma de correo electrónico",
        "facebookPage": "Página de Facebook",
        "hostedEmailSubtitle": "Envía campañas, encuestas y respuestas del Inbox desde una dirección de tu propio dominio.",
        "receiveEmailsInInbox": "Recibir correos en Inbox",
        "forwardingAddress": "Dirección de reenvío",
        "receiveRepliesHint": "Reenvía {{email}} a esta dirección desde tu proveedor de correo. Las respuestas aparecen en Inbox y las contestas desde aquí.",
        "fromNameHint": "Se muestra como nombre del remitente",
        "emailAddress": "Dirección de correo",
        "emailAddressLocked": "La dirección no se puede cambiar después de crear el canal",
        "returnPathSubdomain": "Subdominio Return-Path",
        "customReturnPath": "Usar un subdominio Return-Path personalizado",
        "customReturnPathHint": "Los correos rebotados vuelven a través de este subdominio. Cambia el predeterminado solo si tu dominio ya lo usa.",
        "returnPathSubdomainReused": "{{domain}} ya está conectado. La nueva dirección comparte sus registros DNS y su subdominio Return-Path.",
        "returnPathSubdomainInvalid": "Usa solo letras, dígitos y guiones",
        "verifyDomainTitle": "Verificar {{domain}}",
        "verifyDomainSubtitle": "Añade estos registros en tu proveedor de DNS. El canal estará disponible cuando todos estén verificados.",
        "dnsRecordsHint": "Estos dos registros DNS verifican que el dominio es tuyo y permiten que los proveedores de correo confíen en tus mensajes. El registro TXT firma tus correos; el CNAME gestiona los rebotes.",
        "dnsPropagationNote": "Nota: los cambios de DNS pueden tardar hasta 48 horas en propagarse.",
        "showDnsRecords": "Mostrar registros DNS",
        "hideDnsRecords": "Ocultar registros DNS",
        "recordVerified": "Verificado",
        "statusSuspended": "Suspendido",
        "domainSuspended": "El envío desde este dominio está suspendido. Contacta con soporte para reanudarlo.",
        "ringCentralAccount": "Cuenta de RingCentral",
        "ringCentralNumber": "Número de RingCentral",
        "ringCentralNoNumbers": "Este usuario de RingCentral no tiene ningún número que pueda enviar SMS",
        "ringCentralNumbersInUse": "Todos los números de esta cuenta de RingCentral ya los usa otro canal",
        "ringCentralDisconnected": "La cuenta de RingCentral de este canal está desconectada. Vuelve a conectarla en <0>{{link}}</0> para reanudar los envíos.",
        "ringCentralIntegrations": "Integraciones"
    },
    "SettingsUsers": {
        "addedOn": "Añadido",
        "lastLogin": "Último inicio de sesión",
        "generalInfo": "Información general",
        "editUser": "Editar usuario",
        "accessLevel": "Nivel de acceso",
        "owner": "Propietario",
        "global": "Global",
        "role": "Rol",
        "superAdmin": "Super admin",
        "admin": "Administrador",
        "user": "Usuario",
        "permissions": "Permisos",
        "permissionsDescription": "Seleccione un rol: Los super administradores pueden cambiar la configuración global y gestionar las integraciones de la cuenta. Los administradores pueden configurar localizaciones, encuestas, plantillas y campañas, normalmente para jefes de departamento o propietarios de negocios. Los usuarios gestionan las actividades empresariales diarias, adecuado para el personal operativo.",
        "accessDescription": "Seleccione un nivel de acceso: Global da acceso a toda la organización, Marca permite el acceso a un grupo seleccionado de localizaciones, y Localización da acceso únicamente a localizaciones específicas.",
        "globalAccess": "Nivel de acceso global",
        "brandAccess": "Nivel de acceso por marca",
        "locationAccess": "Nivel de acceso basado en la localización"
    },
    "SettingsTeams": {
        "createTeam": "Crear equipo",
        "editTeam": "Editar equipo",
        "teamName": "Nombre del equipo",
        "permissions": "Permisos",
        "permissionsDescription": "Controla lo que cada equipo puede hacer. Restringido permite ver y realizar acciones básicas, mientras que Completo habilita edición, creación y gestión dentro de cada módulo. La configuración de cuenta también se puede establecer en Ninguno para ocultar los ajustes por completo.",
        "restricted": "Restringido",
        "full": "Completo",
        "none": "Ninguno",
        "noneTooltip": "Sin acceso: la función queda oculta para este equipo",
        "globalPermission": "Global",
        "scope": "Alcance",
        "scopeDescription": "Define a qué localizaciones puede acceder este equipo. Global da acceso a todas las localizaciones, Marca limita el acceso a las localizaciones de las marcas seleccionadas y Localización restringe el acceso solo a localizaciones específicas.",
        "scopeScopedOnlyNote": "El alcance se aplica solo a los permisos con alcance. Los permisos globales (Contactos, Configuración de cuenta) siempre cubren toda la cuenta.",
        "members": "Miembros",
        "membersDescription": "Seleccione usuarios para agregar a este equipo. Los miembros pueden cambiarse después.",
        "addMember": "Añadir miembro",
        "enabledPermissionsCount": "{{count}} permisos",
        "messagingRestricted": "Ver, Responder, Reasignar, Resolver/Reabrir, Exportar, Analíticas",
        "messagingFull": "Agentes de IA, Base de conocimiento",
        "accountSettings": "Configuración de cuenta",
        "tooltipRestricted": "Restringido",
        "tooltipFull": "Completo",
        "contactsRestricted": "Ver todos los contactos de la cuenta",
        "contactsFull": "Crear, Editar, Eliminar, Acciones masivas, Importar, Exportar",
        "locationsRestricted": "Ver localizaciones y perfiles, Subir/Eliminar medios, Exportar CSV",
        "locationsFull": "Agregar/Importar localizaciones, Editar, Eliminar, Edición masiva, Exportar/Importar, Sincronizar, Analíticas",
        "reviewsRestricted": "Ver, Responder reseñas, Usar plantillas, Analíticas, Widgets",
        "reviewsFull": "Gestionar respuestas automáticas y plantillas de respuesta",
        "postsRestricted": "Ver publicaciones, Analíticas",
        "postsFull": "Crear, Editar, Eliminar, Programar publicaciones",
        "micrositesRestricted": "Ver páginas web",
        "micrositesFull": "Crear, Editar, Eliminar páginas web",
        "surveysRestricted": "Ver respuestas, Conversaciones, Tickets, Ver plantillas",
        "surveysFull": "Gestionar plantillas de encuestas",
        "campaignsRestricted": "Ver campañas",
        "campaignsFull": "Crear, Editar, Eliminar campañas",
        "couponsRestricted": "Ver cupones",
        "couponsFull": "Crear, Editar, Eliminar cupones",
        "settingsNoneTooltip": "Solo página de perfil",
        "settingsRestrictedTooltip": "Gestión de usuarios: invitar, editar, eliminar usuarios",
        "settingsFullTooltip": "Todos los ajustes: General, Facturación, Marcas, Usuarios, Equipos, Canales, Integraciones"
    },
    "SettingsBrands": {
        "title": "Organiza tus localizaciones con marcas",
        "subtitle": "Administra fácilmente múltiples localizaciones agrupándolas bajo una sola marca. Centraliza tus mensajes, reseñas, campañas y encuestas para una gestión simplificada en todas tus localizaciones.",
        "editBrand": "Editar marca",
        "shared": "Compartido",
        "gradient": "Degradado",
        "solid": "Sólido",
        "sharp": "Afilados",
        "softlyRounded": "Suavemente redondeados",
        "rounded": "Redondeados",
        "fontColor": "Color de fuente",
        "automaticallyAssignBrand": "Asignar automáticamente a nuevas localizaciones",
        "brandIsAlreadyAssigned": "Ya hay una marca predeterminada configurada",
        "createNewBrand": "Crear nueva marca",
        "previewDisclaimer": "Esto es solo una demostración de cómo se ve tu marca para los clientes."
    },
    "ShowcaseWidgets": {
        "title": "Reseña de cliente",
        "subtitle": "Muestre comentarios positivos de sus clientes en su página web utilizando nuestros widgets.",
        "popup": "Pop-up",
        "grid": "Grid",
        "popupWidget": "Pop-up widget",
        "gridWidget": "Grid widget",
        "reviewsSorting": "Clasificación de reseñas",
        "random": "Al azar",
        "recent": "Mas recientes",
        "reviewsToShow": "Total de reseñas a ver",
        "reviewsMode": "Qué reseñas mostrar",
        "topRatedReviews": "Reseñas de 5 estrellas con comentarios",
        "featuredReviews": "Reseñas destacadas",
        "noFeaturedReviews": "Aún no hay reseñas destacadas. Marque reseñas como destacadas en la página de reseñas",
        "widgetPosition": "Posición del widget",
        "widgetCode": "Código widget",
        "addCodeSubtitle": "Agregue el código al HTML de su sitio web donde desea mostrar el widget."
    },
    "Sidebar": {
        "bookmarks": "Marcadores",
        "addBookmark": "Añadir a marcadores",
        "removeBookmark": "Quitar de marcadores",
        "home": "Home",
        "responses": "Todas las respuestas",
        "templates": "Plantillas",
        "surveys": "Encuestas",
        "surveysQrOnly": "Códigos QR",
        "analytics": "Analitica",
        "analyticsConversion": "Conversión",
        "analyticsNpsOverview": "Resumen de NPS",
        "analyticsSurveyInsights": "Información de encuestas",
        "analyticsSurveys": "NPS y encuestas",
        "analyticsConversations": "Conversaciones",
        "analyticsPresence": "Presencia",
        "analyticsSocialPosts": "Publicaciones redes sociales",
        "performance": "Rendimiento",
        "insights": "Información operativa",
        "reviews": "Reseñas",
        "reviewsManage": "Todas las reseñas",
        "reviewsTemplates": "Plantilla de respuesta",
        "reviewsAutoreplies": "Auto-respuesta",
        "reviewsAutomation": "Automatización",
        "microsites": "Micrositios",
        "messaging": "Mensajería",
        "messagingInbox": "Bandeja de entrada",
        "reviewsWidgets": "Widgets",
        "social": "Social",
        "socialPosts": "Publicaciones",
        "profile": "Perfil",
        "helpCenter": "Centro de ayuda",
        "logout": "Cerrar sesión",
        "switchAccount": "Cambiar de cuenta",
        "accountMenu": "Menú de la cuenta",
        "ordersIfood": "Pedidos",
        "campaigns": "Campañas",
        "campaignsAutomated": "Automatizadas",
        "campaignsOneTime": "Únicas",
        "contacts": "Contactos",
        "presence": "Presencia",
        "presenceProfiles": "Perfiles",
        "presenceMedia": "Fotos y vídeos",
        "locations": "Localizaciones",
        "locationsManage": "Gestionar localizaciones",
        "locationsProfiles": "Perfiles",
        "locationsMedia": "Fotos y Videos",
        "visibilityScanner": "Escáner de visibilidad",
        "pulseAI": "Pulse AI",
        "knowledgeBase": "Base de conocimientos",
        "agents": "Agentes",
        "referral": "Programa de referidos",
        "coupons": "Cupones",
        "expand": "Expandir",
        "collapse": "Contraer",
        "webPages": "Páginas web",
        "menus": "Menús",
        "forms": "Formularios",
        "campaignsLibrary": "Biblioteca"
    },
    "SignupPage": {
        "title": "Crear cuenta gratuita",
        "description": "Empieza a gestionar tus localizaciones, reseñas y conversaciones con clientes desde un único panel.",
        "alreadyRegistered": "¿Ya tienes una cuenta? <0>{{link}}</0>",
        "logIn": "Acceso",
        "or": "o",
        "terms": "Términos de uso",
        "privacy": "Política de Privacidad",
        "dpa": "Acuerdo procesado de datos",
        "termsConditions": "Usando Pluspoint aceptas <0>{{terms}}</0> <1>{{privacy}}</1> Y <2>{{dpa}}</2>",
        "confirmationTitle": "Revisa tu bandeja de email",
        "confirmationDescription": "Hemos enviado un correo electrónico de confirmación. Asegúrese de revisar el no deseado, en caso de que no pueda encontrarlo en su bandeja de entrada",
        "returnToHomepage": "Regresar a inicio",
        "signupWithGoogle": "Regístrese con Google",
        "signupWithGoogleCaption": "Asegúrese de seleccionar las casillas de verificación para una funcionalidad completa"
    },
    "Table": {
        "allOnPageSelected": "Seleccionados los {{selected}} {{entity}} de esta página.",
        "selectAll": " Selecciona los {{data}} {{entity}}",
        "allDataSelected": "Los {{data}} {{entity}} seleccionados.",
        "clearSelection": " Limpiar selección.",
        "moreThan": "Más de",
        "of": "De",
        "rowsPerPage": "Filas por página"
    },
    "FeedbackToolbar": {
        "reviewsTicketToggle": "Mostrar solo comentarios sin tickets",
        "createTicket": "Crear ticket",
        "viewTicket": "Ver ticket",
        "ticketAssignedTo": "Ticket asignado a:",
        "ticketStatus": "Estado del ticket:",
        "completed": "Completed",
        "empty": "Vacio",
        "price": "Precio",
        "quality": "Calidad",
        "cleanliness": "Limpieza",
        "communication": "Comunicación",
        "ticketDescription": "Descripción del ticket"
    },
    "AuthLayout": {
        "title": "Toma el control de tu <0>{{reputation}}</0>",
        "onlineReputation": "reputación online",
        "block1Title": "Impulsa tus reseñas",
        "block1Description": "Convierte clientes satisfechos en promotores con solicitudes automáticas de reseñas.",
        "block2Title": "Ahorra tiempo",
        "block2Description": "Gestiona reseñas, mensajes y publicaciones desde un único panel.",
        "block3Title": "Haz crecer tu presencia online",
        "block3Description": "Gana visibilidad publicando tu negocio en más de 200 plataformas."
    },
    "validation": {
        "minPasswordLength": "Tu contraseña debe contener como mínimo 8 caracteres",
        "wrongPasswordFormat": "Tu contraseña debe contener números y letras",
        "confirmPasswordMatch": "Las contraseñas no coinciden, prueba otra vez",
        "minLength4": "Este campo debe tener al menos 4 caracteres",
        "minLength8": "Este campo debe tener al menos 8 caracteres",
        "wrongEmailFormat": "Por favor, introduce una dirección email válida",
        "wrongFile": "Formato de archivo incorrecto",
        "maxLength": "Este campo debe tener máximo {{count}} caracteres",
        "trackingTagSlug": "Use letras minúsculas, dígitos y guiones",
        "trackingTagPaidMedium": "La analítica contaría este medio como tráfico de pago",
        "trackingTagShoppingCampaign": "La analítica contaría esta campaña como tráfico de compras",
        "numberRange": "Introduce un valor entre {{min}} y {{max}}",
        "descriptionContainsUrl": "No se permiten enlaces en la descripción",
        "hexFormat": "Debe estar en formato HEX",
        "onlyAlphanumericSpace": "Solo debería contener letras, números y espacios",
        "onlyNumbers": "Solo debería contener números",
        "invalidURL": "URL invalida",
        "takenURL": "No disponible",
        "required": "Campo requerido",
        "wrongPhoneFormat": "Debe estar en un formato internacional.",
        "specialHoursNeedBusinessHours": "Quite las fechas especiales o active el horario comercial",
        "specialHoursDuplicateDate": "Esta fecha ya está en la lista. Deje una sola entrada por fecha",
        "specialHoursReversedRange": "Un rango horario debe terminar después de empezar",
        "duplicatePhone": "Este número ya está en la lista",
        "timeRangeExceeded": "Rango de tiempo excedido",
        "completeAllFields": "Complete los campos obligatorios para continuar",
        "platformWithoutDirectCompany": "Cada plataforma seleccionada necesita al menos una localización conectada directamente",
        "unsupportedPlaceholders": "Marcador(es) no compatible(s): {{tokens}}",
        "dateOfBirthOutOfRange": "Introduzca una fecha desde 1900 que no sea futura"
    },
    "VerifyEmail": {
        "message": "Su correo electrónico no está verificado. Hemos enviado las instrucciones de verificación a {{email}}. Si no puede encontrar el correo electrónico de verificación, consulte la carpeta de correo no deseado. También puede reenviar el correo electrónico haciendo clic en <1>{{link}}</1>.",
        "link": "REENVIAR EMAIL DE VERIFICACIÓN",
        "resendSuccess": "Email reenviado correctamente",
        "resendFail": "Se borrará tu plantilla guardada"
    },
    "IfoodOrders": {
        "accountId": "Account ID",
        "createdAt": "Creado en",
        "customerName": "Cliente",
        "customerPhoneNumber": "Móvil cliente",
        "merchant": "Comerciante",
        "orderId": "ID de orden",
        "orderType": "Tipo de orden",
        "paymentInformation": "Información de pago",
        "expireAt": "expira en:"
    },
    "InboxPage": {
        "sentFromWhatsAppBusinessApp": "Aplicación WhatsApp Business",
        "sentFromWhatsAppApp": "Aplicación WhatsApp",
        "sentFromMetaBusinessSuite": "Meta Business Suite",
        "sentFromExternalApp": "Aplicación externa",
        "unsupportedMessage": "Este mensaje no se puede mostrar aquí. Consúltalo en la aplicación WhatsApp Business.",
        "mediaNotImported": "Foto o archivo no importado",
        "viewFullContact": "Ver contacto completo",
        "conversationsCount_one": "{{count}} conversación",
        "conversationsCount_other": "{{count}} conversaciones",
        "viewDetails": "Ver detalles",
        "createdAt": "Creada",
        "resolvedAt": "Resuelta",
        "pulseAgent": "Pulse",
        "views": "Vistas",
        "myConversations": "Mis conversaciones",
        "allConversations": "Todas las conversaciones",
        "moveToTeam": "Mover a equipo",
        "moveToTeamTitle": "Mover a otro equipo",
        "moveToTeamDescription": "La conversación y todo su historial se mueven con ella. El otro equipo recibirá una notificación.",
        "moveToTeamAssigneeKept": "{{name}} es miembro de {{team}} y seguirá asignado.",
        "moveToTeamAssigneeCleared": "{{name}} no es miembro de {{team}}. La conversación quedará sin asignar y se colocará en la cola de ese equipo.",
        "internalNoteOptional": "Nota interna (opcional)",
        "internalNote": "Nota interna",
        "teamChangedBy": "{{date}} — {{name}} movió esta conversación de {{fromTeam}} a {{toTeam}}",
        "teamChangedAuto": "{{date}} — La conversación se movió de {{fromTeam}} a {{toTeam}} tras un cambio de equipo del canal",
        "deletedTeam": "un equipo eliminado",
        "conversationAssignedToUser": "Esta conversación está asignada a {{name}}. Puedes unirte para interactuar directamente con el cliente.",
        "movedToTeam": "Conversación movida a {{team}}",
        "allStatuses": "Estatus",
        "open": "Abiertas",
        "resolved": "Resueltas",
        "viewContact": "Ver contacto",
        "messageLabel": "Escribe tu mensaje aquí",
        "noConversations": "No hay conversaciones.",
        "noConversationsSelected": "Seleccione una conversación del panel izquierdo.",
        "resolvedBy": "{{date}} — Resuelta por {{name}}",
        "reopenedBy": "{{date}} — Reabierta por {{name}}",
        "conversationStarted": "{{date}} — Conversación iniciada",
        "download": "Descargar",
        "resend": "Reenviar",
        "emptyChannelsTitle": "Todas sus conversaciones en un solo lugar",
        "emptyChannelsSubtitle": "Vea todas las conversaciones de clientes en un único panel. Conecte canales como el chat en vivo de su web, Facebook, Instagram o WhatsApp.",
        "emptyChannelsButton": "Conectar canales",
        "storyNotAvailable": "La historia ya no está disponible",
        "showQuotedText": "Mostrar texto citado",
        "hideQuotedText": "Ocultar texto citado",
        "mine": "Mías",
        "unassigned": "No asignadas",
        "archivedConversation": "Esta conversación es de un canal eliminado. No puedes reabrirla ni recibir nuevos mensajes.",
        "importedConversation": "Esta conversación se importó de la aplicación WhatsApp Business. No puedes reabrirla; inicia una nueva conversación para escribir al contacto.",
        "disconnectedChannel": "Esta conversación es de un canal desconectado. Por favor, vuelve a conectar el canal en los <0>{{link}}</0>.",
        "settings": "ajustes",
        "liveChatVisitorUnreachable": "No se puede contactar con este visitante cuando se va. Elija un canal de seguimiento en los <0>{{link}}</0>.",
        "closedConversation": "Esta conversación está resuelta. Puedes reabrirla para seguir comunicándote con el contacto.",
        "whatsApp24HoursWindow": "WhatsApp solo permite respuestas de texto libre en las 24 horas siguientes al último mensaje del cliente. Para escribirle, <0>{{link}}</0>. Podrás responder libremente cuando vuelva a escribir.",
        "useApprovedMessage": "utiliza una plantilla de mensaje aprobada",
        "messagingWindowClosed": "Meta ya no acepta respuestas en esta conversación. Podrás responder cuando el cliente vuelva a escribir.",
        "activityNewestFirst": "Última actividad: Más reciente",
        "activityOldestFirst": "Última actividad: Más antigua",
        "createdAtNewestFirst": "Creación: Más reciente",
        "createdAtOldestFirst": "Creación: Más antigua",
        "backToAllConversations": "Volver a todas las conversaciones",
        "messageDeleted": "Eliminado",
        "conversationSelected_one": "{{count}} conversación seleccionada",
        "conversationSelected_other": "{{count}} conversaciones seleccionadas",
        "exportInProgress": "Exportación en curso. Espera nuestro correo",
        "editConversations": "Editar conversaciones",
        "selectProperty": "Seleccionar propiedad",
        "conversationAssignedOnPulse": "Esta conversación está asignada a Pulse. Únete para interactuar directamente con el cliente.",
        "replyTab": "Responder",
        "noteTab": "Nota",
        "notePlaceholder": "Añadir una nota interna…",
        "noteVisibilityHint": "Nunca visible para el cliente",
        "noteSnippet": "Nota: {{text}}",
        "collaborators": "Colaboradores",
        "addCollaborator": "Añadir",
        "tags": "Etiquetas",
        "addTag": "Añadir",
        "createNewTag": "Crear",
        "tagNamePlaceholder": "Nombre de la etiqueta",
        "deleteTagTitle": "¿Eliminar etiqueta?",
        "deleteTagDescription": "\"{{name}}\" se eliminará para toda la cuenta y se quitará de todas las conversaciones.",
        "editTagTitle": "Editar etiqueta",
        "tagColor": "Color",
        "keepMeAsCollaborator": "Mantenerme como colaborador",
        "collaborating": "Colaborando",
        "collaboratorReadOnly": "Sigues esta conversación como colaborador; usa notas internas para participar",
        "bulkEditPartial": "Se actualizaron {{updated}} de {{total}} conversaciones; las conversaciones de solo colaborador no cambian",
        "bulkEditUpdatedCount": "Se actualizaron {{updated}} de {{total}} conversaciones"
    },
    "SocialPosts": {
        "title": "Crea, personaliza y programa publicaciones en todas las plataformas",
        "subtitle": "Planifica, personaliza y programa publicaciones en redes sociales para cada localización y plataforma conectada, desde un solo lugar.",
        "editPost": "Editar publicación",
        "viewPost": "Detalles de publicación",
        "tableView": "Tabla",
        "calendarView": "Calendario",
        "moreCount": "+{{count}} más",
        "rescheduleSuccess": "Publicación reprogramada",
        "rescheduleFail": "No se pudo reprogramar la publicación",
        "book": "Reserva",
        "orderOnline": "Pedido en línea",
        "buy": "Comprar",
        "signUp": "Inscripción",
        "callNow": "Llamar ahora",
        "imageFormat": "Imágenes: Formato: JPG o PNG. Tamaño: 10KB - 10MB. Las imágenes más grandes se optimizan automáticamente.",
        "videoFormatDynamic": "Videos: Formato: MP4. Resolución: hasta {{maxResolution}}. Tamaño: hasta {{maxSize}}. Duración: de {{minDuration}} a {{maxDuration}}.",
        "videoConstrainedBy": "{{platform}} establece este límite.",
        "noMediaPreview": "Sube imágenes o un video para ver la vista previa aquí",
        "content": "Contenido",
        "contentDescription": "Empieza con una publicación común y ajusta el contenido, la multimedia y las opciones para cada plataforma.",
        "allPlatforms": "Todas las plataformas",
        "customizeFor": "Personalizar para {{platform}}",
        "media": "Multimedia",
        "customized": "Personalizado",
        "messageRequired": "Añade un mensaje",
        "tiktokAutoAddMusic": "Añadir música automáticamente",
        "tiktokAutoAddMusicHint": "TikTok añade un sonido recomendado a las publicaciones con imágenes. Puedes cambiarlo más tarde en la aplicación de TikTok.",
        "videoTooLongForCreator": "Más largo de lo que {{handle}} permite en TikTok (máx. {{limit}})",
        "tiktok": {
            "loadingCreatorInfo": "Cargando la configuración de la cuenta de TikTok…",
            "cannotPostNow": "TikTok no acepta publicaciones de {{handle}} en este momento. Inténtalo de nuevo más tarde.",
            "creatorInfoFailed": "No se pudo cargar la configuración de la cuenta de TikTok.",
            "retry": "Reintentar",
            "privacy": "Quién puede ver esta publicación",
            "privacyHint": "Las opciones provienen de las cuentas conectadas.",
            "privacyLevels": {
                "PUBLIC_TO_EVERYONE": "Todos",
                "MUTUAL_FOLLOW_FRIENDS": "Amigos",
                "FOLLOWER_OF_CREATOR": "Seguidores",
                "SELF_ONLY": "Solo yo"
            },
            "privacyNoCommonOption": "Estas cuentas de TikTok no comparten ninguna opción de privacidad. Quita {{handle}} o prográmala por separado.",
            "privacyNoCommonOptionAny": "Estas cuentas de TikTok no comparten ninguna opción de privacidad. Prográmalas por separado.",
            "privacyChooseAgain": "Elige quién puede ver esta publicación.",
            "interactions": "Permitir a los espectadores",
            "allowComment": "Comentar",
            "allowDuet": "Dúo",
            "allowStitch": "Stitch",
            "interactionDisabled": "Desactivado en la configuración de TikTok de {{handle}}",
            "interactionDisabledForSome": "{{handle}} lo tiene desactivado en TikTok, así que su publicación sale sin esta opción.",
            "commercial": "Declarar contenido comercial",
            "commercialHint": "Actívalo si esta publicación promociona tu negocio, una marca, un producto o un servicio.",
            "yourBrand": "Tu marca",
            "brandedContent": "Contenido de marca",
            "labelPromotional": "Tu {{media}} se etiquetará como 'Contenido promocional'",
            "labelPaidPartnership": "Tu {{media}} se etiquetará como 'Colaboración pagada'",
            "mediaWordVideo": "video",
            "mediaWordPhoto": "foto",
            "commercialIncomplete": "Debes indicar si tu contenido te promociona a ti, a un tercero o a ambos.",
            "brandedNotPrivate": "La visibilidad del contenido de marca no puede ser privada.",
            "consent": "Al publicar, aceptas la <musicLink>Music Usage Confirmation</musicLink> de TikTok",
            "consentBranded": "Al publicar, aceptas la <bcLink>Branded Content Policy</bcLink> y la <musicLink>Music Usage Confirmation</musicLink> de TikTok",
            "processingNote": "TikTok puede tardar unos minutos en mostrar una publicación en el perfil después de publicarla.",
            "publishingTooltip": "TikTok está procesando esta publicación. Puede tardar unos minutos en aparecer en el perfil.",
            "unauditedBanner": "Este entorno solo puede publicar publicaciones privadas en TikTok.",
            "noTikTokLocation": "Selecciona una localización con una cuenta de TikTok conectada.",
            "noCreators": "Ninguna de las localizaciones seleccionadas puede publicar en TikTok en este momento.",
            "reconnectAccount": "Vuelve a conectar {{handle}} en Ajustes, Integraciones antes de programar.",
            "thisAccount": "esta cuenta de TikTok",
            "chooseAccount": "Elige qué cuenta de TikTok publica para esta localización en el perfil de la localización."
        },
        "messageTooLong": "El mensaje supera el límite de {{count}} caracteres de esta plataforma",
        "mediaRequired": "Esta plataforma requiere al menos una imagen o un video",
        "videoTooLarge": "El video supera el límite de tamaño de {{limit}} para esta plataforma",
        "videoTooLong": "El video supera el límite de duración de {{limit}} para esta plataforma",
        "videoTooSmall": "El video está por debajo del tamaño mínimo de {{limit}} para esta plataforma",
        "videoTooLargeSummary": "Video demasiado grande para: {{platforms}}",
        "videoTooLongSummary": "Video demasiado largo para: {{platforms}}",
        "videoTooSmallSummary": "Video demasiado pequeño para: {{platforms}}",
        "checkingVideoLength": "Comprobando la duración del video…",
        "mediaRules": {
            "google": "Máximo una imagen. Video no compatible.",
            "facebook": "Máximo un video, o hasta 10 imágenes (sin mezclar).",
            "instagram": "Hasta 10 imágenes o videos. Multimedia obligatoria.",
            "tiktok": "Máximo un video, o hasta 35 imágenes (sin mezclar). Algunas cuentas de TikTok permiten videos más cortos de lo indicado.",
            "x": "Máximo un video, o hasta 4 imágenes (sin mezclar).",
            "facebookStory": "Exactamente una imagen o un video. Se recomienda 9:16.",
            "instagramStory": "Exactamente una imagen o un video. Se recomienda 9:16. Las imágenes se convierten a JPEG."
        },
        "retry": "Reintentar",
        "openPublishedPost": "Ver publicación",
        "storyMediaOnlyNotice": "Las historias solo publican multimedia — el texto no aparecerá en la historia.",
        "storyAspectWarning": "Este contenido no es 9:16 — {{platform}} lo recortará para ajustarlo.",
        "storyExpiry": "Ver historia (las historias caducan 24 horas después de publicarse)",
        "storyExpired": "Esta historia ha caducado — puede que el enlace ya no funcione",
        "queued": "En cola",
        "removedExternally": "Eliminado en la plataforma",
        "cancelPost": "Cancelar publicación",
        "cancelPostTitle": "¿Cancelar esta publicación?",
        "cancelPostDescription": "Esta publicación no se publicará.",
        "deletePostTitle": "¿Eliminar esta publicación?",
        "deletePostDescription": "Esto elimina la publicación publicada de la plataforma. Esta acción no se puede deshacer.",
        "preview": {
            "emptyHint": "Selecciona plataformas y localizaciones, luego añade un mensaje o contenido multimedia para previsualizar la publicación",
            "seeMore": "Ver más",
            "like": "Me gusta",
            "comment": "Comentar",
            "share": "Compartir",
            "more": "más",
            "likesPlaceholder": "Le gusta a tus seguidores",
            "tiktokSound": "Sonido original",
            "storyHint": "Vista previa 9:16 · solo multimedia"
        },
        "videoTooWide": "El video supera el máximo de {{width}}×{{height}} de esta plataforma",
        "videoTooWideSummary": "Resolución del video demasiado alta para: {{platforms}}"
    },
    "PostDynamicVariables": {
        "title": "Variables dinámicas"
    },
    "UpdateLocations": {
        "title": "Importar localizaciones",
        "subtitle": "Actualice o cree varias localizaciones a la vez utilizando un archivo CSV.",
        "list1Title": "Descargar plantilla",
        "list1Description": "Descargue la plantilla con sus localizaciones existentes",
        "list2Title": "Subir archivo",
        "list2Description": "Suba su archivo. Rellene el ID de localización para actualizar una existente, o déjelo vacío para crear una nueva.",
        "locationsToUpdate": "Localizaciones actualizadas",
        "locationsToAdd": "Localizaciones a añadir",
        "dataVerificationDescription": "Revise las localizaciones procesadas. Las filas «Nueva» crearán una nueva localización; las filas «Actualización» actualizarán una existente.",
        "showAddress": "Mostrar dirección",
        "featuredMessage": "Mensaje destacado",
        "featuredMessageUrl": "URL del mensaje destacado",
        "showHours": "Mostrar horarios",
        "importButton": "Importar {{amount}} localizaciónes",
        "quotaExceeded": "Añadir {{count}} nueva(s) localización(es) supera su límite de {{available}}."
    },
    "ImportValidationTable": {
        "showErrorsOnly": "Mostrar solo errores",
        "showErrorsOnlyCount": "Mostrar solo errores ({{count}} elemento(s))"
    },
    "BulkEditLocations": {
        "notUpdated": "{{count}} de {{total}} localizaciones no se actualizaron:",
        "title": "Editar localizaciones en masa",
        "subtitle": "Edite varias localizaciones a la vez. Los cambios se aplicarán a todas las localizaciones seleccionadas.",
        "applyToLocations": "Aplicar a {{count}} localización(es)",
        "services": "Servicios",
        "socialLinkPlatform": "Enlace social: {{platform}}"
    },
    "AIAssistant": {
        "translate": "Traducir",
        "english": "Inglés",
        "spanish": "Español",
        "portuguese": "Portugués",
        "french": "Francés",
        "german": "Alemán",
        "italian": "Italiano",
        "russian": "Ruso",
        "ukrainian": "Ucraniano",
        "polish": "Polaca",
        "changeTone": "Cambiar el tono",
        "professional": "Profesional",
        "friendly": "Amigable",
        "fixGrammar": "Corregir errores",
        "makeShoter": "Acortar",
        "makeLonger": "Alargar",
        "writeResponse": "Escribir la respuesta",
        "writeTemplate": "Escribir plantilla",
        "writePost": "Escribir post",
        "optimizeForPlatform": "Optimizar para {{platform}}",
        "writeCampaign": "Escribir campaña",
        "writeReply": "Escribir respuesta",
        "writeDescription": "Escribir descripción"
    },
    "industry": {
        "Automotive": "Automotriz",
        "BeautySpaAndSalon": "Belleza, Spa y Salón",
        "ClothingAndApparel": "Ropa y Accesorios",
        "Education": "Educación",
        "Entertainment": "Entretenimiento",
        "EventPlanningAndService": "Planificación y Servicio de Eventos",
        "FinanceAndBanking": "Finanzas y Banca",
        "FoodAndGrocery": "Alimentos y Abarrotes",
        "Pharmacy": "Farmacia",
        "PublicService": "Servicio Público",
        "HotelAndLodging": "Hotel y Alojamiento",
        "HealthcareAndDental": "Salud y Dental",
        "ProfessionalServices": "Servicios Profesionales",
        "ShoppingAndRetail": "Compras y Venta al por Menor",
        "TravelAndTransportation": "Viajes y Transporte",
        "Restaurant": "Restaurante",
        "Veterinary": "Veterinaria",
        "WellnessAndFitness": "Bienestar y Fitness",
        "Other": "Otras"
    },
    "themes": {
        "amenities": "Comodidades",
        "atmosphere": "Ambiente",
        "availability": "Disponibilidad",
        "billing": "Facturación",
        "check-in/out": "Check-in/out",
        "checkout": "Caja",
        "cleanliness": "Limpieza",
        "communication": "Comunicación",
        "delivery": "Entrega",
        "experience": "Experiencia",
        "expertise": "Pericia",
        "facilities": "Instalaciones",
        "food": "Comida",
        "location": "Ubicación",
        "menu": "Menú",
        "noise": "Ruido",
        "policies": "Políticas",
        "pricing": "Precios",
        "products": "Productos",
        "quality": "Calidad",
        "quality of care": "Calidad de atención",
        "results": "Resultados",
        "rooms": "Habitaciones",
        "scheduling": "Citas",
        "service": "Servicio",
        "staff": "Personal",
        "transparency": "Transparencia",
        "treatment": "Tratamiento",
        "value": "Relación calidad-precio",
        "wait time": "Tiempo de espera"
    },
    "ProfilesPage": {
        "title": "Potencie su SEO local",
        "titleGoogle": "Activa Google para sincronizar todos tus perfiles",
        "titleFreemium": "Pasa a visibilidad local completa",
        "subtitleFreemium": "Publica y mantén sincronizadas tus ubicaciones en Apple Maps, Bing, ChatGPT y más de 200 directorios y apps de navegación con Pluspoint Starter. Las fichas siempre actualizadas mejoran el SEO local y refuerzan la confianza de los asistentes de IA.",
        "subtitleGoogle": "Conecta tu cuenta de Google para mantener sincronizados los datos de tus perfiles, como ubicaciones, horarios, fotos y actualizaciones. Sin la integración con Google, parte de la información puede quedar incompleta o desactualizada.",
        "subtitle": "Publique y sincronice los perfiles de su negocio en más de 100 directorios, mapas y plataformas de búsqueda. Las fichas consistentes aumentan su visibilidad ante clientes, motores de búsqueda y asistentes de IA.",
        "profiles": "Perfiles",
        "profileInformation": "Información del perfil",
        "syncStatus": "Estado de la sincronización",
        "synced": "Sincronizado",
        "syncStarted": "Sincronización iniciada",
        "syncCompleted": "Sincronización completada",
        "lastSynced": "Última sincronización",
        "lastChecked": "Última verificación",
        "details": "Detalles",
        "detailsConflictIntegration_one": "{{count}} campo difiere entre Pluspoint y {{platform}}. Elige qué valores conservar para resolver el conflicto.",
        "detailsConflictIntegration_other": "{{count}} campos difieren entre Pluspoint y {{platform}}. Elige qué valores conservar para resolver el conflicto.",
        "detailsConflictScanner_one": "{{count}} campo difiere entre Pluspoint y {{platform}}. Publica para actualizar el perfil.",
        "detailsConflictScanner_other": "{{count}} campos difieren entre Pluspoint y {{platform}}. Publica para actualizar el perfil.",
        "detailsNotFound": "No aparece en {{platform}}. Publica para que tu negocio sea visible.",
        "detailsNotVerified": "El perfil de {{platform}} no está verificado. Verifícalo para gestionar este listado.",
        "detailsDisconnected": "{{platform}} está desconectado. Vuelve a conectarlo para reanudar la sincronización.",
        "detailsSynced": "Todos los campos clave coinciden con la fuente de Pluspoint.",
        "detailsSyncedWithConflicts_one": "El perfil está sincronizado, pero se ignora {{count}} campo.",
        "detailsSyncedWithConflicts_other": "El perfil está sincronizado, pero se ignoran {{count}} campos.",
        "detailsDisabled": "La sincronización está desactivada para este perfil.",
        "resolveTitle": "Resolver conflictos",
        "resolveSubtitle": "Resuelva los conflictos de perfil seleccionando la información correcta",
        "syncSuccessMessage": "Sincronización en proceso. Puede continuar utilizando el sistema.",
        "noAddress": "Sin dirección",
        "field": "Campo",
        "ignore": "Ignorar",
        "openProfile": "Abrir perfil",
        "usePlatformValue": "Usar el valor de {{source}}",
        "updatePlatformToMatch": "Actualizar {{target}} para que coincida con {{source}}",
        "noChangesWillBeMade": "No se realizarán cambios",
        "restrictedFieldHint": "{{source}} no permite actualizar este campo desde Pluspoint. Actualízalo directamente en {{source}} o usa el valor de {{source}}.",
        "noHoursToSendHint": "{{source}} no puede mostrar una página sin horario de apertura, así que no hay nada que enviar. Usa el valor de {{source}} o ignora este campo.",
        "noCoverToSendHint": "Esta ubicación no tiene foto de portada, así que no hay nada que enviar. Usa el valor de {{source}} o ignora este campo.",
        "descriptionContainsUrlHint": "Google no permite enlaces en la descripción del negocio. Elimina el enlace para sincronizarla.",
        "rejectedFieldHint": "{{source}} rechazó este valor ({{reasons}}). Corrígelo en Pluspoint y vuelve a resolver.",
        "socialLinkedElsewhere": "Este perfil social ya está conectado a otra localización. Para usarlo en tus localizaciones, compártelo desde la localización a la que está conectado.",
        "titleScanner": "Resumen de tu presencia en línea",
        "subtitleScanner": "Descubre dónde aparece tu negocio en los directorios. Publica para corregir imprecisiones y aparecer en todas las localizaciones.",
        "notPublished": "Perfil no encontrado",
        "publishAction": "Publicar",
        "upgradeToPublish": "Mejora tu plan para publicar tus fichas",
        "upgradeToPublishDescription": "Toma el control de la información de tu negocio en más de 100 directorios mejorando al plan Starter.",
        "upgradeToPublishAll": "Mejorar para publicar todas las fichas",
        "listingIssuesFound_one": "{{count}} problema en los listados requiere atención",
        "listingIssuesFound_other": "{{count}} problemas en los listados requieren atención",
        "listingIssuesDescription": "Los listados ausentes y los datos de contacto incorrectos perjudican su posicionamiento en búsquedas locales. Añada Directorios Locales a una localización para corregirlos y mantenerlos sincronizados automáticamente.",
        "detailsNotFoundScanner": "No aparece en {{platform}}: mejore el plan para publicar automáticamente"
    },
    "ProfilesMedia": {
        "exterior": "Exterior",
        "interior": "Interior",
        "product": "Producto",
        "atWork": "En el trabajo",
        "foodAndDrink": "Comida y bebidas",
        "menu": "Menú",
        "commonArea": "Áreas comunes",
        "rooms": "Salas",
        "teams": "Equipos",
        "authorName": "Autor",
        "profileName": "Perfil",
        "locationsNames": "Localizaciones",
        "categoryName": "Categoría",
        "viewCount": "Vistas",
        "createdAt": "Publicado el",
        "reportedAt": "Denunciado el",
        "viewContent": "Ver contenido",
        "uploadPhotos": "Subir fotos",
        "photosFormat": "Formato: JPG o PNG. Tamaño: 10KB - 5MB. Resolución mínima: 720 px de alto, 720 px de ancho."
    },
    "IntegrationRequired": {
        "title": "Integración requerida",
        "subtitleGoogle": "Para habilitar esta funcionalidad, conecte su cuenta de Pluspoint a Google My Business",
        "subtitleCommon": "Para habilitar esta funcionalidad, conecte su cuenta de Pluspoint a Google My Business o Facebook"
    },
    "KnowledgeBase": {
        "title": "Haz que Pulse sea más inteligente con tu conocimiento",
        "subtitle": "Añade tus artículos a su base de conocimientos para proporcionarle las respuestas que necesita. Desde preguntas frecuentes hasta guías detalladas, tu contenido ayuda a Pulse a ofrecer respuestas precisas y útiles a los clientes.",
        "editContent": "Editar contenido",
        "agents": "Agentes",
        "limitToLocations": "Limitar a localizaciones específicas",
        "items": "elementos de contenido",
        "itemsSelected": "{{count}} elementos de contenido seleccionados",
        "faq": "Preguntas frecuentes",
        "document": "Documento",
        "website": "Sitio web",
        "addFaq": "Añadir pregunta frecuente",
        "addDocument": "Añadir documento",
        "addWebsite": "Añadir sitio web",
        "dropFileOr": "Suelta un archivo aquí o",
        "browse": "selecciónalo",
        "acceptedFiles": "PDF, Word, Excel, CSV, PowerPoint, texto, Markdown o imagen. Hasta {{size}} {{metric}}; los PDF, hasta {{pages}} páginas, y las hojas, hasta {{rows}} filas.",
        "processing": "Procesando",
        "ready": "Listo",
        "failed": "Error",
        "processingFailed": "No se pudo procesar el archivo",
        "websitePlaceholder": "ayuda.ejemplo.com o ejemplo.com/ayuda",
        "invalidWebsite": "Introduce un dominio, con o sin ruta, como ayuda.ejemplo.com o ejemplo.com/ayuda",
        "documentsAtLimit": "Los documentos han alcanzado su límite",
        "websitesAtLimit": "Los sitios web han alcanzado su límite"
    },
    "Agents": {
        "title": "Adapta Pulse a tu negocio",
        "subtitle": "Configura Pulse para que se ajuste a las necesidades de tu empresa. Crea agentes de IA para distintos canales y ubicaciones, cada uno con un comportamiento personalizado, asegurando respuestas precisas en cada interacción con el cliente.",
        "editAgent": "Editar agente",
        "activateAgent": "Activar agente",
        "contactDetailsDescription": "Elige qué datos de contacto quieres que Pulse solicite a los clientes.",
        "autoCloseTitle": "Conversaciones abandonadas",
        "autoCloseDescription": "Elige cómo debe gestionar Pulse las conversaciones abandonadas después de un período específico de inactividad.",
        "timeOfClientInactivity": "Tiempo de inactividad del cliente antes de aplicar la acción:",
        "closeConversation": "Cerrar conversación",
        "changeToUnassigned": "Cambiar a No asignada",
        "doNothing": "No hacer nada",
        "conversationHandoff": "Derivación de conversación",
        "conversationHandoffDescription": "Decide cómo debe actuar Pulse cuando no pueda responder a una pregunta o cuando el cliente solicite hablar con un operador.",
        "conversationHandoffSwitch": "Cambiar a No asignada",
        "handoffResponseTime": "Tiempo de respuesta esperado",
        "fewMinutes": "Unos minutos",
        "withinHour": "En menos de una hora",
        "fewHours": "Algunas horas",
        "withinDay": "En menos de un día",
        "within2Days": "En un máximo de 2 días",
        "notTransferConversationSwitch": "No transferir la conversación",
        "channelTakenByAgent": "El canal ya está asignado a otro agente",
        "customInstructions": "Instrucciones personalizadas",
        "customInstructionsDescription": "Agregue instrucciones personalizadas que el Agente de IA de Pulse debe seguir al interactuar con los clientes.",
        "playgroundAssignContent": "Asigna contenido de la base de conocimientos a este agente para empezar a probarlo en el playground.",
        "playgroundSaveAgentFirst": "Guarda el agente y asígnale contenido de la base de conocimientos para empezar a probarlo en el playground."
    },
    "InitConversation": {
        "recipient": "Destinatario",
        "newConversation": "Nueva conversación",
        "viewConversation": "Ver conversación",
        "conversationExistsTitle": "Conversación abierta encontrada",
        "conversationExistsDescription": "Tienes una conversación abierta con este contacto a través de la misma localización y canal. ¿Qué quieres hacer?",
        "resolveConversation": "Resolver conversación",
        "goToConversation": "Ir a la conversación"
    },
    "CouponsPage": {
        "title": "Cupones inteligentes para fomentar la fidelidad y las ventas",
        "subtitle": "Crea y comparte ofertas especiales para premiar a clientes satisfechos, resolver incidencias o aumentar las ventas. Personaliza descuentos, artículos gratuitos y reglas de canje en diferentes ubicaciones.",
        "createNewCoupon": "Crear nuevo cupón",
        "createCoupon": "Crear cupón",
        "viewCoupon": "Ver cupón",
        "editCoupon": "Editar cupón",
        "activateCoupon": "Activar cupón",
        "offerType": "Tipo de oferta",
        "percentageOff": "Porcentaje de descuento",
        "amountOff": "Descuento en importe",
        "freeItem": "Artículo gratuito",
        "minimumOrderValue": "Pedido mínimo",
        "offerSchedule": "Calendario de la oferta",
        "offerAndDate": "Fecha de finalización de la oferta",
        "setFinalIssueDate": "Establece el último día en que se puede usar este cupón.",
        "redemptionPeriod": "Periodo de canje",
        "periodOfValidity": "Cuántos días permanece válido el cupón después de su emisión.",
        "redemptionPeriodDays": "Periodo de canje (días)",
        "waitPeriod": "Periodo de espera",
        "setDelay": "Establece el tiempo de espera antes de poder canjear el cupón.",
        "waitPeriodHours": "Periodo de espera (horas)",
        "activationPinCode": "Código PIN de activación",
        "requireStaffForPin": "Requiere que el personal introduzca un PIN para confirmar el canje",
        "redeemed": "Canjeado {{title}}",
        "defaultMessage": "Mensaje por defecto",
        "issuedCount": "Emitidos",
        "redeemedCount": "Canjeados"
    },
    "paymentMethod": {
        "cash": "Efectivo",
        "visa": "Visa",
        "mastercard": "Mastercard",
        "applePay": "Apple Pay",
        "androidPay": "Android Pay",
        "paypal": "PayPal",
        "americanExpress": "American Express",
        "discover": "Discover",
        "invoice": "Factura",
        "bitcoin": "Bitcoin",
        "travelersCheck": "Traveler's Check",
        "dinersClub": "Diners Club",
        "insurance": "Seguro"
    },
    "Paywall": {
        "whatYouGet": "Qué incluye:",
        "unlockThis": "Desbloquea esto y mucho más con Pluspoint Professional.",
        "titleCoupons": "Cupones que fidelizan y hacen que los clientes regresen",
        "subtitleCoupons": "Premia a tus clientes y dales un motivo para volver. Utiliza cupones para recuperar clientes insatisfechos, incentivar las reseñas y convertir la interacción en ventas reales.",
        "proposal1Coupons": "Tipos de cupones flexibles, como artículos gratis y descuentos porcentuales o de importe fijo",
        "proposal2Coupons": "Analítica integrada para medir canjes, rendimiento y ROI",
        "proposal3Coupons": "Cupones interactivos y optimizados para móvil, diseñados para un uso rápido y una alta conversión",
        "proposal4Coupons": "No requiere integración con el TPV, fácil de activar y sencillo de gestionar",
        "titleCampaigns": "Campañas que impulsan la recurrencia",
        "subtitleCampaigns": "Llega a los clientes adecuados en el momento preciso con campañas segmentadas en los canales que realmente utilizan. Automatiza mensajes recurrentes, lanza promociones puntuales y deja que la IA gestione las respuestas para mantener la conversación activa.",
        "proposal1Campaigns": "Campañas automatizadas y puntuales alineadas con tus objetivos",
        "proposal2Campaigns": "Segmentación inteligente basada en datos y comportamiento del cliente",
        "proposal3Campaigns": "Comunicación multicanal por SMS, email y WhatsApp",
        "proposal4Campaigns": "Gestión de respuestas y conversaciones impulsada por IA",
        "titleSurveys": "Encuestas que convierten el feedback en crecimiento",
        "subtitleSurveys": "Haz que la opinión de tus clientes forme parte de tu día a día. Automatiza la recogida de feedback, anticipa y resuelve incidencias a tiempo, y genera más reseñas a partir de quienes tuvieron una experiencia positiva.",
        "proposal1Surveys": "Encuestas automatizadas enviadas por mensajes, email, WhatsApp y códigos QR",
        "proposal2Surveys": "Detección temprana y resolución de incidencias y quejas",
        "proposal3Surveys": "Generación de reseñas desde clientes satisfechos",
        "proposal4Surveys": "Seguimiento del Net Promoter Score para medir la fidelidad y su evolución en el tiempo",
        "titleAutoReplies": "Respuestas automáticas en las que puedes confiar",
        "subtitleAutoReplies": "Responde a todas las reseñas de forma rápida y coherente, sin perder naturalidad. La IA se encarga de redactar respuestas humanas y bien contextualizadas, mientras tú mantienes el control del tono, las reglas y los casos especiales.",
        "proposal1AutoReplies": "Respuestas generadas por IA con un tono cercano y personalizado",
        "proposal2AutoReplies": "Lógica inteligente según la valoración y si la reseña incluye comentario",
        "proposal3AutoReplies": "Prompts de IA personalizables para adaptarse a la voz y las políticas de tu marca",
        "proposal4AutoReplies": "Plantillas reutilizables para asegurar coherencia y control",
        "upgradeForCustomerRating": "Mejora tu plan para recopilar valoraciones de clientes",
        "upgradeForCustomerRatingDescription": "Dirige a los clientes satisfechos a dejar una reseña y a los insatisfechos a comentarios privados.",
        "upgradeForCustomQuestions": "Mejora tu plan para añadir preguntas personalizadas",
        "upgradeForCustomQuestionsDescription": "Añade preguntas de valoración, opción múltiple y abiertas a tus encuestas.",
        "upgradeForSendSurveys": "Mejora tu plan para enviar encuestas",
        "upgradeForSendSurveysDescription": "Envía encuestas a tus contactos por email o SMS, con seguimientos y recordatorios."
    },
    "GoogleVerification": {
        "title": "Verificar perfil de Google Business",
        "verifyOnGoogle": "Verificar en Google Business",
        "selectMethod": "Selecciona el método de verificación",
        "PHONE_CALL": "Llamada telefónica",
        "SMS": "SMS",
        "EMAIL": "Correo electrónico",
        "ADDRESS": "Postal (correo)",
        "VETTED_PARTNER": "Verificación a través de un partner de Google",
        "AUTO": "Verificación automática",
        "pinSent": "Google te envió un código de verificación.",
        "pinSentTo": "Se envió un código de verificación a",
        "pinPlaceholder": "Código de verificación",
        "postcardMailed": "Google envió una postal a la dirección de tu negocio.",
        "postcardMailedOn": "Google envió una postal a la dirección de tu negocio el {{date}}.",
        "postcardArrives": "Debería llegar en unos {{days}} días.",
        "postcardComeBack": "Vuelve e introduce el código cuando llegue.",
        "postcardTo": "La postal se envía a",
        "checkInProgress": "Google está revisando este perfil. El perfil se actualiza cuando termine.",
        "lastAttemptFailed": "Tu último intento ({{method}}) no se completó.",
        "lastAttemptFailedOn": "Tu último intento ({{method}}), solicitado el {{date}}, no se completó.",
        "pinSentOn": "Se envió un código de verificación el {{date}}.",
        "pendingStillOpen": "Una verificación por {{method}} sigue abierta. Elegir otro método inicia una nueva.",
        "pendingStillOpenOn": "Una verificación por {{method}} solicitada el {{date}} sigue abierta. Elegir otro método inicia una nueva.",
        "latestLookupFailed": "No pudimos comprobar si ya hay una verificación en curso, así que iniciar una podría duplicarla.",
        "verificationComplete": "Perfil verificado. La ficha se actualiza en un momento.",
        "verificationFailed": "Esa verificación no se completó. Inténtalo de nuevo o elige otro método.",
        "mailboxName": "Nombre del buzón",
        "resendPostcard": "Enviar una nueva postal",
        "useAnotherMethod": "Usar otro método"
    },
    "exports": {
        "exporting": "Exportando datos...",
        "ready": "Exportación lista",
        "failed": "Error en la exportación"
    },
    "importLoading": {
        "connectingGoogle": "Conectando con tu cuenta de Google...",
        "fetchingDetails": "Obteniendo detalles de localizaciones...",
        "settingUp": "Configurando tus localizaciones...",
        "almostDone": "Casi listo, un momento...",
        "progress": "Importadas {{current}} de {{total}} localizaciones"
    },
    "MenusPage": {
        "title": "Todos los menús de sus localizaciones en un solo lugar",
        "subtitle": "Cree y actualice sus menús en un solo lugar y publíquelos en sus micrositios y en su Perfil de Empresa de Google. Mantenga platos, precios y fotos al día en todas sus localizaciones.",
        "createMenu": "Crear menú",
        "importWithAi": "Importar con IA",
        "importButton": "Importar",
        "importModalDescription": "Sube tu menú existente — un PDF, fotos, una hoja de cálculo o un documento — y la IA lo convertirá en un borrador de menú que podrás revisar y editar.",
        "importDropFiles": "Arrastra los archivos aquí o haz clic para buscar",
        "importTooManyFiles": "Puedes subir hasta {{count}} archivos",
        "importReadingFiles": "Leyendo tus archivos...",
        "importExtractingItems": "Extrayendo secciones y platos...",
        "importFetchingImages": "Importando fotos de los platos...",
        "importAlmostDone": "Casi listo, un momento...",
        "editMenu": "Editar menú",
        "modalTitle": "Menú",
        "builder": "Constructor de menús",
        "internalName": "Nombre interno",
        "internalNameHint": "Solo visible para su equipo",
        "cuisines": "Cocinas",
        "locations": "Localizaciones",
        "menuLocalization": "Nombre y descripción del menú",
        "duplicate": "Duplicar",
        "sections": "Secciones",
        "addSection": "Añadir sección",
        "itemsCount": "platos",
        "items": "Platos",
        "publishedOnGoogle": "Publicado en Google",
        "untitledSection": "Sección sin título",
        "addItem": "Añadir plato",
        "item": "Plato",
        "untitledItem": "Plato sin título",
        "itemName": "Nombre del plato",
        "itemPhoto": "Foto del plato",
        "itemPhotoFormat": "Formato: JPG o PNG. Tamaño: hasta 10MB.",
        "price": "Precio",
        "additionalAttributes": "Atributos adicionales",
        "addItemOptions": "Añadir opciones al plato",
        "option": "Opción",
        "untitledMenu": "Menú",
        "previewEmpty": "Añada secciones y platos para ver la vista previa del menú.",
        "spiciness": "Picante",
        "allergens": "Alérgenos",
        "dietaryRestrictions": "Restricciones dietéticas",
        "preparationMethods": "Métodos de preparación",
        "ingredients": "Ingredientes",
        "portionQuantity": "Cantidad de la porción",
        "portionUnit": "Unidad de la porción (p. ej. piezas, oz)",
        "servesNumPeople": "Raciones (número de personas)",
        "calories": "Calorías",
        "nutrition": {
            "totalFat": "Grasas totales",
            "cholesterol": "Colesterol",
            "sodium": "Sodio",
            "totalCarbohydrate": "Carbohidratos totales",
            "protein": "Proteínas"
        },
        "units": {
            "GRAM": "g",
            "MILLIGRAM": "mg"
        },
        "cuisineValues": {
            "AMERICAN": "Americana",
            "ASIAN": "Asiática",
            "BRAZILIAN": "Brasileña",
            "BREAK_FAST": "Desayuno",
            "BRUNCH": "Brunch",
            "CHICKEN": "Pollo",
            "CHINESE": "China",
            "FAMILY": "Familiar",
            "FAST_FOOD": "Comida rápida",
            "FRENCH": "Francesa",
            "GREEK": "Griega",
            "GERMAN": "Alemana",
            "HAMBURGER": "Hamburguesa",
            "INDIAN": "India",
            "INDONESIAN": "Indonesia",
            "ITALIAN": "Italiana",
            "JAPANESE": "Japonesa",
            "KOREAN": "Coreana",
            "LATIN_AMERICAN": "Latinoamericana",
            "MEDITERRANEAN": "Mediterránea",
            "MEXICAN": "Mexicana",
            "PAKISTANI": "Pakistaní",
            "PIZZA": "Pizza",
            "SEAFOOD": "Mariscos",
            "SPANISH": "Española",
            "SUSHI": "Sushi",
            "THAI": "Tailandesa",
            "TURKISH": "Turca",
            "VEGETARIAN": "Vegetariana",
            "VIETNAMESE": "Vietnamita",
            "OTHER_CUISINE": "Otra"
        },
        "spicinessValues": {
            "MILD": "Suave",
            "MEDIUM": "Medio",
            "HOT": "Picante"
        },
        "allergenValues": {
            "DAIRY": "Lácteos",
            "EGG": "Huevo",
            "FISH": "Pescado",
            "PEANUT": "Cacahuete",
            "SHELLFISH": "Mariscos",
            "SOY": "Soja",
            "TREE_NUT": "Frutos secos",
            "WHEAT": "Trigo"
        },
        "dietaryValues": {
            "HALAL": "Halal",
            "KOSHER": "Kosher",
            "ORGANIC": "Orgánico",
            "VEGAN": "Vegano",
            "VEGETARIAN": "Vegetariano"
        },
        "preparationValues": {
            "BAKED": "Horneado",
            "BARBECUED": "A la barbacoa",
            "BASTED": "Bañado",
            "BLANCHED": "Escaldado",
            "BOILED": "Hervido",
            "BRAISED": "Estofado",
            "CODDLED": "Cocido a baja temperatura",
            "FERMENTED": "Fermentado",
            "FRIED": "Frito",
            "GRILLED": "A la parrilla",
            "KNEADED": "Amasado",
            "MARINATED": "Marinado",
            "PAN_FRIED": "Frito en sartén",
            "PICKLED": "Encurtido",
            "PRESSURE_COOKED": "Cocinado a presión",
            "ROASTED": "Asado",
            "SAUTEED": "Salteado",
            "SEARED": "Sellado",
            "SIMMERED": "Cocido a fuego lento",
            "SMOKED": "Ahumado",
            "STEAMED": "Al vapor",
            "STEEPED": "Infusionado",
            "STIR_FRIED": "Salteado al wok",
            "OTHER_METHOD": "Otro"
        },
        "issuesTitle": "Complete lo siguiente para guardar el menú:",
        "issueInternalName": "Añada un nombre interno",
        "issueName": "Añada un título",
        "issueNameLength": "El título no debe superar los 140 caracteres",
        "issueDescriptionLength": "La descripción no debe superar los 1000 caracteres",
        "issueIngredientsLength": "Cada lista de ingredientes no debe superar los 5000 caracteres",
        "issueCurrency": "Seleccione una moneda",
        "issueLocations": "Asigne al menos una localización",
        "issueSections": "Añada al menos una sección",
        "issueSectionNames": "Nombre todas las secciones",
        "issueSectionItems": "Cada sección necesita al menos un plato",
        "issueItemNames": "Nombre todos los platos",
        "issueItemPrices": "Establezca un precio para cada plato",
        "issueOptionNames": "Nombre todas las opciones",
        "showOnGoogle": "Mostrar en Google Business Profile",
        "showOnGoogleHint": "Mientras esté activado, este menú está publicado en Google Business Profile para las localizaciones de restaurante conectadas. Al desactivarlo, el menú se elimina de Google.",
        "google": "Google",
        "titleOptional": "Título (opcional)",
        "noItems": "Aún no hay platos en esta sección",
        "editSection": "Editar sección"
    },
    "SubscribeLock": {
        "freemiumRetiredTitle": "El plan gratuito se ha retirado",
        "freemiumRetiredSubtitle": "Sus reseñas, contactos y conversaciones están a salvo: suscríbase para continuar donde lo dejó.",
        "trialEndedTitle": "Su prueba gratuita ha terminado",
        "trialEndedSubtitle": "Conserve todo lo que configuró durante la prueba: suscríbase para continuar.",
        "askAccountOwner": "¿No es administrador? Pida al propietario de la cuenta que mejore el plan.",
        "directoriesIntentTitle": "Suscríbase para añadir Directorios Locales",
        "directoriesIntentSubtitle": "Directorios Locales requiere una suscripción activa: suscríbase y añada {{location}} en un solo paso."
    },
    "TemplateLibrary": {
        "title": "Biblioteca de plantillas",
        "subtitle": "Diseños listos para tus campañas. Crea una plantilla de email o WhatsApp una vez, mantenla fiel a tu marca y reutilízala cada vez que lances una campaña.",
        "filterChannelType": "Tipo de canal",
        "filterBrands": "Marcas",
        "tabSettings": "Ajustes",
        "tabContent": "Contenido",
        "tabPreview": "Vista previa",
        "backToBlocks": "Volver a los bloques",
        "paletteHint": "Haz clic en un bloque o arrástralo a tu email",
        "dropHint": "Arrastra un bloque aquí",
        "emptyState": "Aún no hay plantillas. Crea tu primera plantilla para empezar.",
        "channelEmail": "Email",
        "systemTemplate": "Ejemplo",
        "archived": "Archivada",
        "usedByCampaigns": "{{count}} campaña o automatización",
        "usedByCampaigns_plural": "{{count}} campañas o automatizaciones",
        "duplicate": "Duplicar",
        "archive": "Archivar",
        "unarchive": "Desarchivar",
        "duplicated": "Plantilla duplicada",
        "deleteDescription": "¿Eliminar la plantilla \"{{name}}\"? Esta acción no se puede deshacer.",
        "deleteBlocked": "Esta plantilla se usa en campañas o automatizaciones y no se puede eliminar. Archívala en su lugar.",
        "createTemplateTitle": "Nueva plantilla de email",
        "editTemplateTitle": "Editar plantilla de email",
        "viewTemplateTitle": "Plantilla de email",
        "saveTemplate": "Guardar plantilla",
        "sendTest": "Enviar prueba",
        "sendTestHint": "Envíate una prueba para ver exactamente lo que recibirán tus contactos.",
        "templateName": "Nombre de la plantilla",
        "preheader": "Preencabezado",
        "deviceDesktop": "Escritorio",
        "deviceMobile": "Móvil",
        "emailChannel": "Canal de email",
        "testSendSuccess": "Email de prueba enviado",
        "testSendFail": "No se pudo enviar el email de prueba",
        "loadingPreview": "Generando vista previa…",
        "blocks": "Bloques",
        "textColor": "Color del texto",
        "buttonColor": "Color del botón",
        "buttonShape": "Forma del botón",
        "shape_square": "Cuadrado",
        "shape_rounded": "Redondeado",
        "shape_pill": "Píldora",
        "blockLogo": "Logo",
        "blockImage": "Imagen",
        "blockHeading": "Título",
        "blockText": "Texto",
        "blockButton": "Botón",
        "blockDivider": "Separador",
        "blockSpacer": "Espaciador",
        "blockColumns": "Columnas",
        "columnsHint": "Arrastra bloques de la paleta a cualquiera de las columnas, o haz clic en un elemento dentro de una columna para editarlo.",
        "cornerRadius": "Radio de esquinas",
        "blockSocial": "Redes sociales",
        "logoPlaceholder": "Logotipo",
        "imagePlaceholder": "Selecciona el bloque para subir una imagen",
        "headingPlaceholder": "Título",
        "textPlaceholder": "Escribe tu texto…",
        "buttonPlaceholder": "Botón",
        "socialPlaceholder": "Redes sociales — del perfil de la localización",
        "headingText": "Texto del título",
        "textContent": "Texto",
        "imageAlt": "Texto alternativo",
        "buttonLabel": "Nombre del botón",
        "buttonDestination": "Destino",
        "bindingUrl": "URL personalizada",
        "bindingSurvey": "Enlace de encuesta",
        "bindingCoupon": "Enlace de cupón",
        "spacerHeight": "Altura (px)",
        "logoHint": "El logo se resuelve desde la marca o la localización al enviar el email.",
        "socialHint": "Los enlaces de Facebook e Instagram provienen del perfil de la localización.",
        "padding": "Relleno",
        "headingLevel": "Nivel de título",
        "fontSize": "Tamaño del texto",
        "buttonSize": "Tamaño del botón",
        "buttonWidth": "Ancho del botón",
        "widthFull": "Ancho completo",
        "widthAuto": "Ajustar al contenido",
        "imageWidth": "Ancho de la imagen",
        "lineColor": "Color de la línea",
        "thickness": "Grosor",
        "footerPreviewInfo": "Nombre de la empresa · Dirección",
        "footerPreviewLinks": "Darse de baja · Política de privacidad",
        "footerLockedTooltip": "Se añade automáticamente a cada email con los datos reales de tu negocio",
        "alignment": "Alineación",
        "alignLeft": "Izquierda",
        "alignCenter": "Centro",
        "alignRight": "Derecha",
        "emailDesign": "Diseño del email",
        "createNew": "Crear nueva",
        "surveyLinkHint": "La campaña que use esta plantilla lo rellenará con el enlace de la encuesta.",
        "couponLinkHint": "La campaña que use esta plantilla lo rellenará con el enlace del cupón.",
        "noBrand": "Sin marca",
        "dynamicLinkRequired": "Las campañas de encuesta y cupón necesitan una plantilla con un botón de enlace dinámico.",
        "dynamicLinkNotSupported": "Las plantillas con botón de enlace dinámico solo pueden usarse en campañas de encuesta o cupón.",
        "channelWhatsApp": "WhatsApp",
        "newEmailTemplate": "Crear plantilla de email",
        "newWhatsAppTemplate": "Crear plantilla de WhatsApp",
        "waChannelRequired": "Conecta un canal de WhatsApp Business para crear plantillas de WhatsApp.",
        "waStatus_draft": "Borrador",
        "waStatus_pending": "En revisión",
        "waStatus_approved": "Aprobada",
        "waStatus_rejected": "Rechazada",
        "waStatus_paused": "Pausada",
        "waStatus_disabled": "Deshabilitada",
        "waNeedsSetup": "Requiere configuración",
        "waDisconnected": "Desconectada",
        "waEditResubmit": "Editar y reenviar",
        "waCategory": "Categoría",
        "waCategory_MARKETING": "Marketing",
        "waCategory_UTILITY": "Utilidad",
        "waWaba": "Cuenta de WhatsApp Business",
        "waWabaRequired": "Selecciona la cuenta de WhatsApp Business para esta plantilla.",
        "waNameHint": "Minúsculas, dígitos y guiones bajos",
        "waEmptyPreview": "La vista previa de tu mensaje aparecerá aquí",
        "waNameInvalid": "Usa solo minúsculas, dígitos y guiones bajos.",
        "waHeader": "Encabezado",
        "waHeaderNone": "Ninguno",
        "waHeaderText": "Texto",
        "waHeaderImage": "Imagen",
        "waHeaderTextLabel": "Texto del encabezado",
        "waHeaderOneVariable": "Un encabezado de texto permite como máximo una variable.",
        "waHeaderImageRequired": "Sube una imagen de encabezado o cambia el encabezado a ninguno.",
        "waBody": "Cuerpo",
        "waBodyEdgeVariable": "El cuerpo del mensaje no puede empezar ni terminar con una variable.",
        "waBodyMixedVariables": "No mezcles variables con nombre y numeradas en una misma plantilla.",
        "waFooter": "Pie",
        "waFooterLabel": "Texto del pie (opcional)",
        "waButtons": "Botones",
        "waAddButton": "Añadir botón",
        "waButtonQuickReply": "Respuesta rápida",
        "waButtonUrl": "URL",
        "waButtonPhone": "Teléfono",
        "waButtonWebsite": "Visitar el sitio web",
        "waButtonSurvey": "Enlace de encuesta",
        "waButtonCoupon": "Enlace de cupón",
        "waUrlAbsolute": "Las URL de los botones deben empezar por http:// o https://.",
        "waLinkTypeCouponOnly": "El botón de enlace de esta plantilla apunta a enlaces de cupones, por lo que solo sirve para campañas de cupones.",
        "waLinkTypeSurveyOnly": "El botón de enlace de esta plantilla apunta a enlaces de encuestas, por lo que no sirve para campañas de cupones.",
        "waQuickRepliesGrouped": "Los botones de respuesta rápida deben ir agrupados.",
        "waButtonsIncomplete": "Completa la etiqueta y el destino de cada botón.",
        "waVariables": "Variables",
        "waResolution": "Se rellena con",
        "waGroupContact": "Contacto",
        "waGroupLocation": "Localización",
        "waMappingRequired": "Elige cómo se rellena cada variable.",
        "waViewTemplateTitle": "Plantilla de WhatsApp",
        "waEditTemplateTitle": "Editar plantilla de WhatsApp",
        "waCreateTemplateTitle": "Nueva plantilla de WhatsApp",
        "waSaveDraft": "Guardar borrador",
        "waSubmitForReview": "Enviar a revisión",
        "waSubmitted": "Plantilla enviada a revisión",
        "waReviewNote": "Meta revisa las plantillas tras el envío — normalmente en unas horas, hasta 24 h.",
        "waPendingBanner": "Meta está revisando esta plantilla; es de solo lectura hasta que termine la revisión.",
        "waDisabledBanner": "Meta deshabilitó esta plantilla. No se puede editar ni usar en campañas.",
        "waRejectedBanner": "Meta rechazó esta plantilla. Corrige el contenido y reenvíala.",
        "waResubmitBanner": "Al guardar, la plantilla se envía de nuevo a revisión de Meta.",
        "noLinkButton": "Esta plantilla no tiene botón de enlace dinámico, así que no puede entregar un enlace de encuesta o cupón.",
        "linkButtonNotSupported": "Esta plantilla tiene un botón de enlace dinámico, por lo que solo puede usarse en campañas de encuestas o cupones.",
        "waLockedByCampaigns": "Esta plantilla se usa en campañas programadas o en curso, o en automatizaciones activas. Duplícala para editarla, o elimina esas referencias primero.",
        "waMalformedVariable": "Variable mal formada: usa {{nombre_en_minusculas}} con letras, dígitos y guiones bajos.",
        "waUnknownVariable": "Variable desconocida: usa uno de los campos disponibles.",
        "waFromContact": "del contacto",
        "waFromLocation": "de la localización",
        "waLinkSlotInfo": "El botón de URL se rellena con el enlace de la encuesta o el cupón."
    },
    "ImpersonationBanner": {
        "impersonatedBy": "Acceso realizado por {{name}} de Pluspoint",
        "impersonatedByPartner": "Acceso realizado por {{name}}",
        "minutesLeft": "{{count}} min restantes",
        "exit": "Salir"
    }
}
